import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, ElementRef, Component, OnInit, ViewChild, Renderer2, QueryList, ViewChildren, HostListener } from "@angular/core";
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { Observable, OperatorFunction, catchError, debounceTime, distinctUntilChanged, finalize, forkJoin, lastValueFrom, map, of, pairwise, startWith } from "rxjs";
import { ActivatedRoute, Router } from "@angular/router";
import { CompanyService } from "src/app/services/company.service";
import { CustomerService } from "src/app/services/customer.service";
import { AWBService } from "src/app/services/operations/awb.service";
import Swal from "sweetalert2";
import { ProductService } from 'src/app/services/products.service';
import { VendorService } from 'src/app/services/vendor.service';
import { PickupService } from "src/app/services/operations/pickup.service";
import { ChargesService } from "src/app/services/system-config/charges/charges.service";
import { AddressBookService } from "src/app/services/general/addressbook.service";
import { NgbModal, NgbModalOptions, NgbNav, NgbTypeaheadConfig } from "@ng-bootstrap/ng-bootstrap";
import { MiscService } from "src/app/services/misc/misc.service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { ToastrService } from "ngx-toastr";
import { UserManagementService } from "src/app/services/user-management.service";
import { FileHandlerService } from "src/app/services/file-handler.service";
import { HttpHeaders } from "@angular/common/http";
import { AppCoreService } from "src/app/services/app-core.service";
import { AmountValidation, EmailValidation, MobileNumberValidation, regexPattern, AlphaNumericValidation, FileSize, TelephoneNumberValidation, nonZeroValidator } from "src/app/models/validator";
import { RateUploadService } from "src/app/services/operations/rateupload.service";
import { ExcelService } from "src/app/services/excel.service";
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from "ag-grid-community";
import { DatePipe } from "@angular/common";
import { Utilities } from "src/app/models/utilities";
import { saveAs } from 'file-saver-es';
import { NetworkService } from "src/app/services/network.service";
import { ConfigService } from "src/app/services/system-config/configs/configs.service";
import { CreditControlService } from "src/app/services/system-config/credit-control/creditcontrol";
import { IAWBPiecesDB } from "src/app/models/awb";
import printJS from 'print-js-updated';
import { Title } from "@angular/platform-browser";
import { UserData } from "src/app/models/user.data-object";
import { GeoService } from "src/app/services/geo.service";
import { LabelPrintComponent } from "../label-print/label-print.component";
import { compareRatesComponent } from "../compare-rates/compare-rates.component";
import { AwbChargesListComponent } from "../awb-charges/charge.component";
import { NgSelectComponent } from "@ng-select/ng-select";
import { AddressComponent } from "src/app/components/shared/address/address.component";

enum ChargeType {
  AWB = "Customer",
  PURCHASE = "Vendor"
}

enum RateCategory {
  CUSTOMER = "Customer",
  VENDOR = "Vendor"
}

enum MeasurementUnit {
  CENTIMETER = 5000,
  INCHES = 2000
}

@Component({
  selector: 'app-awb',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})

export class AddAwbComponent implements OnInit, AfterViewChecked, AfterViewInit {
  @ViewChild('focusModeCheckBox') focusModeCheckBox!: ElementRef;
  @ViewChild('submitBtn') submitBtn!: ElementRef;
  @ViewChild('pieceAddBtn') pieceAddBtn!: ElementRef;

  @ViewChild('measurementUnit') measurementUnit!: ElementRef;
  @ViewChild('csbtype') csbtype: ElementRef;
  @ViewChild('buyerName') buyerName: ElementRef;
  @ViewChild('deliveryawb') deliveryawb!: ElementRef;
  @ViewChild('fieldExecutive') fieldExecutive!: ElementRef;
  @ViewChild('kycDocumentType') kycDocumentType!: ElementRef;
  @ViewChild('amountReceived') amountReceived!: ElementRef;
  @ViewChild('btnfuelradio1') btnfuelradio1!: ElementRef;
  @ViewChild('lutigst') lutigst!: ElementRef;
  @ViewChild('kycSaveBtn') kycSaveBtn!: ElementRef;
  @ViewChild('appSharedCustomercharge', { static: false }) appSharedCustomercharge!: AwbChargesListComponent;
  @ViewChild('appSharedVendorcharge', { static: false }) appSharedVendorcharge!: AwbChargesListComponent;

  @ViewChild('appShipperAddress') appShipperAddress!: AddressComponent;
  @ViewChild('appConsigneeAddress') appConsigneeAddress!: AddressComponent;

  @ViewChildren('piecesActualWeight') piecesActualWeightInputs!: QueryList<ElementRef>;
  @ViewChildren('tabItems') tabElements!: QueryList<ElementRef>;
  @ViewChild('justifiednav') justifiednav: NgbNav;
  @ViewChildren('descriptionRef') descriptionRefs: QueryList<ElementRef>;
  @ViewChildren('weightRef') weightRef: QueryList<ElementRef>;
  @ViewChildren('importPiecesFileUploaderRef') importPiecesFileUploaderRef: ElementRef;

  @ViewChildren(
    'referenceNo, awbNo, customer, company, bookDateTime, paymentType, product, vendor, service, ' +
    'ChargeTypes, shipmentValue, currency, appShipperAddress, shipperiecioeno, appConsigneeAddress, consigneeiecioeno, piecesActualWeightInputs'
  ) fields!: QueryList<any>;

  focusTabField(fieldName: ElementRef | NgSelectComponent | AwbChargesListComponent) {
    setTimeout(() => {
      if (fieldName instanceof ElementRef) {
        fieldName.nativeElement.focus();
      } else if (fieldName instanceof NgSelectComponent) {
        fieldName.focus();
      } else if (fieldName instanceof AwbChargesListComponent) {
        this.appSharedCustomercharge.focusFirstField();
      }
    });
  }
  focusCheckHide = true;
  awbFocusCheckMap: any = [];
  awbAddressFocusCheckMap: any = [];

  awbForm: FormGroup;
  proformaForm: FormGroup;
  chargeForm: FormGroup;
  receiptForm: FormGroup;
  kycForm: FormGroup;
  piecesForm: FormGroup;
  awbConfigForm: FormGroup;
  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };
  shipperDocValidationMsg: string;
  consigneeDocValidationMsg: string;
  kycDocValidationMsg: string;
  docMsg: string;
  category = RateCategory;
  isFormSubmitted = false;
  showModal = false;
  customerList: any[] = [];
  resCustomerList: any[] = [];
  companyList: any[] = [];
  selectChargeTypes: string[];
  shipperAddressBookList: any[] = [];
  consigneeAddressBookList: any[] = [];
  shipperKycFile: any[] = [];
  consigneeKycFile: any[] = [];
  chargeList: any[] = [];
  performaList: any[] = [];
  customerContractId: Number;
  unitList: any[] = ['Centimeter', 'Inches'];
  newRow = {
    totalpieces: 1,
    piecelength: null,
    piecebreadth: null,
    pieceheight: null,
    actualweight: null,
    volumetricweight: null,
    chargeweight: null
  }
  piecesfldDet: any;
  searchtype: any;
  numberOfRowsToGenerate: number;
  finalList: any[] = [];
  piecesDetailsList: any[] = [];
  itemDescriptionList: any;
  expandedRows: boolean[] = [];
  productOptions: any[] = [];
  resProductOptions: any[] = [];
  vendorOptions: any[] = [];
  serviceOptions: any[] = [];
  invoiceTermOptions: any[] = [];
  paymentOptions: any[] = [{ id: 1, name: "Credit Card" }, { id: 2, name: "Debit Card" }, { id: 3, name: "UPI" }, { id: 4, name: "Net Banking" }];
  fieldExecutiveList: any[] = [];
  salesExecutiveList: any[] = [];
  paymentTypeList = ['Cash', 'Credit', 'COD'];
  unitOptions: any[] = [{ name: 'KGS' }, { name: 'LBS' }, { name: 'CBM' }];
  containerItemUnitOptions: any[] = [{ code: "BOX", name: "Boxes" }, { code: "BOTTLE", name: "Bottle" }, { code: "KGS", name: "Kilogram" }, { code: "PCS", name: "Pieces" }, { code: "PKT", name: "Packet" }, { code: "SET", name: "Set" }];
  lutIgstOptions: any[] = [{ id: 'N', name: 'None' }, { id: 'B', name: 'EXPORT AGAINST IGST PAID' }, { id: 'U', name: 'EXPORT AGAINST LUT' }];
  firmOptions: any[] = [{ name: 'GOVT' }, { name: 'NON GOVT' }];
  performaExportReasonOptions: any[] = [{ name: 'BUYER (IF OTHER THAN CONSIGNEE)' }, { name: 'FREE SAMPLE OF NO COMMERICAL VALUE' }, { name: 'SHIPMENT CONTAINS FOR INTERCOMPANY DATA' }, { name: 'SHIPMENT SENDING FOR REPAIRING PURPOSE' }, { name: 'SHIPMENT SENDING RETURN' }, { name: 'UNSOLICITED GIFT - NOT FOR SALE' }];
  documentOptions: any[] = [{ name: 'GSTIN (Normal)' }, { name: 'PAN Number' }, { name: 'Aadhaar Number' }, { name: 'Passport Number' }, { name: 'TAN Number' }, { name: 'VAT Number' }, { name: 'EORI' }, { name: 'FDA' }, { name: 'Others' }];
  kycDocumentOptions: any[] = [{ name: 'Proforma Invoice' }, ...this.documentOptions];

  shipperLocationInfo: any = {};
  consigneeLocationInfo: any = {};
  bsoBrokerLocationInfo: any = {};
  performaId: number = 1;
  selectedFile: File;
  encryptFile: any;
  forwardingInfoTab = false;
  deliveryProductList: any[] = [];
  deliveryVendorList: any[] = [];
  deliveryServiceList: any[] = [];
  customerRowData = [];
  vendorRowData = [];

  originCountryList: any[] = [];
  originStateList: any[] = [];
  originCityList: any[] = [];
  respCompanyList: any[] = [];
  destinationCountryList: any[] = [];
  destinationStateList: any[] = [];
  destinationCityList: any[] = [];
  selectedPiecesFile: File | null = null;
  selectedKycFile: File | null = null;
  kycList = [];
  minBookingDate: string;
  piecesId: any = 0;
  isCsbType = false;
  compareRatesRowData = [];
  showPiecesDetails = false;
  piecesLength: number = 1;
  vendorData: any;
  customerData: any;
  totalPiecesLength: number;
  selectedSCId: number;
  totalShipment: number;
  kycInfo = {
    type: null,
    no: null,
    filepath: null,
    fileid: null,
    entitytype: null
  };
  progress: number = 0;
  showProgressBar = false;
  isCreditControlChecked = false;
  volumetricList: any[] = [];

  //copy awb
  shipmentDetails = {
    previousAmount: 0,
    chargeId: null,
    shipmentId: null,
    forwardingId: null,
    receiptId: null,
    shipperAddressBookId: null,
    consigneeAddressBookId: null,
    customerId: 0,
    isAwbBind: false,
    totalPiecesDisable: true,
    tempPiecesId: 0,
    isTypeAndId: false
  };
  productFilteredCountryList = [];

  creditDetails: { limit: number; balance: number; used: number; } = { limit: 0, balance: 0, used: 0 };
  updatedCreditBalance: number = 0;

  isAccessTypeCustomer = false;
  userData: any;
  kycUploadedFileURL = '';
  kycUploadedFileName = '';
  configDetail = [
    { name: 'Repeat Booking Date', icon: 'fas fa-calendar-o' },
    { name: 'Repeat Product', icon: 'fas fa-box' },
    { name: 'Repeat Customer', icon: 'fas fa-user' },
    { name: 'Repeat Vendor', icon: 'fas fa-building' },
    { name: 'Repeat Vendor Service', icon: 'fas fa-tools' },
    { name: 'Repeat Destination', icon: 'fas fa-map-marker-alt' },
  ];

  repeatData = [
    { key: 'bookingdate', value: null, isrepeat: false },
    { key: 'productid', value: null, isrepeat: false },
    { key: 'customerid', value: null, isrepeat: false },
    { key: 'vendorid', value: null, isrepeat: false },
    { key: 'vendorserviceid', value: null, isrepeat: false },
    { key: 'destination', value: null, isrepeat: false },
  ];
  awbConfig = {
    isPaymentModeDisable: false,
    isVolumetricRequired: false,
    isKYCMandatory: false
  }

  serviceConfig = {
    proforma: {
      detailsmandatory: false,
      documentrequired: false
    }
  }
  fieldExeList: any;

  availableCreditBalance = 0;
  totalCustomerCharges: number = 0;
  totalForwardingCharges: number = 0;
  inscanAWB: any;
  lastAWBNo: string = '';
  isAwbBuyerDetailsChk = false;
  isDOXSelected = false;
  receiptList = [];
  isReceiptEdit = false;
  receiptIndex;
  isReceiptFormSubmitted = false;
  iskycFormSubmitted = false;
  vendorWeightInfo: any = {};
  currencyCode: string = '';

  context: any;
  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  defaultColDef = {
    filter: true,
    sortable: true,
    resizable: false,
    flex: 1,
    minWidth: 120
  };

  gridOptions: GridOptions = {
    pagination: true,
    domLayout: 'autoHeight',
    paginationPageSize: 10
  }
  rowData: any[] = [];
  isModalOpen = false;

  customerConfig: any = {};
  vendorConfig: any = {};

  isChargeDetailsUpdated = false;
  isShipperCustomerBinded = false;
  docCharacterLimit: number;

  selectedProduct: any = null;
  specialServicesForm: FormGroup;
  conditionalCountryList = [];
  focusConsigneeName: boolean = false;

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  dangerousGoodsList = [
    { name: 'Accessible' },
    { name: 'Inaccessible' },
    { name: 'Small Quantity Exception' }
  ];
  billShipmentToAndDutiesPaidByList = [
    { name: 'Sender' },
    { name: 'Receiver' },
    { name: 'Third Party' }
  ];
  outputFormatList = [
    { name: 'Paper 4x6 (PNG)' },
    { name: 'Paper 8.5x11 Top Half Label (PNG)' }
  ]
  matchedShipper = null;
  matchedConsignee = null;
  tabPermission = {
    proforma: false,
    charges: false,
    shipmentinfo: false,
    specialservices: false,
    forwardinginfo: false,
    kyc: false,
    receipts: false
  };
  finalOriginStateTaxCode
  finalDestinationStateTaxCode
  currencyList = []
  totals = { totalAmount: 0, totalWeight: 0, totalQuantity: 0 };
  showSpecialServices = false;

  CountryList: any[] = [];
  reservedVendorCharges: any[] = [];
  useEnterKey = false;
  reservedCustomerCharges: any[] = [];
  ReservedPiecesData: any[] = [];
  childAwbList: any[] = [];
  currentDateTime: any;
  scLocationByIdObj: any = {};
  activeTabId = 1;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private awbService: AWBService,
    private geoService: GeoService,
    private companyService: CompanyService,
    private customerService: CustomerService,
    private rateUploadService: RateUploadService,
    private changeDetectorRef: ChangeDetectorRef,
    private productService: ProductService,
    private vendorService: VendorService,
    private pickupService: PickupService,
    private chargesService: ChargesService,
    private addressbookService: AddressBookService,
    private typeheadConfig: NgbTypeaheadConfig,
    private miscService: MiscService,
    private ngxLoaderService: NgxUiLoaderService,
    private toastr: ToastrService,
    private userManagementService: UserManagementService,
    private fileHandlerService: FileHandlerService,
    private appCoreService: AppCoreService,
    private excelService: ExcelService,
    private datePipe: DatePipe,
    private _fb: FormBuilder,
    public utilities: Utilities,
    private networkService: NetworkService,
    private configService: ConfigService,
    private creditControlService: CreditControlService,
    private route: ActivatedRoute,
    private titleService: Title,
    public modalService: NgbModal,
    private renderer: Renderer2,
  ) {
    this.titleService.setTitle('Air Way Bill');
    this.context = { componentParent: this, actionConfig: { comment: true } };
  }

  ngAfterViewChecked(): void {
    this.changeDetectorRef.detectChanges();
  };

  async ngOnInit() {

    // const bodyTag = document.body;
    // bodyTag.classList.add('sidebar-enable')
    // bodyTag.classList.add('vertical-collpsed');
    this.totalForwardingCharges = 0;
    this.totalCustomerCharges = 0;

    this.selectChargeTypes = ["Commercial", "Medical", "ODA", "Insurance"];
    this.currentDateTime = this.utilities.FormatDateWithTime().dateTimeString;
    const currentDate = this.utilities.FormatDateWithTime().dateString;

    this.receiptForm = this.formBuilder.group({
      ddlPaymentMode: [1, Validators.compose([Validators.required])],
      txtAmountReceived: [null, Validators.compose([Validators.required, AmountValidation])],
      txtBalanceAmount: [{ disabled: true, value: this.totalCustomerCharges }, AmountValidation],
      txtCashReceiptNo: [null, Validators.compose([Validators.pattern(/^(\d{0,40})$/)])],
      txtCashReceiptDate: [this.currentDateTime, Validators.compose([Validators.required])]
    });

    this.proformaForm = this.formBuilder.group({
      ddlCSBType: ['csb4'],
      ddlInvoiceTerm: [null],
      ddlGSTInvoice: ['No'],
      txtCommercialInvoiceNo: [null, Validators.compose([Validators.pattern(/^[0-9a-zA-Z]{0,30}$/)])],
      ddlInvoiceDate: new FormControl(currentDate),
      ddlExportReason: [null],
      txtDepartmentNo: [{ disabled: true, value: null }],
      chkBuyerDetails: [false],
      csbDetails: this.formBuilder.group({
        ddlLutIgst: [],
        txtTotalIgst: [null],
        txtBankAdCode: [null, Validators.compose([Validators.maxLength(30)])],
        txtBankAccount: [null, Validators.compose([Validators.maxLength(30)])],
        txtBankIfsc: [null, Validators.compose([Validators.maxLength(30)])],
        txtLutBondNo: [null, Validators.compose([Validators.maxLength(30)])],
        txtExchangeRate: [null],
        ddlFirm: [null],
        nfeiCheck: [null],
        payOfIgstCheck: [null],
        eCommerceCheck: [null],
        meisSchemaCheck: [null]
      }),
      buyerDetails: this.formBuilder.group({
        txtName: [null],
        txtPerson: [null],
        txtEmail: [null, Validators.compose([EmailValidation, Validators.maxLength(150)])],
        txtIECNo: [null],
        txtAddress: [null]
      })
    });

    this.kycForm = this.formBuilder.group({
      ddlDocumentType: [null, Validators.compose([Validators.required])],
      txtDocumentNo: [null],
      txtDocument: [null],
      documentFileControl: [null],
      documentFileUrl: ''
    });

    this.chargeForm = this.formBuilder.group({
      ddlChargeType: ['Vendor'],
      txtContractCharges: ['0'],
      txtOtherCharges: ['0'],
      txtSubTotal: [null],
      txtTotalFuel: [null],
      txtIGST: ['0.000'],
      txtCGST: ['0.000'],
      txtSGST: ['0.000'],
      txtTotalAmount: [null],
      chargesdetails: this.formBuilder.group({
        txtDescription: [null, Validators.required],
        txtItemAmount: [null, Validators.compose([Validators.required, AmountValidation])],
        txtFuelAmt: new FormControl({ value: null, disabled: true }),
        txtFuelTaxAmount: new FormControl({ value: null, disabled: true }),
        txtTaxAmount: new FormControl({ value: null, disabled: true }),
        chkItemFuel: ['No'],
        chkFuelTax: ['No'],
        chkTax: ['No'],
        txtItemTotal: [null, Validators.compose([Validators.required, AmountValidation])]
      })
    });

    this.awbForm = this.formBuilder.group({
      txtReferenceNo: [null, Validators.compose([Validators.maxLength(30)])],
      txtAwbNo: [null, Validators.compose([AlphaNumericValidation])],
      ddlCustomer: [null],
      ddlCompanies: [null, Validators.compose([Validators.required])],
      txtDateTime: [this.currentDateTime, Validators.required],
      ddlProduct: [null, Validators.compose([Validators.required])],
      ddlVendor: [null, Validators.compose([Validators.required])],
      ddlService: [null, Validators.compose([Validators.required])],
      txtShipmentValue: [null, AmountValidation],
      ddlCurrency: [null],
      ddlPaymentType: ['Cash'],
      ddlChargeType: [[]],
      txtShipperIecIoeNo: [null],
      txtConsigneeIecIoeNo: [null],
      ddlShipperDocumentType: [null],
      txtShipperDocumentNo: [{ value: null, disabled: true }, Validators.required],
      ddlConsigneeDocumentType: [null],
      txtConsigneeDocumentNo: [{ value: null, disabled: true }, Validators.required],
      txtFile: [null],
      txtTotalPiecesFileId: [],
      ddlMeasurementUnit: [this.unitList[0]],
      txtDivision: [{ disabled: true, value: '5000' }],

      shipperlocationdetails: this.formBuilder.group({
        ddlCountry: [null, Validators.compose([Validators.required])],
        txtName: [null, Validators.compose([Validators.required])],
        txtContactPerson: [null],
        txtEmail: [null, Validators.compose([EmailValidation, , Validators.maxLength(150)])],
        txtPincode: [null],
        ddlState: [null],
        ddlCity: [null],
        txtAddress1: [null, Validators.compose([Validators.required, Validators.maxLength(150)])],
        txtAddress2: [null, Validators.maxLength(150)],
        txtArea: [null, Validators.maxLength(30)],
        txtMobileNo: [null, Validators.compose([MobileNumberValidation])],
        txtTelephoneNo: [null, TelephoneNumberValidation],
      }),

      consigneelocationdetails: this.formBuilder.group({
        ddlCountry: [null, Validators.compose([Validators.required])],
        txtName: [null, Validators.compose([Validators.required])],
        txtContactPerson: [null],
        txtEmail: [null, Validators.compose([EmailValidation, , Validators.maxLength(150)])],
        txtPincode: [null],
        ddlState: [null],
        ddlCity: [null],
        txtAddress1: [null, Validators.compose([Validators.required, Validators.maxLength(150)])],
        txtAddress2: [null, Validators.maxLength(150)],
        txtArea: [null, Validators.maxLength(30)],
        txtMobileNo: [null, Validators.compose([MobileNumberValidation])],
        txtTelephoneNo: [null, TelephoneNumberValidation],
      }),

      shipmentinfo: this.formBuilder.group({
        ddlFieldExecutive: [null],
        ddlSalesExecutive: [null],
        txtExpectedDeliveryDate: [null],
        txtMasterAwbNo: [null, Validators.compose([Validators.pattern(/^([0-9a-zA-Z]{0,40})$/)])],
        txtRunNo: [{ value: null, disabled: true }],
        txtSpecialInstruction: [null],
      }),

      forwardinginfo: this.formBuilder.group({
        txtDeliveryAwb: [null, Validators.compose([Validators.maxLength(30), AlphaNumericValidation])],
        txtForwardingAwb: [null, Validators.compose([Validators.maxLength(30), AlphaNumericValidation])],
        ddlDeliveryProduct: [null],
        ddlDeliveryVendor: [null],
        ddlDeliveryService: [null],
        txtVendorWeight: [null],
        txtVendorInvoiceNo: [null, Validators.compose([Validators.maxLength(30)])]
      }),
      usedPickup: new FormControl(false),
    });

    this.specialServicesForm = this.formBuilder.group({
      dangerousGoodsCheck: ['No'],
      ddldangerousGoods: [{ value: null, disabled: true }],
      dryIceCheck: ['No'],
      txtDryIceWeight: [{ value: null, disabled: true }],
      insuranceCoverCheck: ['No'],
      txtInsuranceCoverValue: [{ value: null, disabled: true }],
      txtBookingConfirmationNo: [null],
      ddlbillShipmentTo: [null],
      txtBillShipmentToAccNo: [null],
      ddlTaxAndDutiesPaidBy: [null],
      txtTaxAndDutiesAccNo: [null],
      ddlOutputFormat: [null],

      bsoBrokerCheck: [false],
      bsoBrokerlocationdetails: this.formBuilder.group({
        ddlCountry: [{ value: null, disabled: true }, [Validators.required]],
        ddlState: [{ value: null, disabled: true }],
        ddlCity: [{ value: null, disabled: true }],
        txtPincode: [{ value: null, disabled: true }],
        txtAddress1: [{ value: null, disabled: true }, Validators.compose([Validators.required, Validators.maxLength(150)])],
        txtAddress2: [{ value: null, disabled: true }, Validators.maxLength(150)],
        txtArea: [{ value: null, disabled: true }, Validators.maxLength(30)],
        txtMobileNo: [{ value: null, disabled: true }, Validators.compose([Validators.required, MobileNumberValidation])],
        txtTelephoneNo: [{ value: null, disabled: true }, TelephoneNumberValidation],
      }),
    }),

      this.piecesForm = this._fb.group({
        totalpieces: [{ value: 0, disabled: true }],
        totalactualweight: [{ value: '0.000', disabled: true }, Validators.compose([Validators.required, Validators.pattern(/^\d{0,9}(\.\d{0,3})?$/)])],
        totalvolumetricweight: [{ value: '0.000', disabled: true }, Validators.compose([Validators.required, Validators.pattern(/^\d{0,9}(\.\d{0,3})?$/)])],
        totalchargeableweight: [{ value: '0.000', disabled: true }, Validators.compose([Validators.required, Validators.pattern(/^\d{0,9}(\.\d{0,3})?$/)])],
        actualweightunit: ['KGS'],
        measurementunit: [''],
        containers: this._fb.array([])
      });

    this.awbConfigForm = this.formBuilder.group({
      configDetails: this.formBuilder.array(this.configDetail.map(detail => this.formBuilder.group({
        name: detail.name,
        icon: detail.icon,
        ischecked: false
      })))

    });

    /*AWB Charges*/
    //this.getAWBCharges();
    this.checkPermission();
    if (this.permConfig.isAddAllowed) {
      this.appCoreService.SelectedServiceCenter().subscribe(async (val) => {
        if (val) {
          this.selectedSCId = val;
        }
      });

      this.bindBookingDate();
      this.loadDataFromAPI();

      this.awbForm.get('ddlCustomer')?.valueChanges.pipe(startWith(this.awbForm.get('ddlCustomer')?.value), pairwise()).subscribe(([previousValue, currentValue]) =>
        previousValue != currentValue && this.checkVolumetricDetail());

      this.awbForm.get('ddlProduct')?.valueChanges.pipe(startWith(this.awbForm.get('ddlProduct')?.value), pairwise()).subscribe(([previousValue, currentValue]) =>
        (currentValue && previousValue != currentValue) ? this.onProductChange(currentValue) : this.selectedProduct = null);

      this.awbForm.get('ddlVendor')?.valueChanges.pipe(startWith(this.awbForm.get('ddlVendor')?.value), pairwise()).subscribe(([previousValue, currentValue]) =>
        previousValue != currentValue && this.checkVolumetricDetail());

      this.awbForm.get('ddlShipperDocumentType')?.valueChanges.pipe(startWith(this.awbForm.get('ddlShipperDocumentType')?.value), pairwise()).subscribe(([previousValue, currentValue]) => {
        const docNoControl = this.awbForm.get('txtShipperDocumentNo');
        currentValue && previousValue != currentValue ? docNoControl?.enable() : (docNoControl.reset(), docNoControl?.disable());
      });

      this.awbForm.get('ddlConsigneeDocumentType')?.valueChanges.pipe(startWith(this.awbForm.get('ddlConsigneeDocumentType')?.value), pairwise()).subscribe(([previousValue, currentValue]) => {
        const docNoControl = this.awbForm.get('txtConsigneeDocumentNo');
        currentValue && previousValue != currentValue ? docNoControl?.enable() : (docNoControl.reset(), docNoControl?.disable());
      });

      this.awbForm.get('ddlService')?.valueChanges.subscribe((value) => value && this.checkVolumetricDetail());
      this.awbForm.get('shipperlocationdetails').get('ddlState').valueChanges.subscribe((newValue) => newValue && this.documentTypeValidation('shipperdoc'));
      this.awbForm.get('consigneelocationdetails').get('ddlState').valueChanges.subscribe((newValue) => newValue && this.documentTypeValidation('consigneedoc'));

      this.awbForm.get('shipperlocationdetails').get('ddlCountry').valueChanges.subscribe((newValue) => {
        // console.log('shipperlocationdetails >> ddlCountry', newValue);

        if (newValue === 'GBR') {
          this.awbForm.get('txtShipperIecIoeNo')?.enable();
        } else {
          this.awbForm.get('txtShipperIecIoeNo')?.disable();
        }
      });

      this.awbForm.get('consigneelocationdetails').get('ddlCountry').valueChanges.subscribe((newValue) => {
        // console.log('consigneelocationdetails >> ddlCountry', newValue);
        if (newValue === 'GBR') {
          this.awbForm.get('txtConsigneeIecIoeNo')?.enable();
        } else {
          this.awbForm.get('txtConsigneeIecIoeNo')?.disable();
        }
      });

      this.awbForm.get('ddlCompanies').valueChanges.pipe(startWith(this.awbForm.get('ddlCompanies')?.value), pairwise()).subscribe(([previousValue, currentValue]) =>
        currentValue && previousValue != currentValue && this.onChangeCompany(currentValue));

      this.piecesForm.valueChanges.subscribe(() => { this.calculateTotals() });

      this.awbForm.get('forwardinginfo.ddlDeliveryProduct')?.valueChanges.pipe(startWith(this.awbForm.get('forwardinginfo.ddlDeliveryProduct')?.value), pairwise()).subscribe(([previousValue, currentValue]) => {
        if ((currentValue && previousValue != currentValue)) {
          this.getVendorApplicableTax()
        }
      });

      this.awbForm.get('forwardinginfo.ddlDeliveryVendor')?.valueChanges.pipe(startWith(this.awbForm.get('forwardinginfo.ddlDeliveryVendor')?.value), pairwise()).subscribe(([previousValue, currentValue]) => {
        if ((currentValue && previousValue != currentValue)) {
          this.getVendorApplicableTax()
        }
      });

      // this.awbForm.get('txtDateTime')?.valueChanges.subscribe((value) => {
      //   this.awbForm.get('shipmentinfo').get('txtExpectedDeliveryDate').setValue(value);
      // });
      // this.awbForm.get('forwardinginfo.txtVendorWeight').disable();
      // this.isFormSubmitted = false;

      this.route.queryParams.subscribe(params => {
        const type = params['type'];
        const awbid = params['id'];

        if (type === 'copy' && awbid) {
          this.shipmentDetails.isTypeAndId = true;
          this.bindAwb(awbid);
        }
      });

      if (!this.shipmentDetails.isTypeAndId) {
        this.bindDefaultPiecesContainer();
      }
      // this.bindItemDescriptions();
      // this.getAllPaymntModes();

      // this.piecesForm.get('totalchargeableweight').valueChanges.pipe(
      //   pairwise() // Emits previous and current values as an array
      // ).subscribe(([previousValue, currentValue]) => {
      //   // Only call getAWBCharges if the value has changed
      //   if (previousValue !== currentValue) {
      //     this.getAWBCharges(this.category.CUSTOMER);
      //   }
      // });

    }
  }

  ngAfterViewInit() {
    this.useEnterKey = !this.userData?.metaInfo?.tabbasedtemplate;

    this.awbFocusCheckMap = this.userData.metaInfo.userconfig.awbfocuscheckmap;
    this.awbAddressFocusCheckMap = this.userData.metaInfo.userconfig.awbaddressfocuscheckmap;

    this.awbFocusCheckMap?.length && this.focusNextField();
    this.updateShortcuts();
  }

  updateShortcuts() {
    // Generate shortcut message with HTML formatting and grey-styled keys
    const shortcutMessage = `
        <div class="shortcut-container">
          <ul>
            <li><strong>Save AWB</strong>: <span class="shortcut-key">Alt + S</span></li>
            <li><strong>New AWB Entry</strong>: <span class="shortcut-key">Alt + N</span></li>
            <li><strong>AWB Cancel (Back to list view)</strong>: <span class="shortcut-key">Alt + L</span></li>
            <li><strong>Next Tab (AWB Entry)</strong>: <span class="shortcut-key">Alt + ></span></li>
            <li><strong>Previous Tab (AWB Entry)</strong>: <span class="shortcut-key">Alt + <</span></li>
            <li><strong>Toggle Weight Dimensions (Pieces details)</strong>: <span class="shortcut-key">Alt + W</span></li>
            <li><strong>Toggle Proforma details</strong>: <span class="shortcut-key">Alt + P</span></li>
            <li><strong>Toggle Charges details</strong>: <span class="shortcut-key">Alt + C</span></li>
            <li><strong>Toggle Shipment Info</strong>: <span class="shortcut-key">Alt + H</span></li>
            <li><strong>Toggle Forwarding Info</strong>: <span class="shortcut-key">Alt + F</span></li>
            <li><strong>Toggle KYC details</strong>: <span class="shortcut-key">Alt + K</span></li>
            <li><strong>Toggle Receipts</strong>: <span class="shortcut-key">Alt + R</span></li>
          </ul>
        </div>
      `;

    this.appCoreService.updateShortcut(shortcutMessage);
  };

  isTabVisible(tabId: number): boolean {
    switch (tabId) {
      case 2: return this.tabPermission.proforma;
      case 3: return this.tabPermission.charges;
      case 4: return this.tabPermission.shipmentinfo;
      case 5: return this.tabPermission.specialservices && this.showSpecialServices;
      case 6: return !this.isAccessTypeCustomer && this.tabPermission.forwardinginfo;
      case 7: return this.tabPermission.kyc;
      case 8: return this.tabPermission.receipts;
      default: return true;
    }
  }

  // Mapping of tab IDs to their respective template outlet names
  tabTemplateMap: { [key: number]: string } = {
    1: 'WeightDimensions',
    2: 'ProformaContent',
    3: 'ChargesContent',
    4: 'ShipmentContent',
    5: 'SpecialServicesContent',
    6: 'ForwardingContent',
    7: 'KYCContent',
    8: 'ReceiptsContent'
  };

  showShortcuts = false;

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    // console.log(`Key Pressed: ${event.key}, Alt: ${event.altKey}`); // Debug log
    if (!event.altKey) return;

    event.preventDefault(); // Prevent default browser behavior for all Alt key combinations

    const findTabIdByTemplate = (templateName: string): number | null => {
      const tabId = Object.keys(this.tabTemplateMap).map(Number)
        .find(id => this.tabTemplateMap[id] === templateName && this.isTabVisible(id));
      return tabId ?? null;
    };

    const getNextTabId = (currentTabId: number): number | null => {
      const tabIds = Object.keys(this.tabTemplateMap).map(Number).filter(id => this.isTabVisible(id));

      const currentIndex = tabIds.indexOf(currentTabId);
      return currentIndex !== -1 && currentIndex < tabIds.length - 1 ? tabIds[currentIndex + 1] : null;
    };

    const getPreviousTabId = (currentTabId: number): number | null => {
      const tabIds = Object.keys(this.tabTemplateMap).map(Number).filter(id => this.isTabVisible(id));
      const currentIndex = tabIds.indexOf(currentTabId);
      return currentIndex > 0 ? tabIds[currentIndex - 1] : null;
    };

    const key = event.key.toLowerCase();

    const actions: { [key: string]: () => void } = {
      w: () => { const tabId = findTabIdByTemplate('WeightDimensions'); if (tabId) this.activeTabId = tabId; },
      p: () => { const tabId = findTabIdByTemplate('ProformaContent'); if (tabId) this.activeTabId = tabId; },
      c: () => { const tabId = findTabIdByTemplate('ChargesContent'); if (tabId) this.activeTabId = tabId; },
      h: () => { const tabId = findTabIdByTemplate('ShipmentContent'); if (tabId) this.activeTabId = tabId; },
      f: () => { const tabId = findTabIdByTemplate('ForwardingContent'); if (tabId) this.activeTabId = tabId; },
      k: () => { const tabId = findTabIdByTemplate('KYCContent'); if (tabId) this.activeTabId = tabId; },
      r: () => { const tabId = findTabIdByTemplate('ReceiptsContent'); if (tabId) this.activeTabId = tabId; },
      l: () => { this.router.navigate(['/operation/awb']); },
      n: () => { this.router.navigate(['/operation/awb/add']); },
      'arrowright': () => {

        const nextTab = getNextTabId(this.activeTabId);
        if (nextTab) this.activeTabId = nextTab;
      },
      'arrowleft': () => {
        const prevTab = getPreviousTabId(this.activeTabId);
        if (prevTab) this.activeTabId = prevTab;
      }
    };

    if (actions[key]) {
      event.preventDefault(); // Prevent browser navigation (back/forward) on Alt + > and Alt + <
      actions[key]();
    }
  }



  onKeyDownblockKeyForShipment(event: KeyboardEvent) {
    if (event.keyCode == 69 || event.keyCode == 107) {
      event.preventDefault();
    }
  }

  loadDataFromAPI() {
    this.ngxLoaderService.start();
    try {
      forkJoin({
        countries: this.geoService.GetAllCountries(),
        customers: this.customerService.GetAll({ isactive: true, scid: this.appCoreService.GetUserData().selectedServiceCenter }),
        companies: this.companyService.GetAll({ isactive: true }),
        products: this.productService.GetAll({ isactive: true }),
        vendors: this.vendorService.GetAll({ isactive: true }),
        itemDescription: this.miscService.GetAllGoods(),
        invoiceTrem: this.miscService.GetAllInvoiceTerms(),
        users: this.userManagementService.GetUserByGroup('fe,se', this.selectedSCId),
        description: this.chargesService.GetAll(''),
        globalConfig: this.configService.getAllGlobalConfig(),
        paymentModes: this.miscService.GetAllPaymentModes(),
        moduleConfigByClientId: this.configService.getModuleConfigByClientId(),
      }).pipe(
        finalize(async () => {
          await this.getAllVendorServices();
          this.bindShipperLocationOverSc();
          this.onPerformaChange();
          this.updateRepeatData();

          // set default company
          let defaultCompanyId = this.companyList.find(x => x.isdefault)?.id;
          this.awbForm.get('ddlCompanies').setValue(defaultCompanyId);

          // Filter customers whose companyids array contains at least one matching company ID
          if (defaultCompanyId)
            this.customerList = this.resCustomerList.filter(cust => cust.companyids.some(id => id == defaultCompanyId));
          else
            this.customerList = this.resCustomerList;

          const ud: any = this.appCoreService.GetUserData();
          if (ud && ud.accessType == "Customer") {
            this.isAccessTypeCustomer = true;
            this.awbForm.get('ddlCustomer').setValue(this.customerList.find(x => x.id == ud?.metaInfo?.customerid)?.id);
            this.awbForm.get('txtReferenceNo').disable();
            this.awbForm.get('txtAwbNo').disable();
            this.awbForm.get('ddlCustomer').disable();
            this.awbForm.get('txtDateTime').disable();
            this.getCustomerContract(Number(ud?.metaInfo?.customerid));
          }
          this.ngxLoaderService.stop();
        })
      ).subscribe((res) => {
        if (res) {
          if (res.countries.success && res?.countries?.data) {
            this.CountryList = res?.countries?.data || [];
            this.productFilteredCountryList = this.CountryList || [];
            this.currencyList = Array.from(new Set(this.CountryList?.filter((x) => x.currencycode !== '' && x.currencycode !== null)))

            // bind currecycode
            const currencyCode = this.currencyList.find(x => x.isocode === this.userData?.metaInfo?.defaultcountry)?.currencycode;
            currencyCode && this.awbForm.get('ddlCurrency').setValue(currencyCode);
          }
          if (res.customers.success && res.customers?.data) {
            this.resCustomerList = res.customers?.data;
          }
          if (res.companies.success && res.companies?.data) {
            this.respCompanyList = res.companies?.data;
            //list those customers only who have selected service center as their active one.
            this.companyList = this.respCompanyList.filter(cust => cust?.servicecenters && cust?.servicecenters?.some(scid => scid == this.selectedSCId));
          }
          if (res.products.success && res.products?.data) {
            this.productOptions = res.products?.data;
            this.resProductOptions = res.products?.data;
            this.deliveryProductList = res.products?.data;
          }
          if (res.vendors.success && res.vendors?.data) {
            this.vendorOptions = res.vendors?.data;
            this.deliveryVendorList = res.vendors?.data;
          }
          if (res.itemDescription.success && res.itemDescription?.data) {
            this.itemDescriptionList = res.itemDescription?.data;
          }
          if (res.invoiceTrem.success && res.invoiceTrem?.data) {
            this.invoiceTermOptions = res.invoiceTrem?.data;
          }
          if (res.users.success && res.users?.data) {
            const data = res.users?.data;
            this.fieldExecutiveList = data.filter((item: any) => item.usergroupname === 'Field Executive');
            this.salesExecutiveList = data.filter((item: any) => item.usergroupname === 'Sales Executive');
          }
          if (res.description.success && res.description?.data) {
            this.chargeList = res.description?.data;
          }
          if (res.globalConfig.success && res.globalConfig?.data) {
            const globalConfig = res.globalConfig?.data;
            this.checkAwbConfig(globalConfig);
          }
          if (res.paymentModes.success && res.paymentModes?.data) {
            this.paymentOptions = res.paymentModes?.data;
          }
          if (res.moduleConfigByClientId.success && res.moduleConfigByClientId?.data) {
            const creditControl = res.moduleConfigByClientId?.data?.[0]?.planconfig?.moduleconfig?.find(res => res.name === 'Credit Control');
            this.isCreditControlChecked = creditControl?.checked;
          }
        }
      })
    } catch (error) {
      this.ngxLoaderService.stop();
    }
  };

  checkPermission(): any {
    this.userData = this.appCoreService.GetUserData();
    const permission = this.userData.config.filter(x => x.categoryname === 'AirWayBills');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
    // Tab permissions
    const tabCategories = ['Proforma', 'Charges', 'Shipment Info', 'Special Services', 'Forwarding Info', 'KYC', 'Receipts'];
    const tabPerm = this.userData.config.filter(x => x.parentcategoryname === 'Operations');

    tabCategories.forEach(category => {
      const permission = tabPerm.find(x => x.categoryname === category);
      this.tabPermission[category.replace(/\s+/g, '').toLowerCase()] = permission?.add || false;
    });
  }

  bindSpecialServices() {
    this.specialServicesForm.reset();
    this.specialServicesForm.controls.dangerousGoodsCheck.setValue('No');
    this.specialServicesForm.controls.dryIceCheck.setValue('No');
    this.specialServicesForm.controls.insuranceCoverCheck.setValue('No');

    this.specialServicesForm.controls.ddldangerousGoods.disable();
    this.specialServicesForm.controls.txtDryIceWeight.disable();
    this.specialServicesForm.controls.txtInsuranceCoverValue.disable();

    const { code, apienabled } = this.vendorOptions.find(x => x.id === this.awbForm.get('ddlVendor')?.value);

    const matchedVendor = code && code?.toUpperCase()?.includes('FDX') || code?.toUpperCase().includes('UPS');

    //for SpecialServices check vendor api confuguration && permission
    this.showSpecialServices = this.tabPermission.specialservices && matchedVendor && apienabled;
  }

  bindCustomerBySC() {
    this.customerList = this.resCustomerList.filter(cust => cust.allocatedservicecenters.filter(x => x.active))
  }

  calculateTotals() {
    this.totals.totalAmount = 0;
    this.totals.totalWeight = 0;
    this.totals.totalQuantity = 0;

    this.containers.controls.forEach((container: FormGroup) => {
      const subitems = container.get('containeritemsgroup.subitems')?.value || [];
      subitems.forEach((item: any) => {
        this.totals.totalAmount += Number(item.itemamount) || 0;
        this.totals.totalWeight += Number(item.itemweight) || 0;
        this.totals.totalQuantity += Number(item.itemquantity) || 0;
      });
    });

    this.totals.totalAmount = parseFloat(this.totals.totalAmount.toFixed(2));
    this.totals.totalWeight = parseFloat(this.totals.totalWeight.toFixed(3));
  }

  checkVolumetricDetail() {
    const customer = this.awbForm.get('ddlCustomer')?.value;
    const product = this.awbForm.get('ddlProduct')?.value;
    const vendor = this.awbForm.get('ddlVendor')?.value;
    const service = this.awbForm.get('ddlService')?.value;
    const serviceObject = Array.isArray(service) ? service[0] : service;
    if (customer && product && vendor && serviceObject) {
      const requestObj = {
        customerid: customer,
        productid: product,
        vendorid: vendor,
        serviceid: service
      };

      this.customerService.getVolumetricDataForAwb(requestObj).subscribe((res) => {
        if (res?.success) {
          this.volumetricList = res.data;
          if (this.volumetricList.length > 0) {
            if (this.awbForm.get('ddlMeasurementUnit')?.value === 'Inches') {
              this.awbForm.get('txtDivision').setValue(this.volumetricList[0].inches);
            } else {
              this.awbForm.get('txtDivision').setValue(this.volumetricList[0].centimeter);
            }
          } else {
            this.awbForm.get('txtDivision')?.setValue(
              this.awbForm.get('ddlMeasurementUnit')?.value === 'Inches' ? MeasurementUnit.INCHES : MeasurementUnit.CENTIMETER
            );
          }

        } else if (res && !res.success && res?.data?.err_msg) {

          this.appCoreService.showMessage(res.data.err_msg, "Error", 'error')
        }
      })

    } else {
      return;
    }
  }

  SpecialServicesCheckChange(formControlNameArray?: string[]) {
    const specialServicesForm = this.specialServicesForm;
    const serviceControls = [
      { checkName: 'bsoBrokerCheck', controlName: 'bsoBrokerlocationdetails' },
      { checkName: 'dangerousGoodsCheck', controlName: 'ddldangerousGoods' },
      { checkName: 'dryIceCheck', controlName: 'txtDryIceWeight' },
      { checkName: 'insuranceCoverCheck', controlName: 'txtInsuranceCoverValue' },
      { checkName: 'ddlbillShipmentTo', controlName: 'txtBillShipmentToAccNo' },
      { checkName: 'ddlTaxAndDutiesPaidBy', controlName: 'txtTaxAndDutiesAccNo' },
    ];

    // If no specific controls are passed, consider all controls
    const controlsToCheck = formControlNameArray?.length > 0 ?
      serviceControls.filter(control => formControlNameArray.includes(control.checkName)) :
      serviceControls;

    controlsToCheck.forEach(control => {
      const checkValue = specialServicesForm.get(control.checkName).value;

      // Handle enabling/disabling logic based on checkValue
      if (['dangerousGoodsCheck', 'dryIceCheck', 'insuranceCoverCheck'].includes(control.checkName)) {
        const shouldEnable = (checkValue === 'Yes');
        shouldEnable ? specialServicesForm.get(control.controlName).enable() :
          (specialServicesForm.get(control.controlName).reset(), specialServicesForm.get(control.controlName).disable());
      } else if (control.checkName === 'ddlbillShipmentTo' || control.checkName === 'ddlTaxAndDutiesPaidBy') {
        const shouldEnable = (checkValue !== this.billShipmentToAndDutiesPaidByList[0].name);
        shouldEnable ? specialServicesForm.get(control.controlName).enable() :
          (specialServicesForm.get(control.controlName).reset(), specialServicesForm.get(control.controlName).disable());
      } else if (['bsoBrokerCheck'].includes(control.checkName)) {
        const shouldEnable = (checkValue === true);
        shouldEnable ? specialServicesForm.get(control.controlName).enable() :
          (specialServicesForm.get(control.controlName).reset(), specialServicesForm.get(control.controlName).disable());
      }
    });
  }

  //#region Pieces Containers
  get containers(): FormArray {
    return this.piecesForm.get('containers') as FormArray;
  }

  newContainer(pCount): FormGroup {
    return this._fb.group({
      piecescounter: (this.containers.length + 1),
      piecescount: [pCount || '', Validators.compose([Validators.required, Validators.min(1)])],
      piecesactualweight: ['', Validators.compose([Validators.required, Validators.pattern(/^\d{0,9}(\.\d{0,3})?$/)])],
      pieceslength: '',
      piecesbreadth: '',
      piecesheight: '',
      piecesvolumetricweight: 0,
      pieceschargeableweight: [{ value: 0, disabled: true }],
      // subitems: this._fb.array([])
      containeritemsgroup: this._fb.group({
        containerid: '',
        editmode: false,
        editsubitemid: 0,
        description: [null, Validators.compose([Validators.maxLength(40), Validators.required])],
        hsncode: [null, Validators.compose([Validators.maxLength(10)])],
        unit: ['PCS'],
        weight: [null, Validators.compose([Validators.pattern(/^[0-9]{0,9}(\.[0-9]{0,3})?$/)])],
        quantity: [null, Validators.compose([Validators.pattern(/^\d{1,3}$/), Validators.required, nonZeroValidator])],
        rate: [null, Validators.compose([Validators.required, Validators.pattern(/^[0-9]{0,10}(\.[0-9]{0,3})?$/), nonZeroValidator])],
        amount: [{ value: '', disabled: true }],
        subitems: this._fb.array([])
      })
    });
  }

  addContainer(pCount, containerObj?) {
    if (containerObj) {
      this.containers.push(this.newContainerWithData(pCount, containerObj));
    } else {
      this.containers.push(this.newContainer(pCount));
    }
  }

  removeContainer(pCount) {
    this.containers.removeAt(pCount);
  }

  subItem(itemIndex: number): FormArray {
    return this.containers
      .at(itemIndex)
      .get('containeritemsgroup')
      .get('subitems') as FormArray;
  }

  newSubItem(item): FormGroup {
    // console.log(item);
    return this._fb.group({
      itemdescription: item?.description?.name ?? item?.description ?? item?.itemdescription,
      itemhsncode: item.hsncode || item.itemhsncode,
      itemunit: item.unit || item.itemunit,
      itemweight: item.weight || item.itemweight,
      itemquantity: item.quantity || item.itemquantity,
      itemrate: item.rate || item.itemrate,
      itemamount: item.amount || item.itemamount
    });
  }

  addSubItem(itemIndex: number, containerGroup: FormGroup) {
    // this.subItem(itemIndex).push(this.newSubItem(item));
    let item = containerGroup.value;
    // temp fix - disabled amount value read
    item.amount = containerGroup.get('amount').value;
    containerGroup.markAllAsTouched();
    if (containerGroup.valid) {
      // containerGroup.reset();
      containerGroup.patchValue({
        description: '',
        hsncode: '',
        weight: '',
        unit: 'PCS',
        quantity: '',
        rate: '',
        amount: 0
      });
      containerGroup.markAsUntouched();
      containerGroup.updateValueAndValidity();
      this.subItem(itemIndex).insert(0, this.newSubItem(item));
      this.focusNextContainer(itemIndex + 1);
      this.calculateShipmentValue();
    }
  }

  editSubItem(containerGroup: FormGroup, subItem, itemIdx) {
    // this.subItem(itemIndex).push(this.newSubItem(item));
    // console.log(subItem);
    containerGroup.patchValue({
      editmode: true,
      editsubitemid: itemIdx,
      description: { name: subItem.value.itemdescription, hsncode: 234 },
      hsncode: subItem.value.itemhsncode,
      weight: subItem.value.itemweight,
      unit: subItem.value.itemunit,
      quantity: subItem.value.itemquantity,
      rate: subItem.value.itemrate,
      amount: subItem.value.itemamount
    });
    // Disable the description control
    containerGroup.get('description')?.disable();
  }

  cancelUpdateSubItem(containerGroup: FormGroup) {
    containerGroup.patchValue({
      editmode: false,
      description: '',
      hsncode: '',
      weight: '',
      unit: 'PCS',
      quantity: '',
      rate: '',
      amount: 0
    });
    // Enable the description control
    containerGroup.get('description')?.enable();
    containerGroup.markAsUntouched();
    containerGroup.updateValueAndValidity();
  }

  updateSubItem(containerGroup: FormGroup) {
    let item = containerGroup.value;
    // console.log('item', item);
    // console.log('item', containerGroup.getRawValue());
    // temp fix - disabled amount value read
    item.amount = containerGroup.get('amount').value;
    item.description = containerGroup.get('description').value;
    containerGroup.markAllAsTouched();
    if (containerGroup.invalid) return;
    if (containerGroup.valid) {
      // containerGroup.reset();
      containerGroup.patchValue({
        description: '',
        hsncode: '',
        weight: '',
        unit: 'PCS',
        quantity: '',
        rate: '',
        amount: 0
      });
      containerGroup.markAsUntouched();
      containerGroup.updateValueAndValidity();
      // console.log(containerGroup.get('subitems'));
      (containerGroup.get('subitems') as FormArray).at(item.editsubitemid).patchValue({
        itemdescription: item?.description?.name ?? item?.description,
        itemhsncode: item.hsncode,
        itemweight: item.weight,
        itemunit: item.unit,
        itemquantity: item.quantity,
        itemrate: item.rate,
        itemamount: item.amount
      });
      // Enable the description control
      containerGroup.get('description')?.enable();
      this.calculateShipmentValue();
    }

    containerGroup.patchValue({
      editmode: false,
      description: '',
      hsncode: '',
      weight: '',
      unit: 'PCS',
      quantity: '',
      rate: '',
      amount: 0
    });
    containerGroup.markAsUntouched();
    containerGroup.updateValueAndValidity();
  }

  async removeSubItem(itemIndex: number, currentIdx: number) {
    const confirmed = await this.openConfirmationDialog('Are you sure you want to delete ?');
    if (confirmed) {
      this.subItem(itemIndex).removeAt(currentIdx);
      this.calculateShipmentValue();
    }
  }

  addNewContainerCustom(index?: number, focusActualWeight: boolean = true) {
    if (index >= 0) {
      const totalLength = this.containers?.controls?.length - 1;
      if (totalLength !== index) {
        return;
      }
    }
    let piecesCount = 1, allowAdd = false;
    // console.log(this.containers);
    // this.piecesForm.markAllAsTouched();
    this.containers.controls.forEach((val, idx) => {
      // console.log('val', val, 'idx', idx);
      val.get('piecescount').markAsTouched();
      val.get('piecesactualweight').markAsTouched();
      // val.get('containeritemsgroup').markAsUntouched({onlySelf: true});
      // val.get('containeritemsgroup').clearValidators();
      // val.get('containeritemsgroup').setErrors(null);
      // val.get('containeritemsgroup').updateValueAndValidity();
      val.get('containeritemsgroup').disable();
    })

    allowAdd = this.containers.valid;
    if (allowAdd) {
      this.addContainer(piecesCount);
      this.containers.controls.forEach((val) => {
        val.get('containeritemsgroup')?.enable();
        val.get('containeritemsgroup.amount')?.disable();
      });
      this.calculateWeightNew();
      // focus on the last container' actual weight
      focusActualWeight ? this.focusFirstActualWeight() : null;
    }
  };

  focusNextContainer(index: number) {
    const nextContainer = document.querySelectorAll('input[formControlName="piecesactualweight"]')[index];
    if (nextContainer) {
      (nextContainer as HTMLElement).focus();
    }
  }

  focusFirstActualWeight() {
    setTimeout(() => {
      const firstInput = this.piecesActualWeightInputs.first;
      if (firstInput) {
        firstInput.nativeElement.focus();
      }
    }, 0);
  }

  async removeContainerCustom(idx) {
    let allowDelete = false;
    // console.log('container validity', this.containers.valid);
    // console.log(this.containers);
    allowDelete = (this.containers.controls.length > 1);
    this.piecesForm.markAllAsTouched();
    if (allowDelete) {
      const confirmed = await this.openConfirmationDialog('Are you sure you want to delete ?');
      if (confirmed) {
        this.removeContainer(idx);
        this.calculateWeightNew();
      }
    } else {
      // this.appCoreService.showMessage('Minimum of 1 piece is required', '', 'warning');
      this.openWarningDialog("Cannot Delete!. Minimum of 1 piece is required");
    }
  }

  //#endregion

  calculateItemAmount(currentContainer: FormGroup) {
    let quantity = currentContainer.get('containeritemsgroup').get('quantity').value || 0;
    let rate = currentContainer.get('containeritemsgroup').get('rate').value || 0;
    const amount = quantity * rate;
    currentContainer.get('containeritemsgroup').patchValue({
      amount: amount
    });
  }

  bindDefaultPiecesContainer() {
    let piecesCount = 1;
    this.piecesForm.get('totalpieces').setValue(piecesCount);
    this.addContainer(piecesCount);
  }

  bindItemDescriptions() {
    try {
      this.miscService.GetAllGoods().subscribe((res) => {
        if (res && res.success) {
          this.itemDescriptionList = res.data;
          // console.log(" item description :",this.itemDescriptionList);
        }
      })
    } catch (e) {
      console.error(e);
    }
  }

  formatterItemDescription = (x: { name: string }) => x.name;

  searchItemDescription: OperatorFunction<string, readonly { name; flag }[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term) =>
        term === ''
          ? []
          : this.itemDescriptionList?.filter((v) => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10),
      ),
    );

  selectedItemDescriptionEvent(currentContainer: FormGroup, event: any) {
    try {
      if (event) {
        const item = event.item;
        currentContainer.get('containeritemsgroup').patchValue({
          hsncode: item.hsncode
        })
        this.focusItemWeightRef();
      }
    } catch (e) {
      console.error(e);
    }
  }

  focusItemWeightRef() {
    setTimeout(() => {
      if (this.weightRef instanceof QueryList && this.weightRef.first) {
        this.weightRef.first.nativeElement.focus();
      }
    }, 100);
  };

  toggleRowExpansion(index: number): void {
    this.expandedRows.forEach((_, i) => {
      if (i !== index) {
        this.expandedRows[i] = false;
      }
    });
    this.expandedRows[index] = !this.expandedRows[index];
    if (this.expandedRows[index]) {
      this.containers.at(index).get('containeritemsgroup').enable();
    } else {
      this.containers.at(index).get('containeritemsgroup').disable();
    }
    this.containers.at(index).get('containeritemsgroup').get('amount').disable();
  }

  isRowExpanded(index: number): boolean {
    return this.expandedRows[index];
  }

  bindBookingDate(date: any = new Date()) {
    // this.awbForm.get('txtDateTime').setValue(this.utilities.FormatDateWithTime(0, date).dateTimeString);
    this.minBookingDate = this.utilities.FormatDateWithTime(0, new Date(new Date(date).setDate(new Date(date).getDate() - 30))).dateTimeString;
  }


  bindDescription() {
    try {
      this.chargesService.GetAll().subscribe((res) => {
        if (res && res.success) {
          this.chargeList = res.data;
        }
      });
    } catch (err) {
      console.error(err);
    }
  }

  onEnterAmount(event: any) {
    const amountRegex = /^\d{1,12}(\.\d{0,3})?$/;
    let inputValue = event.target.value;
    // Clear validators before validation
    const controlName = event.target.id === 'amountreceived' ? 'txtAmountReceived' : 'txtBalanceAmount';
    this.receiptForm.get(controlName).markAsUntouched();
    this.receiptForm.get(controlName).updateValueAndValidity();

    inputValue = inputValue.replace(/[^\d.]/g, '');

    if (inputValue && !amountRegex.test(inputValue)) {
      // Set custom validator and update validity status
      this.receiptForm.get(controlName).markAsTouched();
    }
  }

  bindUsers() {
    try {
      this.userManagementService.GetUserByGroup('fe,se', this.selectedSCId).subscribe((res) => {
        if (res && res.success) {
          const data = res.data;
          this.fieldExecutiveList = data.filter((item: any) => item.usergroupname === 'Field Executive');
          this.salesExecutiveList = data.filter((item: any) => item.usergroupname === 'Sales Executive');
        }
      })
    } catch (err) {
      console.error(err);
    }
  }

  onPerformaDataChange(updatedPerformaData: any[]) {
    this.performaList = updatedPerformaData;
  }


  downloadFile() {
    try {
      const fileDomainURL = this.utilities.getS3DownloadURL();
      let fileName = '';
      let downloadFileURL = '';
      let filePath = 'awb/AWB-Items.xlsx'; //need to change file her

      if (filePath) {
        fileName = filePath.substring(filePath.lastIndexOf('/') + 1);
      }

      downloadFileURL = `${fileDomainURL}${filePath}`;
      saveAs(downloadFileURL, fileName);
    } catch (e) {
      console.log(e);
    }
  }

  volumetricDetails(piecesfldDet?, isBulk: boolean = false) {
    if (isBulk) {
      piecesfldDet = this.piecesDetailsList[0];
      piecesfldDet?.controls?.length > 0 && piecesfldDet?.controls?.piecesvolumetricweight?.reset();
    }
    let totalVolumetricWeight = 0;
    const selectedCustomer = this.customerList.find(x => x.id === this.awbForm.get('ddlCustomer').value);
    const selectedProduct = this.productOptions.find(x => x.id === this.awbForm.get('ddlProduct').value);
    let division = 0;
    let cftValue: number = 1;
    if (this.volumetricList.length > 0) {
      const isInches = this.awbForm.get('ddlMeasurementUnit')?.value === 'Inches';
      division = (isInches ? this.volumetricList[0].inches : this.volumetricList[0].centimeter);
      cftValue = this.volumetricList[0].cft;
    } else {
      const isInches = this.awbForm.get('ddlMeasurementUnit')?.value === 'Inches';
      division = (isInches ? selectedProduct?.volumetricdivisor?.inches : selectedProduct?.volumetricdivisor?.centimeter) ?? (isInches ? MeasurementUnit.INCHES : MeasurementUnit.CENTIMETER);

    }

    if (!division) {
      this.openWarningDialog('Please select product');
      return;
    }

    if (selectedCustomer && selectedCustomer.cftvalue != null && selectedCustomer.cftvalue != undefined) {
      cftValue = Number(selectedCustomer.cftvalue);
    }
    this.awbForm.get('txtDivision').setValue(division);
    if (!piecesfldDet && !isBulk) {
      piecesfldDet = this.piecesDetailsList[0];
    }
    if (isBulk) {
      for (const container of this.containers.controls) {
        let pieceCount = container.get('piecescount').value || 0;
        let pieceslength = container.get('pieceslength').value || 0;
        let piecesbreadth = container.get('piecesbreadth').value || 0;
        let piecesheight = container.get('piecesheight').value || 0;
        const volumetric = (pieceslength * piecesbreadth * piecesheight * cftValue) / division;
        if (volumetric) {
          container.get('piecesvolumetricweight')?.setValue((parseFloat((pieceCount * volumetric).toString())).toFixed(3));
        }
      }
    }
    else {
      const pieceCount = parseFloat(piecesfldDet?.value?.piecescount || 0);
      const lengthValue = parseFloat(piecesfldDet?.value?.pieceslength || 0);
      const breadthValue = parseFloat(piecesfldDet?.value?.piecesbreadth || 0);
      const heightValue = parseFloat(piecesfldDet?.value?.piecesheight || 0);
      const volumetric = (lengthValue * breadthValue * heightValue * cftValue) / division;
      if (volumetric) {
        piecesfldDet.value.piecesvolumetricweight = parseFloat(volumetric > 0 ? (pieceCount * volumetric).toFixed(3) : piecesfldDet.volumetricweight > 0 ? piecesfldDet.volumetricweight : 0);
        piecesfldDet.controls.piecesvolumetricweight.setValue(piecesfldDet.value.piecesvolumetricweight);
      }
    }
    this.calculateWeightNew();
  }

  loadDefaultsChargesForm() {
    this.chargeForm.get('chargesdetails').patchValue({
      txtDescription: null,
      ddlItemFuel: 'No',
      ddlFuelTax: 'No',
      ddlTax: 'No',
    });
  }

  calculateWeightNew(index?: number) {
    let totalPieces = 0, totalActualWeight = 0, totalVolumetricWeight = 0, totalChargeableWeight = 0;
    for (const container of this.containers.controls) {
      // console.log('container', container);
      let pieceCount = container.get('piecescount').value || 0;
      let piecesactualweight = container.get('piecesactualweight').value || 0;
      let piecesvolumetricweight = container.get('piecesvolumetricweight').value || 0;
      let pieceschargeableweight = container.get('pieceschargeableweight').value || 0;
      let pieceslength = container.get('pieceslength').value || 0;
      let piecesbreadth = container.get('piecesbreadth').value || 0;
      let piecesheight = container.get('piecesheight').value || 0;
      if ((pieceslength * piecesbreadth * piecesheight) > 0) {
        container.get('piecesvolumetricweight').disable();
      }
      container.get('pieceschargeableweight').setValue((Math.max(pieceCount * piecesactualweight, piecesvolumetricweight)).toFixed(3));
      // console.log(pieceCount, piecesactualweight);
      totalPieces += pieceCount;
      totalActualWeight += parseFloat((pieceCount * piecesactualweight).toString());
      totalVolumetricWeight += parseFloat(piecesvolumetricweight);
    }
    // const isNotWeightValid = this.validateActualWeight(totalActualWeight);
    // if (isNotWeightValid) {
    //   const containerControl = this.containers?.controls[index];
    //   const volWeight = containerControl?.get('piecesvolumetricweight')?.value;
    //   containerControl?.get('piecesactualweight')?.reset();
    //   containerControl?.get('pieceschargeableweight')?.setValue(volWeight ?? '0');
    //   return this.warningDialog(isNotWeightValid);
    // }
    this.piecesForm.get('totalpieces').setValue(totalPieces);
    this.piecesForm.get('totalactualweight').setValue(totalActualWeight.toFixed(3));
    this.piecesForm.get('totalvolumetricweight').setValue(totalVolumetricWeight.toFixed(3));
    this.awbForm.get('forwardinginfo.txtVendorWeight').setValue(totalActualWeight.toFixed(3));
    this.awbForm.get('forwardinginfo.txtVendorWeight').markAsDirty();

    totalChargeableWeight = this.piecesForm.get('totalchargeableweight')?.value;
    this.piecesForm.get('totalchargeableweight').setValue(Math.max(+totalActualWeight.toFixed(3), +totalVolumetricWeight.toFixed(3)));

    // call getAWBCharges if totalchargeableweight's first vale differs from new one
    // totalChargeableWeight != this.piecesForm.get('totalchargeableweight')?.value && this.getAWBCharges(this.category.CUSTOMER);

  }

  async getAllVendorServices(data?: any): Promise<void> {
    const awbForm = this.awbForm;
    const isForwardingInfo = data === 'forwardinginfo';

    // Get vendor IDs based on the flag
    const vendorId = awbForm.get('ddlVendor')?.value;
    const deliveryVendorId = awbForm.get('forwardinginfo.ddlDeliveryVendor')?.value;
    const selectedVendorId = isForwardingInfo ? deliveryVendorId : vendorId;

    // Reset dropdowns based on the flag
    if (isForwardingInfo) {
      awbForm.get('forwardinginfo.ddlDeliveryService')?.reset();
    } else {
      awbForm.get('ddlService')?.reset();
    }

    if (selectedVendorId) {
      try {
        const res = await lastValueFrom(this.vendorService.GetAllListByVendor({ id: selectedVendorId }));

        if (res?.success) {
          if (isForwardingInfo) {
            // Bind delivery services
            this.deliveryServiceList = res.data;
          } else {
            // Bind vendor services
            this.serviceOptions = res.data;
            // if (this.serviceOptions?.length) {
            //   this.awbForm.get('ddlService')?.setValue(this.serviceOptions[0]?.id);
            // }
            // Apply customer-specific filtering
            const ud: any = this.appCoreService.GetUserData();
            if (ud?.accessType === "Customer") {
              this.customerService.getContractDetailById(this.customerContractId).subscribe((res) => {
                if (res?.success) {
                  const serviceList = res.data?.[0]?.additionaldetails?.[0]?.service;
                  if (serviceList?.length) {
                    const serviceCheckedList = serviceList.flatMap(item =>
                      item.service.map(servicecode => ({
                        code: item.vendor,
                        servicename: servicecode
                      }))
                    );

                    this.serviceOptions = this.serviceOptions.filter(service =>
                      serviceCheckedList.some(match =>
                        match.servicename === service.servicename && vendorId === service.vendorid
                      )
                    );
                  }
                }
              });
            }
          }
          this.getAWBCharges(isForwardingInfo ? RateCategory.VENDOR : RateCategory.CUSTOMER);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }

  bindPickupById(pickupNo: string) {
    this.ngxLoaderService.start();
    this.pickupService.GetByPickupNo(pickupNo).subscribe((res) => {
      // console.log("pickup", res);
      if (res) {
        this.ngxLoaderService.stop();
        if (res?.success) {
          // if (res.data[0].status !== 'Confirm') {
          //   return;
          // }
          this.awbForm.get('usedPickup').setValue(true);
          const awbForm = this.awbForm;
          const shipper = res.data[0]?.details.filter(x => x.type === 'Shipper');
          const consignee = res.data[0]?.details.filter(x => x.type === 'Consignee');

          // const shippername = shipper[0]?.info;
          // const consigneename = consignee?.length ? consignee[0]?.info : "";

          // console.log(shippername);
          awbForm.patchValue({
            ddlCustomer: res.data[0]?.customerid,
            // txtShipperName: shippername,
            // txtConsigneeName: consigneename //bind these in location 
          });

          //this.shipperLocationInfo = shipper.length ? (shipper[0].location == null ? {} : shipper[0].location) : {};
          this.shipperLocationInfo = {
            ...this.shipperLocationInfo,
            location: shipper[0].location ?? {},
            info: shipper[0].info
          }
          //this.consigneeLocationInfo = consignee.length ? (consignee[0].location == null ? {} : consignee[0].location) : {};
          this.consigneeLocationInfo = {
            ...this.consigneeLocationInfo,
            location: consignee[0].location ?? {},
            info: consignee[0].info
          }
        }
        else if (res?.data?.err_msg) {
          const msg = `<span>This pickup cannot be used to pre-populate the data as it is not confirmed yet.
                      </span><br><span>Either confirm the pickup once or enter the data manually.</span>`
          this.openErrorDialog(msg);
        }
      }
    });
  }

  numberValidate(event: KeyboardEvent): void {
    const val = (event.target as HTMLInputElement).value;
    if (event.keyCode !== 8 && event.keyCode !== 46 && event.keyCode !== 37 && event.keyCode !== 39 && val?.length >= 12) {
      event.preventDefault();
    }
    if (event.keyCode == 69 || event.keyCode == 107) {
      event.preventDefault();
    }
  }

  peformaNumberValidate(event: KeyboardEvent): void {
    const val = (event.target as HTMLInputElement).value;
    if (event.keyCode !== 8 && event.keyCode !== 46 && event.keyCode !== 37 && event.keyCode !== 39 && val?.length >= 30) {
      event.preventDefault();
    }
    if (event.keyCode == 69 || event.keyCode == 107) {
      event.preventDefault();
    }
  }

  bindInvoiceTerm() {
    try {
      this.miscService.GetAllInvoiceTerms().subscribe((res) => {
        // console.log("VdF",res);
        if (res && res.success) {
          this.invoiceTermOptions = res.data;
        }
      });
    } catch (err) {
      console.error(err);
    }
  }

  async getCustomerContract(customerId: number) {
    try {
      this.customerService.getContractDetailbyCustId(customerId).subscribe((res) => {
        if (res && res.success) {
          const data = res.data;
          const bookingdate = new Date(this.awbForm.get('txtDateTime')?.value);
          const bookingDateOnly = bookingdate.toISOString().split("T")[0];
          let formattedData = [];

          if (data && data.length > 0) {
            const availableContracts = data.filter(contract => {
              const fromDate = new Date(contract.fromdate.split('/').reverse().join('-'));

              const toDate = new Date(contract.todate.split('/').reverse().join('-'));

              const bookingDate = new Date(bookingDateOnly);

              return bookingDate >= fromDate && bookingDate <= toDate;
            });
            if (availableContracts && availableContracts.length > 0) {
              this.customerContractId = availableContracts[0].id;

              this.getContractInfo(this.customerContractId);
            }
          } else {

          }
        }
      });
    } catch (e) {
      console.error(e);
    }
  }

  getActiveContract(data: any[], bookingDate: string) {
    // Convert booking date to a Date object
    const bookingDateObj = new Date(bookingDate);

    return data.filter(contract => {
      const fromDate = new Date(contract.fromdate);
      const toDate = new Date(contract.todate);
      // Check if booking date falls in the range of fromdate and todate (inclusive)
      return bookingDateObj >= fromDate && bookingDateObj <= toDate;
    });
  }

  getContractInfo(id: any) {
    this.customerService.getContractDetailById(id).subscribe((res) => {
      if (res && res.success) {
        const data = res.data;
        // console.log('data', data);
        // console.log('productOptions', this.productOptions);
        const { origin, destination } = data?.[0]?.additionaldetails?.[0];
        this.conditionalCountryList = [{ type: 'origin', data: origin }, { type: 'destination', data: destination }];

        const filteredProductOptions = this.productOptions.filter(option =>
          data[0].additionaldetails[0].product.includes(option.code)
        );
        const filteredVendorOptions = this.vendorOptions.filter(option =>
          data[0].additionaldetails[0].vendor.includes(option.name)
        );
        // console.log('filteredProductOptions', filteredProductOptions)
        this.productOptions = filteredProductOptions;
        this.vendorOptions = filteredVendorOptions;
      } else {

      }
    });
  }


  bindShipperLocationOverSc() {
    this.networkService.GetServiceCentersById(this.selectedSCId).subscribe((res) => {
      if (res && res.success) {
        const location = res?.data[0]?.location;
        this.scLocationByIdObj = location;
        if (location) {
          // this.shipperLocationInfo = {
          //   ...this.shipperLocationInfo,
          //   country: location.country,
          //   state: location.state,
          //   city: location.city
          // }
          this.shipperLocationInfo = {
            ...this.shipperLocationInfo,
            location: {
              country: location.country,
              state: location.state,
              city: location.city
            }
          }
        }
      }
    })
  }

  async bindCustomerShipperInfo() {
    //this.getAWBCharges();
    const customerId = this.awbForm.get('ddlCustomer')?.value;
    const customerData: any = this.customerList.filter(x => x.id === customerId);
    const kycGSTRecord = customerData?.[0]?.kyc?.find(kyc => kyc.type === "GSTIN (Normal)");
    const kycRecord = kycGSTRecord ?? customerData?.[0]?.kyc?.[0];

    customerData[0]?.paymenttype ? this.awbForm.get("ddlPaymentType").setValue(customerData[0].paymenttype) : '';
    if (customerId && customerData[0]?.customertype !== "Co-Courier") {
      this.customerData = customerData;
      this.isShipperCustomerBinded = true;

      this.shipperLocationInfo = {
        ...this.shipperLocationInfo,
        location: customerData?.[0]?.location ?? {},
        info: {
          name: customerData?.[0]?.name,
          emailid: customerData?.[0]?.emailid,
          contactperson: customerData?.[0]?.contactperson
        }
      }

      this.awbForm.get('txtShipperIecIoeNo').setValue(kycRecord?.iecno);
      this.awbForm.get('ddlShipperDocumentType').setValue(kycRecord?.type);
      this.awbForm.get('txtShipperDocumentNo').setValue(kycRecord?.no);
    }
    // else {
    //   this.shipperLocationInfo = {};
    //   this.awbForm.get('shipperlocationdetails').patchValue({
    //     txtName: null,
    //     txtContactPerson: null,
    //     txtEmail: null,
    //   });

    // }

    this.getCustomerApplicableTax();
    this.getAWBCharges(RateCategory.CUSTOMER);
    // this.volumetricDetails();
    /*if customer change 
      -get enrolled companies with that customer, if list.length then modify this.companyList : else this.companyList 
    */
    //customers having companies --> take companyids
    // this.awbForm.get('ddlCompanies').reset();

    const filteredCompanyList = this.respCompanyList.filter(company => customerData[0]?.companyids?.includes(company.id));
    this.companyList = filteredCompanyList;
    if (filteredCompanyList.length) {
      let selectedCompany = this.companyList?.length == 1 ? this.companyList[0].id : null;
      this.awbForm.get('ddlCompanies').setValue(selectedCompany);
    }

    if (!customerId) {
      let defaultCompany = this.companyList.filter(x => x.isdefault)[0]?.id || null;
      // this.awbForm.get('ddlCompanies').setValue(defaultCompany);
    }

    if (filteredCompanyList?.length) {
      if (filteredCompanyList?.length == 1) {
        // this.awbForm.get('ddlCompanies').setValue(filteredCompanyList[0].id);
      } else {
        //if it is default company then select it 
        // this.companyList.filter(x => x.isdefault).length ? this.awbForm.get('ddlCompanies').setValue(this.companyList[0]?.id) : this.companyList;
        // this.companyList = filteredCompanyList?.length > 1 ? filteredCompanyList : this.respCompanyList;
      }
    } else {
      this.companyList = this.respCompanyList;
    }
  }

  bindVendors() {
    try {
      this.vendorService.GetAll({ isactive: true }).subscribe((res) => {
        if (res && res.success) {
          this.vendorOptions = res.data;
          this.deliveryVendorList = res.data;
        }
      });
    } catch (err) {
      console.error(err);
    }
  }

  async bindProducts() {
    try {
      this.productService.GetAll({ isactive: true }).subscribe((res) => {
        if (res && res.success) {
          this.productOptions = res.data;
          this.resProductOptions = res.data;
          this.deliveryProductList = res.data;
          // console.log(" ProductOptions", this.productOptions)
        }
      });
    } catch (err) {
      console.error(err);
    }
  }

  getPincodeOdaDetails() {
    try {
      const pincodedata = this.awbForm.get('consigneelocationdetails.txtPincode').value;
      const data = this.awbForm.get('ddlChargeType').value;
      const reqObj = {
        customerid: this.awbForm.get('ddlCustomer').value,
        vendorid: this.awbForm.get('ddlVendor').value,
        pincode: pincodedata?.pincode,
        countryisocode: this.awbForm.get('consigneelocationdetails.ddlCountry').value,
        stateisocode: this.awbForm.get('consigneelocationdetails.ddlState').value,
        cityisocode: this.awbForm.get('consigneelocationdetails.ddlCity').value,
      }
      this.chargesService.IsExist_ODA(reqObj).subscribe((res) => {
        if (res && res.success) {
          res.data[0]?.isoda ? this.awbForm.get('ddlChargeType').setValue([...data, "ODA"]) : null;
        }
      });
    } catch (error) {
      console.error(error);
    }
  }

  focusFirstInvalidField(formGroup: FormGroup) {
    setTimeout(() => {
      if (!formGroup) return;

      // Find the first form control that is invalid
      const firstInvalidControl = document.querySelector('.ng-invalid');
      // block start find the first invalid field to focus it
      if (firstInvalidControl) {
        firstInvalidControl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        (firstInvalidControl as HTMLElement).focus();
      }
    });
  };

  async addAwb() {
    this.isFormSubmitted = true;
    const awbForm = this.awbForm;
    // const isCreditAvilable = await this.checkAndBindAvailableCredit();
    //if (!isCreditAvilable) return this.openErrorDialog('No credit balance available.');
    let invalidContainers = [];
    const invalidIndexes: number[] = [];
    this.containers.controls.forEach((container, i) => {
      if (!container.get('piecesactualweight').valid) {
        invalidContainers.push(`Weight or volumetric info missing at container ${i + 1}`);
        invalidIndexes.push(i);  // Store the invalid index

        // navigate to the first invalid field
        this.activeTabId = 1;
        this.focusTabField(this.measurementUnit);
      }
    });

    //console.log(invalidContainers);
    if (invalidContainers.length) {
      await this.openWarningDialog(invalidContainers.join(','));
      if (invalidIndexes.length) {
        setTimeout(() => {
          const invalidField = this.piecesActualWeightInputs?.toArray().find(field =>
            field.nativeElement.classList.contains('ng-invalid')
          );

          if (invalidField) {
            invalidField.nativeElement.focus();
          }
        }, 300);
      }
      return;
    }

    if (this.serviceConfig.proforma.detailsmandatory) {
      let list: any[] = [];
      let invalidIndexes: number[] = [];
      const pieces = this.piecesForm.get('containers').value;

      for (let i = 0; i < pieces.length; i++) {
        const subitem = this.subItem(i);
        if (!subitem.length) {
          list.push(`Piece No ${i + 1}`);
          invalidIndexes.push(i);
        }
      }

      if (list.length) {
        let msg = `<span><label>Please provide at least one Item Detail for the following Pieces:</label><br><label>${list.join(', ')}</label></span>`;
        await this.warningDialog(msg);

        if (invalidIndexes.length) {
          // Expand first invalid row
          this.toggleRowExpansion(invalidIndexes[0]);
          setTimeout(() => {
            // Find and focus on the first available input
            const descriptionInput = this.descriptionRefs.first;
            if (descriptionInput) {
              descriptionInput.nativeElement.focus();
            }
          }, 300);
        }
        return;
      }
    }


    if (this.tabPermission.kyc && this.serviceConfig.proforma.documentrequired) {
      const isexist = this.kycList?.find((item: any) => item.type == "Proforma Invoice");
      if (!isexist || !this.kycList.length) {
        this.openWarningDialog('Kindly attach Proforma Invoice in KYC.');
        return;
      }
    }

    const totalActualWeight = this.piecesForm.get('totalactualweight')?.value;;
    const isNotWeightValid = this.validateActualWeight(totalActualWeight)
    if (isNotWeightValid) {
      return this.warningDialog(isNotWeightValid);
    }
    //// Check if the control is invalid
    // Object.keys(this.awbForm.controls).forEach(key => {
    //   const control = this.awbForm.controls[key];`
    //   if (control.invalid) {
    //     // console.log(`${ key } control is invalid`);
    //   }
    // });

    if (awbForm.invalid) {
      // Get the list of invalid controls
      this.focusFirstInvalidField(this.awbForm);
      const invalidControls = Object.keys(awbForm.controls).filter(controlName => awbForm.controls[controlName].invalid);
      // console.log('Invalid controls:', invalidControls);
      return;
    }

    if (awbForm.valid) {
      //check for GSTIN validation 
      if (this.kycList?.length) {
        const originStateIsocode = this.awbForm.get('shipperlocationdetails.ddlState')?.value;
        const originStatetaxCode = this.originStateList?.find(row => row.isocode === originStateIsocode)?.taxcode;
        const gstStateCode = this.kycList?.find(doc => doc?.type === 'GSTIN (Normal)')?.no?.slice(0, 2);

        if (originStateIsocode && gstStateCode && gstStateCode !== originStatetaxCode) {
          return this.appCoreService.showMessage('Invalid GSTIN Format for Selected KYC.', '', 'error');
        }
      }

      if (Number(this.piecesForm.get('totalactualweight').value) === 0) {
        this.focusFirstActualWeight();
        return this.openWarningDialog('Actual weight cannot be 0 or empty.');
      }

      this.loadDefaultsChargesForm();
      let details = [], csbDetails: any, buyerDetails: any;
      let proformaForm = this.proformaForm;
      // let chargeForm = this.chargeForm;
      let shipmentinfo = awbForm.get('shipmentinfo');
      let forwardinginfo = awbForm.get('forwardinginfo');
      let shipperlocation = awbForm.get('shipperlocationdetails');
      let consigneelocation = awbForm.get('consigneelocationdetails');
      this.piecesForm.get('measurementunit').setValue(awbForm.get('ddlMeasurementUnit')?.value);

      let shipper = shipperlocation.get('txtName').value;
      shipper = (typeof shipper === 'string') ? shipper : shipper?.name;

      let consignee = consigneelocation.get('txtName').value;
      consignee = (typeof consignee === 'string') ? consignee : consignee?.name;

      this.insertIntoFinalList();

      const shipperNameValue: any = this.awbForm.get('shipperlocationdetails.txtName')?.value;
      let shipperName = shipperNameValue ? (typeof shipperNameValue === 'string' ? shipperNameValue?.toUpperCase()?.trim() : shipperNameValue?.name?.toUpperCase()) : null;
      let shipperArea = shipperlocation.get('txtArea').value;
      shipperArea = shipperArea ? (typeof shipperArea === 'string' ? shipperArea : shipperArea?.area) : null;
      let shipperPincode = shipperlocation.get('txtPincode')?.value;
      shipperPincode = shipperPincode ? (typeof shipperPincode === 'string' ? shipperPincode : shipperPincode?.pincode) : null;

      const consigneeNameValue: any = this.awbForm.get('consigneelocationdetails.txtName')?.value;
      let consigneeName = shipperNameValue ? (typeof consigneeNameValue === 'string' ? consigneeNameValue?.toUpperCase()?.trim() : consigneeNameValue?.name?.toUpperCase()) : null;
      let consigneeArea = consigneelocation.get('txtArea').value;
      consigneeArea = consigneeArea? (typeof consigneeArea === 'string' ? consigneeArea : consigneeArea?.area): null;
      let consigneePincode = consigneelocation.get('txtPincode')?.value;
      consigneePincode = consigneePincode? (typeof consigneePincode === 'string' ? consigneePincode : consigneePincode?.pincode): null;

      // get address book details
      details.push({
        info: {
          name: shipperName,
          type: 'Shipper',
          contactperson: shipperlocation.get('txtContactPerson')?.value?.trim()?.toUpperCase(),
          emailid: shipperlocation.get('txtEmail')?.value?.trim()?.toUpperCase(),
          location: {
            country: shipperlocation.get('ddlCountry')?.value,
            countrycode: this.originCountryList.find(x => x.isocode === shipperlocation.get('ddlCountry')?.value)?.code,
            state: shipperlocation.get('ddlState')?.value,
            statecode: this.originStateList.find(x => x.isocode === shipperlocation.get('ddlState')?.value)?.code,
            city: shipperlocation.get('ddlCity')?.value,
            citycode: this.originCityList.find(x => x.isocode === shipperlocation.get('ddlCity')?.value)?.code,
            pincode: shipperPincode,
            address1: shipperlocation.get('txtAddress1')?.value?.trim()?.toUpperCase(),
            address2: shipperlocation.get('txtAddress2')?.value?.trim()?.toUpperCase(),
            mobileno: shipperlocation.get('txtMobileNo')?.value,
            tel: shipperlocation.get('txtTelephoneNo')?.value,
            area: shipperArea?.trim()?.toUpperCase()
          },
          iecno: this.awbForm.get('txtShipperIecIoeNo')?.value?.trim()?.toUpperCase(),
          kyc: {
            type: this.awbForm.get('ddlShipperDocumentType')?.value,
            no: this.awbForm.get('txtShipperDocumentNo')?.value
          },
          generatedby: this.appCoreService.GetUserData().accessType,
          generatedfromid: this.appCoreService.GetUserData().selectedServiceCenter,
          customerid: this.appCoreService.GetUserData().metaInfo.customerid
        },
      });

      details.push({
        info: {
          type: 'Consignee',
          name: consigneeName,
          contactperson: consigneelocation.get('txtContactPerson')?.value?.trim()?.toUpperCase(),
          emailid: consigneelocation.get('txtEmail')?.value?.trim()?.toUpperCase(),
          location: {
            country: consigneelocation.get('ddlCountry')?.value,
            countrycode: this.destinationCountryList.find(x => x.isocode === consigneelocation.get('ddlCountry')?.value)?.code,
            state: consigneelocation.get('ddlState')?.value,
            statecode: this.destinationStateList.find(x => x.isocode === consigneelocation.get('ddlState')?.value)?.code,
            city: consigneelocation.get('ddlCity')?.value,
            citycode: this.destinationCityList.find(x => x.isocode === consigneelocation.get('ddlCity')?.value)?.code,
            pincode: consigneePincode,
            address1: consigneelocation.get('txtAddress1')?.value?.trim()?.toUpperCase(),
            address2: consigneelocation.get('txtAddress2')?.value?.trim()?.toUpperCase(),
            mobileno: consigneelocation.get('txtMobileNo')?.value,
            tel: consigneelocation.get('txtTelephoneNo')?.value,
            area: consigneeArea? consigneeArea?.trim()?.toUpperCase(): null
          },
          iecno: awbForm.get('txtConsigneeIecIoeNo')?.value?.trim()?.toUpperCase(),
          kyc: {
            type: this.awbForm.get('ddlConsigneeDocumentType')?.value,
            no: this.awbForm.get('txtConsigneeDocumentNo')?.value
          },
          generatedby: this.appCoreService.GetUserData().accessType,
          generatedfromid: this.appCoreService.GetUserData().selectedServiceCenter,
          customerid: this.appCoreService.GetUserData().metaInfo.customerid
        },
      });

      if (this.isCsbType) {
        csbDetails = {
          lut: proformaForm.get('csbDetails.ddlLutIgst')?.value,
          totalisgt: proformaForm.get('csbDetails.txtTotalIgst')?.value,
          bankadcode: proformaForm.get('csbDetails.txtBankAdCode')?.value,
          bankaccount: proformaForm.get('csbDetails.txtBankAccount')?.value,
          bankifsc: proformaForm.get('csbDetails.txtBankIfsc')?.value,
          lutbondno: proformaForm.get('csbDetails.txtLutBondNo')?.value,
          exchangerate: proformaForm.get('csbDetails.txtExchangeRate')?.value,
          firm: proformaForm.get('csbDetails.ddlFirm')?.value,
          nfei: proformaForm.get('csbDetails.nfeiCheck')?.value,
          payofigst: proformaForm.get('csbDetails.payOfIgstCheck')?.value,
          ecommerce: proformaForm.get('csbDetails.eCommerceCheck')?.value,
          meisschema: proformaForm.get('csbDetails.meisSchemaCheck')?.value,
        }
      }

      if (Number(this.customerData?.igst) && (Number(this.customerData?.sgst) || Number(this.customerData?.sgst))) {
        this.openWarningDialog(`Entry cannot contains [IGST] or [CGST/SGST] at a time.`);
        return;
      }

      if (this.isAwbBuyerDetailsChk) {
        buyerDetails = {
          name: proformaForm.get('buyerDetails.txtName')?.value,
          contactperson: proformaForm.get('buyerDetails.txtPerson')?.value,
          email: proformaForm.get('buyerDetails.txtEmail')?.value,
          iecno: proformaForm.get('buyerDetails.txtIECNo')?.value,
          address: proformaForm.get('buyerDetails.txtAddress')?.value,
        }
      }

      const shipperlocationdetails = this.awbForm.get('shipperlocationdetails');
      const consigneelocationdetails = this.awbForm.get('consigneelocationdetails');

      const brockerPincode = this.specialServicesForm.get('bsoBrokerlocationdetails.txtPincode')?.value;
      const brockerArea = this.specialServicesForm.get('bsoBrokerlocationdetails.txtArea')?.value;
      const reqObj = {
        mode: 'awb',
        generatedfromid: this.selectedSCId,
        awbnumber: awbForm.get('txtAwbNo')?.value,
        customerid: awbForm.get('ddlCustomer')?.value,
        companyid: awbForm.get('ddlCompanies')?.value,
        referenceno: awbForm.get('txtReferenceNo')?.value,
        frompickup: awbForm.get('usedPickup')?.value,
        bookingdate: awbForm.get('txtDateTime')?.value,
        productid: awbForm.get('ddlProduct')?.value,
        vendorid: awbForm.get('ddlVendor')?.value,
        serviceid: awbForm.get('ddlService')?.value,
        shipmentvalue: awbForm.get('txtShipmentValue')?.value,
        currencycode: awbForm.get('ddlCurrency')?.value,

        chargetypes: awbForm.get('ddlChargeType')?.value,
        paymenttype: awbForm.get('ddlPaymentType')?.value,

        details: details,
        pieces: this.piecesForm.getRawValue(),
        piecesupdates: this.piecesForm.dirty,
        proforma: {
          updates: this.proformaForm.dirty,
          awbnumber: awbForm.get('txtAwbNo')?.value,
          csbtype: proformaForm.get('ddlCSBType')?.value,
          termofinvoice: proformaForm.get('ddlInvoiceTerm')?.value,
          isgstinvoice: proformaForm.get('ddlGSTInvoice')?.value === 'Yes' ? true : false,
          commercialinvoiceno: proformaForm.get('txtCommercialInvoiceNo')?.value,
          invoicedate: proformaForm.get('ddlInvoiceDate')?.value,
          exportreason: proformaForm.get('ddlExportReason')?.value,
          departmentno: proformaForm.get('txtDepartmentNo')?.value,
          csbdetails: csbDetails,
          awbbuyerdetails: buyerDetails
        },
        charges: {
          updates: this.chargeForm.dirty || this.customerRowData?.length > 0,
          // updates: true,
          chargetype: this.customerRowData?.[0]?.chargetype || 'Customer',
          contractchargesamount: this.customerData?.contractcharges,
          otherchargesamount: this.customerData?.othercharges,
          subtotal: this.customerData?.subtotal,
          totalfuel: this.customerData?.totalfuel,
          taxes: {
            type: 'gst',
            tax: {
              igst: this.customerData?.igst,
              cgst: this.customerData?.cgst,
              sgst: this.customerData?.sgst,
            }
          },
          totalamount: this.customerData?.totalamount,
          chargesdetails: this.customerRowData,
        },
        shipmentdetails: {
          updates: shipmentinfo.dirty || this.specialServicesForm.dirty,
          awbnumber: awbForm.get('txtAwbNo')?.value,
          fieldexecutive: shipmentinfo.get('ddlFieldExecutive')?.value,
          salesexecutive: shipmentinfo.get('ddlSalesExecutive')?.value,
          expecteddeliverydate: shipmentinfo.get('txtExpectedDeliveryDate')?.value,
          masterawbno: shipmentinfo.get('txtMasterAwbNo')?.value,
          runno: shipmentinfo.get('txtRunNo')?.value,
          specialinstructions: shipmentinfo.get('txtSpecialInstruction')?.value,
          specialservicesdetail: {
            isdangerousgoods: this.specialServicesForm.get('dangerousGoodsCheck')?.value === 'No' ? false : true,
            goodstype: this.specialServicesForm.get('ddldangerousGoods')?.value,
            isdryice: this.specialServicesForm.get('dryIceCheck')?.value === 'No' ? false : true,
            dryiceweight: this.specialServicesForm.get('txtDryIceWeight')?.value || 0,
            bookingconfirmationno: this.specialServicesForm.get('txtBookingConfirmationNo')?.value,
            isinsurancecovered: this.specialServicesForm.get('insuranceCoverCheck')?.value === 'No' ? false : true,
            insurancecovervalue: this.specialServicesForm.get('txtInsuranceCoverValue')?.value || 0,
            billshipmentto: {
              type: this.specialServicesForm.get('ddlbillShipmentTo')?.value,
              accountno: this.specialServicesForm.get('txtBillShipmentToAccNo')?.value
            },
            taxdutypaidby: {
              type: this.specialServicesForm.get('ddlTaxAndDutiesPaidBy')?.value,
              accountno: this.specialServicesForm.get('txtTaxAndDutiesAccNo')?.value
            },
            outputformat: this.specialServicesForm.get('ddlOutputFormat')?.value,
            brokerdetails: {
              enabled: this.specialServicesForm.get('bsoBrokerCheck')?.value,
              country: this.specialServicesForm.get('bsoBrokerlocationdetails.ddlCountry')?.value,
              state: this.specialServicesForm.get('bsoBrokerlocationdetails.ddlState')?.value,
              city: this.specialServicesForm.get('bsoBrokerlocationdetails.ddlCity')?.value,
              pincode: typeof brockerPincode === 'string' ? brockerPincode : brockerPincode?.pincode,
              address1: this.specialServicesForm.get('bsoBrokerlocationdetails.txtAddress1')?.value,
              address2: this.specialServicesForm.get('bsoBrokerlocationdetails.txtAddress2')?.value,
              area: typeof brockerArea === 'string' ? brockerArea : brockerArea?.area,
              mobileno: this.specialServicesForm.get('bsoBrokerlocationdetails.txtMobileNo')?.value,
              tel: this.specialServicesForm.get('bsoBrokerlocationdetails.txtTelephoneNo')?.value
            }
          },
        },
        forwardingdetails: {
          updates: forwardinginfo.dirty || this.vendorRowData?.length > 0,
          awbnumber: awbForm.get('txtAwbNo')?.value,
          deliveryawbno: forwardinginfo.get('txtDeliveryAwb')?.value,
          forwardingawbno: forwardinginfo.get('txtForwardingAwb')?.value,
          deliveryproduct: forwardinginfo.get('ddlDeliveryProduct')?.value,
          deliveryvendor: forwardinginfo.get('ddlDeliveryVendor')?.value,
          deliveryservice: forwardinginfo.get('ddlDeliveryService')?.value,
          deliveryweight: forwardinginfo.get('txtVendorWeight')?.value,
          deliveryinvoice: forwardinginfo.get('txtVendorInvoiceNo')?.value,
          charges: {
            chargetype: this.vendorRowData?.[0]?.chargetype,
            contractchargesamount: this.vendorData?.contractcharges,
            otherchargesamount: this.vendorData?.othercharges,
            subtotal: this.vendorData?.subtotal,
            totalfuel: this.vendorData?.totalfuel,
            igst: this.vendorData?.igst,
            cgst: this.vendorData?.cgst,
            sgst: this.vendorData?.sgst,
            totalamount: this.vendorData?.totalamount,
            chargesdetails: this.vendorRowData
          }
        },
        kyc: this.kycList,
        receipt: {
          updates: this.receiptForm.dirty,
          receiptItems: this.receiptList
        },
        productcode: this.productOptions.find(x => x.id === awbForm.get('ddlProduct')?.value).code,
        vendorcode: this.vendorOptions.find(x => x.id === awbForm.get('ddlVendor')?.value).code,

        origincountrycode: this.originCountryList.filter(x => x.isocode === shipperlocationdetails.get('ddlCountry').value)[0]?.code,
        originstatecode: this.originStateList.filter(x => x.isocode === shipperlocationdetails.get('ddlState').value)[0]?.code,
        origincitycode: this.originCityList.filter(x => x.isocode === shipperlocationdetails.get('ddlCity').value)[0]?.code,
        originpincode: shipperPincode || null,

        destinationcontrycode: this.destinationCountryList.filter(x => x.isocode === consigneelocationdetails.get('ddlCountry').value)[0]?.code,
        destinationstatecode: this.destinationStateList.filter(x => x.isocode === consigneelocationdetails.get('ddlState').value)[0]?.code,
        destinationcitycode: this.destinationCityList.filter(x => x.isocode === consigneelocationdetails.get('ddlCity').value)[0]?.code,
        consigneepincode: consigneePincode || null,
      };

      let requestObject = {
        generatedfromid: this.selectedSCId,
        awbnumber: awbForm.get('txtAwbNo')?.value,
        customerid: awbForm.get('ddlCustomer')?.value,
        companyid: awbForm.get('ddlCompanies')?.value,
        referenceno: awbForm.get('txtReferenceNo')?.value,
        frompickup: awbForm.get('usedPickup')?.value,
        bookingdate: awbForm.get('txtDateTime')?.value,
        productid: awbForm.get('ddlProduct')?.value,
        productcode: this.productOptions.find(x => x.id === awbForm.get('ddlProduct')?.value).code,
        vendorid: awbForm.get('ddlVendor')?.value,
        vendorcode: this.vendorOptions.find(x => x.id === awbForm.get('ddlVendor')?.value).code,
        serviceid: awbForm.get('ddlService')?.value,
        shipmentvalue: awbForm.get('txtShipmentValue')?.value,
        currencycode: awbForm.get('ddlCurrency')?.value,

        chargetypes: awbForm.get('ddlChargeType')?.value,
        paymenttype: awbForm.get('ddlPaymentType')?.value,
      };

      let awbRequestObject = {
        mode: 'awb',
        details: details,
      };

      let piecesRequestObject = {
        mode: 'pieces',
        id: null,
        pieces: this.piecesForm.getRawValue(),
        piecesupdates: this.piecesForm.dirty,
      };

      let proformaRequestObject = {
        mode: 'proforma',
        id: null,
        proforma: {
          updates: this.proformaForm.dirty,
          awbnumber: awbForm.get('txtAwbNo')?.value,
          csbtype: proformaForm.get('ddlCSBType')?.value,
          termofinvoice: proformaForm.get('ddlInvoiceTerm')?.value,
          isgstinvoice: proformaForm.get('ddlGSTInvoice')?.value === 'Yes' ? true : false,
          commercialinvoiceno: proformaForm.get('txtCommercialInvoiceNo')?.value,
          invoicedate: proformaForm.get('ddlInvoiceDate')?.value,
          exportreason: proformaForm.get('ddlExportReason')?.value,
          departmentno: proformaForm.get('txtDepartmentNo')?.value,
          csbdetails: csbDetails,
          awbbuyerdetails: buyerDetails
        }
      };

      let chargesRequestObject = {
        mode: 'charges',
        id: null,
        charges: {
          updates: true,
          chargetype: this.customerRowData[0]?.chargetype || 'Customer',
          contractchargesamount: this.customerData?.contractcharges,
          otherchargesamount: this.customerData?.othercharges,
          subtotal: this.customerData?.subtotal,
          totalfuel: this.customerData?.totalfuel,
          taxes: {
            type: 'gst',
            tax: {
              igst: this.customerData?.igst,
              cgst: this.customerData?.cgst,
              sgst: this.customerData?.sgst,
            }
          },
          totalamount: this.customerData?.totalamount,
          chargesdetails: this.customerRowData,
        },
      };

      let shipmentRequestObject = {
        mode: 'shipment',
        id: null,
        details: details,
        shipmentdetails: {
          updates: shipmentinfo.dirty || this.specialServicesForm.dirty,
          awbnumber: awbForm.get('txtAwbNo')?.value,
          fieldexecutive: shipmentinfo.get('ddlFieldExecutive')?.value,
          salesexecutive: shipmentinfo.get('ddlSalesExecutive')?.value,
          expecteddeliverydate: shipmentinfo.get('txtExpectedDeliveryDate')?.value,
          masterawbno: shipmentinfo.get('txtMasterAwbNo')?.value,
          runno: shipmentinfo.get('txtRunNo')?.value,
          specialinstructions: shipmentinfo.get('txtSpecialInstruction')?.value,
          specialservicesdetail: {
            isdangerousgoods: this.specialServicesForm.get('dangerousGoodsCheck')?.value === 'No' ? false : true,
            goodstype: this.specialServicesForm.get('ddldangerousGoods')?.value,
            isdryice: this.specialServicesForm.get('dryIceCheck')?.value === 'No' ? false : true,
            dryiceweight: this.specialServicesForm.get('txtDryIceWeight')?.value || 0,
            bookingconfirmationno: this.specialServicesForm.get('txtBookingConfirmationNo')?.value,
            isinsurancecovered: this.specialServicesForm.get('insuranceCoverCheck')?.value === 'No' ? false : true,
            insurancecovervalue: this.specialServicesForm.get('txtInsuranceCoverValue')?.value || 0,
            billshipmentto: {
              type: this.specialServicesForm.get('ddlbillShipmentTo')?.value,
              accountno: this.specialServicesForm.get('txtBillShipmentToAccNo')?.value
            },
            taxdutypaidby: {
              type: this.specialServicesForm.get('ddlTaxAndDutiesPaidBy')?.value,
              accountno: this.specialServicesForm.get('txtTaxAndDutiesAccNo')?.value
            },
            outputformat: this.specialServicesForm.get('ddlOutputFormat')?.value,
            brokerdetails: {
              enabled: this.specialServicesForm.get('bsoBrokerCheck')?.value,
              country: this.specialServicesForm.get('bsoBrokerlocationdetails.ddlCountry')?.value,
              state: this.specialServicesForm.get('bsoBrokerlocationdetails.ddlState')?.value,
              city: this.specialServicesForm.get('bsoBrokerlocationdetails.ddlCity')?.value,
              pincode: typeof brockerPincode === 'string' ? brockerPincode : brockerPincode?.pincode,
              address1: this.specialServicesForm.get('bsoBrokerlocationdetails.txtAddress1')?.value,
              address2: this.specialServicesForm.get('bsoBrokerlocationdetails.txtAddress2')?.value,
              area: typeof brockerArea === 'string' ? brockerArea : brockerArea?.area,
              mobileno: this.specialServicesForm.get('bsoBrokerlocationdetails.txtMobileNo')?.value,
              tel: this.specialServicesForm.get('bsoBrokerlocationdetails.txtTelephoneNo')?.value
            }
          },
        },
      };

      let forwardingRequestObject = {
        mode: 'forwarding',
        id: null,
        forwardingdetails: {
          updates: forwardinginfo.dirty || this.vendorRowData?.length > 0,
          awbnumber: awbForm.get('txtAwbNo')?.value,
          deliveryawbno: forwardinginfo.get('txtDeliveryAwb')?.value,
          forwardingawbno: forwardinginfo.get('txtForwardingAwb')?.value,
          deliveryproduct: forwardinginfo.get('ddlDeliveryProduct')?.value,
          deliveryvendor: forwardinginfo.get('ddlDeliveryVendor')?.value,
          deliveryservice: forwardinginfo.get('ddlDeliveryService')?.value,
          deliveryweight: forwardinginfo.get('txtVendorWeight')?.value,
          deliveryinvoice: forwardinginfo.get('txtVendorInvoiceNo')?.value,
          charges: {
            chargetype: this.vendorRowData[0]?.chargetype,
            contractchargesamount: this.vendorData?.contractcharges,
            otherchargesamount: this.vendorData?.othercharges,
            subtotal: this.vendorData?.subtotal,
            totalfuel: this.vendorData?.totalfuel,
            igst: this.vendorData?.igst,
            cgst: this.vendorData?.cgst,
            sgst: this.vendorData?.sgst,
            totalamount: this.vendorData?.totalamount,
            chargesdetails: this.vendorRowData
          }
        },
      };

      let kycRequestObject = {
        mode: 'kyc',
        id: null,
        kyc: this.kycList,
      };

      let receiptRequestObject = {
        mode: 'receipt',
        id: null,
        receipt: {
          updates: this.receiptForm.dirty,
          receiptItems: this.receiptList
        },
      };

      // console.log('requestObject', requestObject);
      // console.log('awbRequestObject', awbRequestObject);

      //check credit limit
      // console.log("req", reqObj);
      if (this.isCreditControlChecked) {
        const isCreditLimitRemain = await this.checkCreditLimit(reqObj);
        if (!isCreditLimitRemain) return this.ngxLoaderService.stop();
      };
      if (this.permConfig.isAddAllowed && awbForm.valid) {
        this.ngxLoaderService.start();
        // console.log("reqobj : ", reqObj.details);
        this.awbService.AddAWB({ ...requestObject, ...awbRequestObject }).subscribe(async (res) => {
          if (res && res.success) {
            // this.ngxLoaderService.stop();
            // console.log(res);

            let awbNumber = res?.data[0].awbnumber;

            let awbId = res?.data[0].id;
            // update request objects
            requestObject.awbnumber = awbNumber;
            piecesRequestObject.id = awbId;
            proformaRequestObject.id = awbId;
            chargesRequestObject.id = awbId;
            shipmentRequestObject.id = awbId;
            forwardingRequestObject.id = awbId;
            kycRequestObject.id = awbId;
            receiptRequestObject.id = awbId;

            let errorMsg: string = '', msg: string = '';

            if (res?.data?.apiResponse?.error) {
              errorMsg = res?.data?.apiResponse.message;
            }

            if (awbNumber) {
              const stringValue = this.getOptionsHtml();

              this.inscanAWB = awbNumber;
              this.lastAWBNo = awbNumber;
              let awbVendorApiRequestObject = {
                mode: 'shipmentapi',
                awbnumber: awbNumber
              };

              forkJoin({
                awbpieces: this.awbService.AddAWB({ ...requestObject, ...piecesRequestObject }).pipe(catchError(() => of(null))),
                awbproforma: this.awbService.AddAWB({ ...requestObject, ...proformaRequestObject }).pipe(catchError(() => of(null))),
                awbcharges: this.awbService.AddAWB({ ...requestObject, ...chargesRequestObject }).pipe(catchError(() => of(null))),
                awbshipment: this.awbService.AddAWB({ ...requestObject, ...shipmentRequestObject }).pipe(catchError(() => of(null))),
                awbforwarding: this.awbService.AddAWB({ ...requestObject, ...forwardingRequestObject }).pipe(catchError(() => of(null))),
                awbkyc: this.awbService.AddAWB({ ...requestObject, ...kycRequestObject }).pipe(catchError(() => of(null))),
                awbreceipt: this.awbService.AddAWB({ ...requestObject, ...receiptRequestObject }).pipe(catchError(() => of(null))),
                vendorapi: this.awbService.AddAWB({ ...awbVendorApiRequestObject }).pipe(catchError(() => of(null))),
              }).subscribe(async res => {
                // console.log("res", res);
                this.ngxLoaderService.stop();
                const allSuccessful = Object.values(res).every(val => val !== null);
                // console.log("allSuccessful", allSuccessful);
                if (allSuccessful) {
                  const message = res.vendorapi?.data?.apiResponse?.MESSAGE;
                  const errorBlock = message ? `<br>Api Response : ${message}<br><br>` : '';

                  msg = `AWB no. <b>${awbNumber}</b> Created Successfully <br>
                      ${errorBlock}
                      <div style="display: flex;align-items: center;gap: 8px;margin-bottom: 15px;justify-content: center;margin-top: 10px;">
                          <input type="checkbox" id="inscanCheckbox" style="width:18px; height:18px">
                          <label for="inscanCheckbox" style="margin-bottom: auto;">Inscan this shipment</label>
                      </div>
                      <select id="pickedByWhom" class="swal2-select" style="margin: 0px 0px 0px 5px !important;width: 78%;">
                          <option value="" selected>Select to assign field executive</option>
                          ${stringValue}
                      </select>`;

                  this.openSuccessConfirmationDialog(msg, awbNumber);
                  setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }, 500);
                }
                else {
                  this.appCoreService.showMessage('Some Error Occured. Please Try again.', '', 'error');
                }
              });
            }

          }
          if (res && !res.success) {
            this.ngxLoaderService.stop();
            this.openWarningDialog(res.message);
          }
        });
      }
    }
  }

  async AddVendorAPI(awbnumber: any): Promise<any> {
    let awbRequestObject = {
      mode: 'shipmentapi',
      awbnumber: awbnumber
    };

    // Now returning the observable
    return this.awbService.AddAWB(awbRequestObject).pipe(
      map((res) => {
        // console.log("from vendor", res);

        if (res && res.success) {
          return res?.data?.apiResponse;  // Return the apiResponse
        } else {
          // Handle the case where the response does not contain success
          throw new Error('Request failed');
        }
      })
    ).toPromise();  // Converts the observable to a promise
  }


  async checkCreditLimit(creditInitials: any) {
    const creditObj = {
      totalamount: parseFloat(creditInitials?.charges?.totalamount),
      customerid: creditInitials?.customerid || null,
      servicecenterid: creditInitials.generatedfromid
    };

    this.ngxLoaderService.start();
    try {
      const res = await lastValueFrom(this.creditControlService.CheckCreditLimit(creditObj));
      if (res?.success && res.data) {
        // console.log('credit-control', res);
        if (res?.data?.err_msg) {
          this.openWarningDialog(res.data.err_msg);
          this.ngxLoaderService.stop();
          return false;
        }
        return true;
      } else if (!res?.success) {
        this.ngxLoaderService.stop();
        return false;
      }
    } catch (error) {
      // console.error('Error checking credit limit:', error);
      this.ngxLoaderService.stop();
      return false;
    }
  }

  onCsbChange() {
    const csbType = this.proformaForm.get('ddlCSBType')?.value;
    if (csbType && csbType !== 'csb4') {
      this.isCsbType = true;
    } else {
      this.isCsbType = false
      this.proformaForm.get('csbDetails').reset();
    };

    this.onPerformaChange();
  }

  onPerformaChange() {
    const csbType = this.proformaForm.get('ddlCSBType')?.value;
    const invoiceDate = this.datePipe.transform(this.proformaForm.get('ddlInvoiceDate')?.value, 'ddMMyy');
    if (csbType == 'csb4' && invoiceDate) {
      this.setDepartmentNo(`CSB4/ASP/NGST/${invoiceDate}`);
    }
    else {
      this.handelNonCsb4(invoiceDate, csbType)
    }
  }

  setDepartmentNo(value: string) {
    this.proformaForm.get('txtDepartmentNo').setValue(value);
  }

  handelNonCsb4(invoiceDate: string, csbType: string) {
    csbType = csbType?.toUpperCase();
    let invoiceterm = this.invoiceTermOptions.filter((item) => item.id == this.proformaForm.get('ddlInvoiceTerm')?.value)[0]?.name?.split(/\(([^)]+)\)/)[1];
    invoiceterm = invoiceterm ? invoiceterm : '-';
    const gstinvoivce = this.proformaForm.get('ddlGSTInvoice')?.value == 'Yes' ? 'G' : 'N';
    const totaligst = this.proformaForm.get('csbDetails.txtTotalIgst')?.value ? this.proformaForm.get('csbDetails.txtTotalIgst').value : 0;
    const ecommerce = this.proformaForm.get('csbDetails.eCommerceCheck')?.value == true ? 'E' : '-';
    const meis = this.proformaForm.get('csbDetails.meisSchemaCheck')?.value == true ? 'M' : '-';
    const lut = this.lutIgstOptions.filter((item) => item.name == this.proformaForm.get('csbDetails.ddlLutIgst')?.value);
    const lutigst = lut[0]?.id == 'N' || lut[0]?.id == undefined ? '-' : lut[0]?.id;
    const str = `${csbType}/${gstinvoivce}/${invoiceterm}/${lutigst}/${ecommerce}/${meis}/${totaligst}/${invoiceDate}`
    this.setDepartmentNo(str);
  }

  resetForm(): void {
    this.awbForm.reset();
    this.piecesDetailsList = [];
    this.isFormSubmitted = false;
    this.totalShipment = null;
    this.performaList = [];
    this.chargeList = [];
    this.customerRowData = [];
    this.vendorRowData = [];
    this.consigneeKycFile = [];
    this.shipperKycFile = [];
    this.isFormSubmitted = false;
    this.activeTabId = 1;
    this.kycUploadedFileURL = '';
    this.kycUploadedFileName = '';
    this.awbForm.controls.shipmentinfo.reset();
    this.awbForm.controls.forwardinginfo.reset();
    this.loadDefaultsChargesForm();
    // Setting default values
    this.awbForm.patchValue({
      txtDateTime: this.currentDateTime,
      ddlMeasurementUnit: this.unitList[0],
      ddlPaymentType: 'Cash',
      txtDivision: '5000'
    });
    this.bindBookingDate();
    this.totalForwardingCharges = 0;
    this.totalCustomerCharges = 0;
    this.resetKycDocumentform();
    this.resetReceiptForm();
    this.addNewContainerCustom(undefined, false);
    this.proformaForm.reset();
    this.proformaForm.patchValue({
      ddlCSBType: 'csb4',
      ddlGSTInvoice: 'Yes',
    });
    this.piecesForm.reset();
    this.chargeForm.reset();
    this.chargeForm.patchValue({
      ddlChargeType: 'Vendor',
      txtContractCharges: '0',
      txtOtherCharges: '0',
      txtIGST: '0.000',
      txtCGST: '0.000',
      txtSGST: '0.000',
    });

    // Patch nested form group separately
    this.chargeForm.get('chargesdetails')?.patchValue({
      chkItemFuel: 'No',
      chkFuelTax: 'No',
      chkTax: 'No',
    });

    // Patch disabled control using setValue
    this.chargeForm.get('chargesdetails.txtFuelAmt')?.setValue(null);
    this.chargeForm.get('chargesdetails.txtFuelTaxAmount')?.setValue(null);
    this.chargeForm.get('chargesdetails.txtTaxAmount')?.setValue(null);

    this.specialServicesForm.reset();
    this.specialServicesForm.patchValue({
      dangerousGoodsCheck: 'No',
      dryIceCheck: 'No',
      insuranceCoverCheck: 'No',
      txtBookingConfirmationNo: null,
      ddlbillShipmentTo: null,
      txtBillShipmentToAccNo: null,
      ddlTaxAndDutiesPaidBy: null,
      txtTaxAndDutiesAccNo: null,
      ddlOutputFormat: null,
      bsoBrokerCheck: false
    });
    this.piecesForm.patchValue({
      actualweightunit: 'KGS',
      measurementunit: ''
    });

    // For disabled controls, use `setValue`
    this.piecesForm.get('totalpieces')?.setValue(0);
    this.piecesForm.get('totalactualweight')?.setValue('0.000');
    this.piecesForm.get('totalvolumetricweight')?.setValue('0.000');
    this.piecesForm.get('totalchargeableweight')?.setValue('0.000');

    // If you want to reset the array too
    this.containers.clear();
    this.bindDefaultPiecesContainer();
    this.utilities.focusFirstElement(this.awbForm);
    this.shipperLocationInfo = null;
    this.consigneeLocationInfo = null;
    this.shipperLocationInfo = {
      ...this.shipperLocationInfo,
      location: {
        country: this.scLocationByIdObj.country,
        state: this.scLocationByIdObj.state,
        city: this.scLocationByIdObj.city
      }
    };
    this.onPerformaChange();
    let defaultCompanyId = this.companyList.find(x => x.isdefault)?.id;
    this.awbForm.get('ddlCompanies').setValue(defaultCompanyId);
    const currencyCode = this.currencyList.find(x => x.isocode === this.userData?.metaInfo?.defaultcountry)?.currencycode;
    currencyCode && this.awbForm.get('ddlCurrency').setValue(currencyCode);

    this.checkAndBindAvailableCredit();
  }

  async checkAndBindAvailableCredit(): Promise<boolean> {
    try {
      const userdata: UserData = this.appCoreService.GetUserData();
      const reqObj = {
        servicecenterid: userdata.accessType === 'Customer' ? null : userdata.selectedServiceCenter,
        customerid: userdata.accessType === 'Customer' ? userdata.metaInfo?.customerid : null
      };

      const res = await lastValueFrom(this.creditControlService.GetByTypeCustomerOrSCId(reqObj));
      if (res.data.err_msg) {
        this.openWarningDialog(res.data.err_msg);
        return false;
      }
      if (res?.success && res.data?.creditdetails?.balance) {
        this.creditDetails = res.data.creditdetails;
        this.appCoreService.setCreditDetails(this.creditDetails);
        return true;
      }
    } catch (error) {
      console.error(error);
    }

    return false;
  }

  addData(data?: any[]) {
    if (this.chargeForm.dirty) this.isChargeDetailsUpdated = true;

    if (this.forwardingInfoTab) {
      this.vendorRowData = data;
    }
    else {
      this.customerRowData = data;
    }
  }

  addChargeData(data?: any[], category: string = '') {
    if (category === 'Vendor') {
      this.vendorData = data;
      this.totalForwardingCharges = parseFloat((Number(this.vendorData?.totalamount) || 0).toFixed(3));
    }
    else {
      this.customerData = data;
      const totalAmount = Number(this.customerData?.totalamount) || 0;
      this.totalCustomerCharges = parseFloat(totalAmount.toFixed(3)) || 0;

      let totalamountreceived = Number(this.receiptList.reduce((sum, receipt) => sum + receipt.amountreceived, 0) ?? 0);

      let balanceamount = Number(this.totalCustomerCharges) - totalamountreceived;
      this.receiptForm.get('txtBalanceAmount').setValue(balanceamount);

    }
  }

  getAllPaymntModes() {
    this.miscService.GetAllPaymentModes().subscribe(res => {
      res && res.success ? this.paymentOptions = res.data : null;
    })
  }

  formatter = (x: { name: string }) => x.name;

  formateDate(date?: any) {
    const inputDate = date != null || undefined ? new Date(date) : new Date();
    const year = inputDate.getFullYear();
    const month = (inputDate.getMonth() + 1).toString().padStart(2, '0');
    const day = inputDate.getDate().toString().padStart(2, '0');
    const hh = inputDate.getHours() < 10 ? ('0' + inputDate.getHours()) : inputDate.getHours();
    const mm = inputDate.getMinutes() < 10 ? ('0' + inputDate.getMinutes()) : inputDate.getMinutes();
    const dateTimeString = `${year}-${month}-${day}T${hh}:${mm}`;
    const dateString = `${year}-${month}-${day}`;
    return { dateString, dateTimeString };
  }

  async openSuccessConfirmationDialog(msg: any, awbNumber: string) {
    const result = await Swal.fire({
      input: 'select',
      inputOptions: {
        AWB: 'AWB',
        BoxLabel: 'Box Label',
        VendorLabel: 'Vendor Label',
        Label: 'Label',
        CommercialInvoice: 'Commercial Invoice',
        AuthorityLetter: 'Authority Letter',
        PrintAll: 'Print All'
      },
      inputPlaceholder: 'Select to Print Label.',
      allowEscapeKey: false,
      allowOutsideClick: false,
      allowEnterKey: true,
      html: msg,
      icon: 'success',
      confirmButtonText: 'OK',
      // showDenyButton: true,
      // denyButtonText: 'Inscan this shipment',
      customClass: {
        denyButton: 'swal2-deny-button'
      }
    }).then(async (result) => {
      if (result.isConfirmed) {
        const selectElement = document.getElementById('pickedByWhom') as HTMLSelectElement;
        const selectedInscan = document.getElementById('inscanCheckbox') as HTMLInputElement;
        const selectedFeildExec = selectElement?.value;
        const inscanChecked = selectedInscan?.checked;
        // console.log('selectedFeildExec && selectedInscan', selectedFeildExec && selectedInscan);

        if (selectedFeildExec && inscanChecked) {
          await this.proceedWithAwbInscan();
          this.updatePickedByWhome(selectedFeildExec, awbNumber);
        };

        if (selectedFeildExec && !inscanChecked) {
          this.updatePickedByWhome(selectedFeildExec, awbNumber);
        }

        if (!selectedFeildExec && inscanChecked) {
          await this.proceedWithAwbInscan();
        }

        // this.router.navigate(['/operation/awb']);

        // reset form
        this.resetForm();
        // print selected label
        // console.log('selected print Label', result.value);
        result?.value && this.lablePrintOptionChange(result.value, awbNumber);
      };
    });
  }

  async openWarningDialog(msg: any) {
    await Swal.fire({
      // title: 'Oops!',add
      text: msg,
      icon: 'warning',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false,
      allowEnterKey: true
    })
  }

  async openErrorDialog(msg: any) {
    const isHtml = msg.includes('<') && msg.includes('>');
    Swal.fire({
      // title: 'Error',
      [isHtml ? 'html' : 'text']: msg,
      icon: 'error',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false,
    })
  }

  async openConfirmationDialog(msg: any) {
    const result = await Swal.fire({
      title: 'Warning!',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      showCancelButton: true,
      allowEscapeKey: false,
      allowOutsideClick: false,
      allowEnterKey: true
    })
    if (result.isConfirmed) {
      return true;
    } else return false;
  }

  printDocument(doctype: string) {
    var byteCharacters = atob(
      'JVBERi0xLjcKCjEgMCBvYmogICUgZW50cnkgcG9pbnQKPDwKICAvVHlwZSAvQ2F0YWxvZwog' +
      'IC9QYWdlcyAyIDAgUgo+PgplbmRvYmoKCjIgMCBvYmoKPDwKICAvVHlwZSAvUGFnZXMKICAv' +
      'TWVkaWFCb3ggWyAwIDAgMjAwIDIwMCBdCiAgL0NvdW50IDEKICAvS2lkcyBbIDMgMCBSIF0K' +
      'Pj4KZW5kb2JqCgozIDAgb2JqCjw8CiAgL1R5cGUgL1BhZ2UKICAvUGFyZW50IDIgMCBSCiAg' +
      'L1Jlc291cmNlcyA8PAogICAgL0ZvbnQgPDwKICAgICAgL0YxIDQgMCBSIAogICAgPj4KICA+' +
      'PgogIC9Db250ZW50cyA1IDAgUgo+PgplbmRvYmoKCjQgMCBvYmoKPDwKICAvVHlwZSAvRm9u' +
      'dAogIC9TdWJ0eXBlIC9UeXBlMQogIC9CYXNlRm9udCAvVGltZXMtUm9tYW4KPj4KZW5kb2Jq' +
      'Cgo1IDAgb2JqICAlIHBhZ2UgY29udGVudAo8PAogIC9MZW5ndGggNDQKPj4Kc3RyZWFtCkJU' +
      'CjcwIDUwIFRECi9GMSAxMiBUZgooSGVsbG8sIHdvcmxkISkgVGoKRVQKZW5kc3RyZWFtCmVu' +
      'ZG9iagoKeHJlZgowIDYKMDAwMDAwMDAwMCA2NTUzNSBmIAowMDAwMDAwMDEwIDAwMDAwIG4g' +
      'CjAwMDAwMDAwNzkgMDAwMDAgbiAKMDAwMDAwMDE3MyAwMDAwMCBuIAowMDAwMDAwMzAxIDAw' +
      'MDAwIG4gCjAwMDAwMDAzODAgMDAwMDAgbiAKdHJhaWxlcgo8PAogIC9TaXplIDYKICAvUm9v' +
      'dCAxIDAgUgo+PgpzdGFydHhyZWYKNDkyCiUlRU9G');
    var byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    var file = new Blob([byteArray], { type: 'application/pdf;base64' });
    var fileURL = URL.createObjectURL(file);
    window.open(fileURL);
  }

  getAWBCharges(category: RateCategory) {
    try {
      let searchtype = "Tariff";
      //let searchtype = "";

      const shipperlocationdetails = this.awbForm.get('shipperlocationdetails');
      // console.log('shipperlocationdetails', shipperlocationdetails);
      const consigneelocationdetails = this.awbForm.get('consigneelocationdetails');
      const forwardinginfo = this.awbForm.get('forwardinginfo');

      let selectedDestinationCountry = this.destinationCountryList.filter(x => x.isocode === consigneelocationdetails.get('ddlCountry').value);
      let selectedDestinationState = this.destinationStateList.filter(x => x.isocode === consigneelocationdetails.get('ddlState').value);
      let selectedDestinationCity = this.destinationCityList.filter(x => x.isocode === consigneelocationdetails.get('ddlCity').value);

      let selectedOriginCountry = this.originCountryList.filter(x => x.isocode === shipperlocationdetails.get('ddlCountry').value);
      let selectedOriginState = this.originStateList.filter(x => x.isocode === shipperlocationdetails.get('ddlState').value);
      let selectedOriginCity = this.originCityList.filter(x => x.isocode === shipperlocationdetails.get('ddlCity').value);

      let selectedVendor = null, selectedProduct = null, selectedService = null, applicable_weight = 0;
      let chargetype = this.awbForm.get('ddlChargeType').value;
      let selectedCustomer = this.awbForm.controls.ddlCustomer?.value || null;

      switch (category) {
        case RateCategory.CUSTOMER:
          selectedVendor = this.awbForm.get('ddlVendor').value ? this.vendorOptions.filter(x => x.id === this.awbForm.get('ddlVendor').value) : null;
          selectedProduct = this.productOptions.filter(x => x.id === this.awbForm.controls.ddlProduct?.value)[0]?.code;
          selectedService = this.serviceOptions.filter(x => x.id === this.awbForm.controls.ddlService?.value)[0]?.servicename;

          let actual_weight = this.piecesForm.get("totalactualweight").value || 0;
          let volumetric_weight = this.piecesForm.get("totalvolumetricweight").value || 0;
          applicable_weight = actual_weight >= volumetric_weight ? actual_weight : volumetric_weight;
          searchtype = !selectedCustomer ? "Tariff" : RateCategory.CUSTOMER;
          break;
        case RateCategory.VENDOR:
          selectedVendor = forwardinginfo.get('ddlDeliveryVendor').value ? this.deliveryVendorList.filter(x => x.id === forwardinginfo.get('ddlDeliveryVendor').value) : null;
          selectedProduct = this.deliveryProductList.filter(x => x.id === forwardinginfo.get('ddlDeliveryProduct').value)[0]?.code;
          selectedService = this.deliveryServiceList.filter(x => x.id === forwardinginfo.get('ddlDeliveryService').value)[0]?.servicename;
          applicable_weight = forwardinginfo.get('txtVendorWeight').value || 0;
          searchtype = RateCategory.VENDOR;
          break;
      }

      if (selectedVendor?.length && selectedProduct != null && selectedService != null && selectedDestinationCountry?.length && applicable_weight > 0) {
        const reqObj = {
          searchtype: searchtype,
          customer: this.awbForm.controls.ddlCustomer?.value || null,
          company: this.awbForm.controls.ddlCompanies?.value || null,
          vendor: selectedVendor,
          service: selectedService,
          product: selectedProduct,
          origincountry: selectedOriginCountry,
          originstate: selectedOriginState,
          origincity: selectedOriginCity,
          destinationcountry: selectedDestinationCountry,
          destinationstate: selectedDestinationState,
          destinationcity: selectedDestinationCity,
          weight: applicable_weight,
          bookingdate: this.awbForm.get('txtDateTime').value,
          is_oda: chargetype?.includes("ODA") || false,
          is_commercial: chargetype?.includes("Commercial") || false,
          is_medical: chargetype?.includes("Medical") || false,
          is_insurance: chargetype?.includes("Insurance") || false
          //actual_weight: this.rateCompareForm.controls.txtActualWeight.value,
          //volumetric_weight: this.rateCompareForm.controls.txtVolumetricWeight.value,
        }
        //this.chargesService.GetAWBCharges(reqObj).subscribe((res) => {
        this.chargesService.GetApplicableCharges(reqObj).subscribe((res) => {
          if (res && res.success) {
            let awbCharges = res.data?.availableCharges || [];
            // console.log('category', category);
            //this.setCharges(awbCharges, category);
            this.addCharges(awbCharges, category);
            this.customerConfig.fuel = res.data?.fuel;
            this.customerConfig.tax = res.data?.tax;
            //console.log(res);
            // console.log('customerConfig', this.customerConfig);

          }
        });
      }
    } catch (error) {
      console.error(error);
    }
    // this.volumetricDetails();
  }

  addCharges(charges: any[], category: RateCategory) {
    // let othercharges = charges["othercharges"] || [];
    // let freightcharges = charges["freight"] || null;
    let customerCharges: any[] = [];
    // console.log('this.customerRowData', this.customerRowData);

    if (category == RateCategory.CUSTOMER)
      this.customerRowData = this.customerRowData.filter(x => !x.system);

    if (category === RateCategory.VENDOR)
      this.vendorRowData = this.vendorRowData.filter(x => !x.system);
    let otherChargesMatch: any[] = [];
    if (charges?.length) {
      otherChargesMatch = charges?.filter(x => {
        if (category == RateCategory.CUSTOMER)
          return this.customerRowData?.length && this.customerRowData.filter(y => y.chargesdescription?.toLowerCase() === x.chargename?.toLowerCase())?.length ? false : true;
        else
          return this.vendorRowData?.length && this.vendorRowData.filter(y => y.chargesdescription?.toLowerCase() === x.chargename?.toLowerCase())?.length ? false : true;
      });
    }

    let idx = 0;
    if (otherChargesMatch?.length) {
      for (const c of otherChargesMatch) {
        let igst = c.tax?.filter(x => x.type === 'IGST')[0].value;
        let sgst = c.tax?.filter(x => x.type === 'SGST')[0].value;
        let cgst = c.tax?.filter(x => x.type === 'CGST')[0].value;
        let fuel_igst = c.fueltax?.filter(x => x.type === 'IGST')?.[0]?.value;
        let fuel_sgst = c.fueltax?.filter(x => x.type === 'SGST')?.[0]?.value;
        let fuel_cgst = c.fueltax?.filter(x => x.type === 'CGST')?.[0]?.value;

        if (c.chargename?.toLowerCase() === 'freight') {
          let item_total = (parseFloat(c.rate || 0) + parseFloat(c.fuelamount || 0) + (parseFloat(igst || 0) + Number(sgst || 0) + parseFloat(cgst || 0)) + parseFloat(c.taxonfuelamount || 0)) || 0;
          this.piecesForm.get('totalchargeableweight').setValue(Number(c.weight));

          let _obj = {
            id: 0,
            chargesid: this.chargeList?.filter(_x => _x.name?.toLowerCase() === c.chargename.toLowerCase())[0]?.id,
            chargesdescription: c.chargename,
            itemamount: c.rate || 0,
            isitemfuel: c.fuelapplicable || false,
            fuelamount: c.fuelamount || 0,
            fueltax: c.taxonfuelapplicable || false,
            fueltaxamount: c.taxonfuelamount || 0,
            igst: Number(igst) + Number(fuel_igst),
            sgst: sgst + fuel_sgst,
            cgst: cgst + fuel_cgst,
            tax: c.taxapplicable || false,
            taxamount: (igst + sgst + cgst),
            itemtotal: Number(item_total.toFixed(3)),
            system: true
          };

          let chargeType: any[] = c.chargetype || [];

          if (chargeType?.includes(ChargeType.AWB) && category === RateCategory.CUSTOMER) {
            this.customerRowData.push({ ..._obj, chargetype: "Customer" });
          }
          else if (chargeType?.includes(ChargeType.PURCHASE) && category === RateCategory.VENDOR) {
            this.vendorRowData.push({ ..._obj, chargetype: "Vendor" });
          }

        } else {

          let total_igst = (Number(igst) + Number(fuel_igst)) || 0;
          let obj = {
            id: (idx + 1),
            chargesid: this.chargeList?.filter(_x => _x.name === c.chargename)[0]?.id,
            chargesdescription: c.chargename,
            itemamount: c.otherchargeamount || 0,
            isitemfuel: c.fuelapplicable || false,
            fuelamount: c.fuelamount || 0,
            fueltax: c.taxonfuelapplicable || false,
            fueltaxamount: c.taxonfuelamount || 0,
            igst: Number(total_igst.toFixed(3)),
            sgst: sgst,
            cgst: cgst,
            tax: c.taxapplicable || false,
            taxamount: (igst + sgst + cgst),
            itemtotal: c.otherchargeamount + (igst + sgst + cgst) + c.fuelamount + c.taxonfuelamount,
            system: true
          };

          let chargeType: any[] = c.chargetype || [];

          if (chargeType?.includes(ChargeType.AWB) && category === RateCategory.CUSTOMER) {
            this.customerRowData.push({ ...obj, chargetype: "Customer" });
          }
          else if (chargeType?.includes(ChargeType.PURCHASE) && category === RateCategory.VENDOR) {
            this.vendorRowData.push({ ...obj, chargetype: "Vendor" });
          }
        }
      }
    }

    let chargesData = category === RateCategory.CUSTOMER ? this.customerRowData : this.vendorRowData;

    // console.log('chargesData 6 ', chargesData);

    this.getChargesSummary(chargesData, (data) => {
      this.addChargeData(data, category);
      // if (category == RateCategory.CUSTOMER)
      //   this.customerData = data;
      // else
      //   this.vendorData = data;
    });
  }

  setCharges(awbCharges: [], category: RateCategory) {
    // console.log('setCharges 1', awbCharges);
    // console.log('this.customerRowData 2', this.customerRowData);

    let othercharges = awbCharges["othercharges"] || [];
    let freightcharges = awbCharges["freight"] || null;

    // console.log('this.customerRowData', this.customerRowData);

    if (category == RateCategory.CUSTOMER)
      this.customerRowData = this.customerRowData.filter(x => !x.system);

    if (category == RateCategory.VENDOR)
      this.vendorRowData = this.vendorRowData.filter(x => !x.system);

    const otherChargesMatch = othercharges.filter(x => {
      if (category == RateCategory.CUSTOMER)
        return this.customerRowData?.length && this.customerRowData.filter(y => y.chargesdescription.toLowerCase() === x.charge.toLowerCase())?.length ? false : true;
      else
        return this.vendorRowData?.length && this.vendorRowData.filter(y => y.chargesdescription.toLowerCase() === x.charge.toLowerCase())?.length ? false : true;
    });

    let FreightMatch = false;
    if (category == RateCategory.CUSTOMER)
      FreightMatch = this.customerRowData.filter(y => y.chargesdescription.toLowerCase() === "freight")?.length ? true : false;
    else
      FreightMatch = this.vendorRowData.filter(y => y.chargesdescription.toLowerCase() === "freight")?.length ? true : false;

    // console.log('otherChargesMatch 3', otherChargesMatch);

    if (otherChargesMatch?.length) {
      // console.log('OTHER CHARGES >>>');
      // console.log('this.chargeList ', this.chargeList);

      otherChargesMatch.map((item, index) => {
        let total_igst = (Number(item["igst"]) + Number(item["fuel_igst"])) || 0;
        let obj = {
          "id": (index + 1),
          //"chargetype": item?["chargetype"],
          "chargesid": this.chargeList.filter(_x => _x.name === item["chargename"])[0]?.id,
          "chargesdescription": item["chargename"],
          "itemamount": item["otherchargeamount"] || 0,
          "isitemfuel": item["fuelApplicable"] || false,
          "fuelamount": item["fuelamount"] || 0,
          "fueltax": item["taxOnFuelApplicable"] || false,
          "fueltaxamount": item["taxonfuelamount"] || 0,
          "igst": Number(total_igst.toFixed(3)),
          "sgst": item["sgst"],
          "cgst": item["cgst"],
          "tax": item["taxapplicable"] || false,
          "taxamount": (item["igst"] + item["sgst"] + item["cgst"]),
          //"totaltaxamount": (item["igst"] + item["sgst"] + item["cgst"]) +  item["taxonfuelamount"],
          "itemtotal": item["otherchargeamount"] + (item["igst"] + item["sgst"] + item["cgst"]) + item["fuelamount"] + + item["taxonfuelamount"],
          "system": true
        };

        let chargeType: any[] = item["targettypes"] || [];

        // console.log('chargeType : ', chargeType);

        if (chargeType.includes(ChargeType.AWB) && category == RateCategory.CUSTOMER)
          this.customerRowData.push({ ...obj, chargetype: "Customer" });
        else if (chargeType.includes(ChargeType.PURCHASE) && category == RateCategory.VENDOR)
          this.vendorRowData.push({ ...obj, chargetype: "Vendor" });
      });
      // console.log('<<< OTHER CHARGES ');
    }

    // console.log('this.customerRowData 333 ', this.customerRowData);
    // console.log('freightcharges 4 ', freightcharges);
    // console.log('FreightMatch 5 ', FreightMatch);

    if (freightcharges != null && !FreightMatch) {
      let item_total = (parseFloat(freightcharges["rate"] || 0) + parseFloat(freightcharges["fuelamount"] || 0) + (parseFloat(freightcharges["igst"] || 0) + Number(freightcharges["sgst"] || 0) + parseFloat(freightcharges["cgst"] || 0)) + parseFloat(freightcharges["taxonfuelamount"] || 0)) || 0;
      let _obj = {
        "id": 0,
        //"chargetype": item?["chargetype"],
        "chargesid": this.chargeList.filter(_x => _x.name?.toLowerCase() === "freight")[0]?.id,
        "chargesdescription": "FREIGHT",
        "itemamount": freightcharges["rate"] || 0,
        "isitemfuel": freightcharges["fuelApplicable"] || false,
        "fuelamount": freightcharges["fuelamount"] || 0,
        "fueltax": freightcharges["taxOnFuelApplicable"] || false,
        "fueltaxamount": freightcharges["taxonfuelamount"] || 0,
        "igst": Number(freightcharges["igst"]) + Number(freightcharges["fuel_igst"]),
        "sgst": freightcharges["sgst"] + freightcharges["fuel_sgst"],
        "cgst": freightcharges["cgst"] + freightcharges["fuel_cgst"],
        "tax": freightcharges["taxapplicable"] || false,
        //"taxamount": (freightcharges["igst"] + freightcharges["sgst"] + freightcharges["cgst"]) + freightcharges["taxonfuelamount"],
        "taxamount": (freightcharges["igst"] + freightcharges["sgst"] + freightcharges["cgst"]),
        "itemtotal": Number(item_total.toFixed(3)),
        "system": true
      };

      //this.customerRowData.push({ ..._obj, chargetype: "Customer" });

      if (category == RateCategory.CUSTOMER)
        this.customerRowData.push({ ..._obj, chargetype: "Customer" });
      else if (category == RateCategory.VENDOR)
        this.vendorRowData.push({ ..._obj, chargetype: "Vendor" });
    }

    let chargesData = category == RateCategory.CUSTOMER ? this.customerRowData : this.vendorRowData;

    // console.log('chargesData 6 ', chargesData);

    this.getChargesSummary(chargesData, (data) => {
      if (category == RateCategory.CUSTOMER)
        this.customerData = data;
      else
        this.vendorData = data;
    });
    // console.log('customerRowData 7', this.customerRowData);
  }

  getOriginLocation(location: any) {
    this.originCountryList = location?.[0]?.country || [];
    this.originStateList = location?.[0]?.state || [];
    this.originCityList = location?.[0]?.city || [];
    this.documentTypeValidation('shipperdoc');
    this.getAWBCharges(RateCategory.CUSTOMER);
  }

  getDestinationLocation(location: any) {
    this.destinationCountryList = location?.[0]?.country || [];
    this.destinationStateList = location?.[0]?.state || [];
    this.destinationCityList = location?.[0]?.city || [];
    this.documentTypeValidation('consigneedoc');
    this.getAWBCharges(RateCategory.CUSTOMER);
  }

  getAddressbookList(event: any) {
    event.listType === 'origin' ? this.shipperAddressBookList = event.addressbook : this.consigneeAddressBookList = event.addressbook;
  }

  bindAddressKycInfo(event: any, type: string) {
    this.awbForm.get(`ddl${type}DocumentType`).reset();
    this.awbForm.get(`txt${type}DocumentNo`).reset();
    if (event?.no && event?.type) {
      this.awbForm.get(`ddl${type}DocumentType`).setValue(this.documentOptions.find(x => x.name === event?.type)?.name);
      this.awbForm.get(`txt${type}DocumentNo`).setValue(event?.no);
    }
  }

  getBrokerLocation(location: any) {
    this.destinationCountryList = location[0]?.country || [];
    this.destinationStateList = location[0]?.state || [];
    this.destinationCityList = location[0]?.city || [];
  }

  getchargesList(chargeList: any[]) {
    this.chargeList = chargeList || [];
  }

  onChangeFileSelect(evt, selectedType: string) {
    try {
      if (evt) {
        if (selectedType === 'AWBKyc') {
          this.selectedKycFile = evt.target.files[0];
          this.kycUploadedFileURL = '';
          this.kycUploadedFileName = '';
        } else if (selectedType === 'AWBPieces') {
          this.selectedPiecesFile = evt.target.files[0];
        }

      }
    } catch (e) {
      console.error(e);
    }
  }

  resetKycDocumentform() {
    this.kycForm.get('txtDocument').reset();
    this.iskycFormSubmitted = false;
    this.kycInfo = {
      type: null,
      no: null,
      filepath: null,
      fileid: null,
      entitytype: null
    };
    this.kycUploadedFileURL = '';
    this.kycUploadedFileName = '';
    this.selectedKycFile = null;
  };

  uploadKycInfo(entityType: string) {
    try {
      let interval: any;
      let timeout: any;
      clearInterval(interval);
      clearTimeout(timeout);
      if (entityType) {
        if (entityType === 'AWB') {
          let selectedDocumentType = this.kycForm.get('ddlDocumentType').value;

          if (!selectedDocumentType) return this.appCoreService.showMessage('Please select Document type', '', 'error');
          if (selectedDocumentType && this.selectedKycFile) {
            let currentfiletype = this.selectedKycFile.name.split('.').pop();
            let filetype = ['png', 'jpeg', 'jpg', 'svg', 'pdf']
            if (!filetype.includes(currentfiletype)) {
              this.appCoreService.showMessage('Allowed file formats: PNG, JPEG, JPG, SVG, and PDF.', 'Info', 'info');
              return;
            }
            if (this.selectedKycFile?.size > FileSize) {
              this.appCoreService.showMessage('File size exceeded.', 'Info', 'info');
              return;
            }
            let requestObj = {
              name: this.selectedKycFile.name,
              fileType: this.selectedKycFile.type,
              category: 'kyc'
            };
            this.showProgressBar = true;
            this.progress = 0;
            interval = setInterval(() => {
              if (this.progress < 99) {
                this.progress += 1;
              }
            }, 100);

            timeout = setTimeout(() => {
              if (this.progress >= 99 && this.progress < 100) {
                this.showProgressBar = false;
                this.appCoreService.showMessage('Error in upload. Please try again later.', 'Error', 'error');
                clearInterval(interval);
              }
            }, 5000);

            this.fileHandlerService.GetSignedURLForUpload(requestObj).subscribe(res => {
              try {
                if (res && res.success) {
                  const signedUrl = res.data.uploadURL;
                  const fileId = res.data.fileId;
                  if (signedUrl) {
                    let headers: HttpHeaders = new HttpHeaders({
                      "Content-Type": requestObj.fileType
                    });

                    this.fileHandlerService.UploadFile(signedUrl, this.selectedKycFile, headers).subscribe((f) => {
                      if (f === null) {
                        this.fileHandlerService.UploadComplete({ id: fileId }).subscribe((res) => {
                          if (res && res.success) {
                            this.progress = 100;
                            clearInterval(interval);
                            clearTimeout(timeout);

                            this.kycInfo.type = selectedDocumentType;
                            this.kycInfo.filepath = res.data.url;
                            this.kycInfo.fileid = fileId;
                            this.kycInfo.entitytype = 'AWB';

                            this.kycUploadedFileURL = res.data.url;
                            this.kycUploadedFileName = res.data.name;

                            setTimeout(() => {
                              this.showProgressBar = false;
                            }, 1000);

                            this.appCoreService.showMessage('Record uploaded successfully', 'Success', 'success');
                            this.selectedKycFile = null;
                            this.kycSaveBtn.nativeElement.focus();
                          }
                        });
                      }
                    });
                  }
                }
              } catch (error) {
                console.error(error);
              }
            });
          } else {
            this.appCoreService.showMessage('For adding a KYC, you must provide document type and a supporting file', '', 'error');
          }
        }
      }
    } catch (e) {
      console.error(e);
    }
  }

  addKYC() {
    try {
      this.iskycFormSubmitted = true;
      let selectedDocumentType = this.kycForm.get('ddlDocumentType').value;
      let selectedDocumentNo = this.kycForm.get('txtDocumentNo')?.value;
      this.kycInfo.no = selectedDocumentNo;
      // if (selectedDocumentType && !selectedDocumentNo) return this.appCoreService.showMessage('Please enter Document no', '', 'error');

      if (this.kycForm.invalid) return;

      if (!this.kycInfo.fileid) return this.appCoreService.showMessage('Please attach file and upload.', '', 'error');

      // Check if docType already exists in the kycList
      if (this.kycList.some(item => item.type === selectedDocumentType)) return this.appCoreService.showMessage('Document type already exists.', 'Error', 'error');

      const existingDocType = this.kycList.some(item => item.type === this.kycInfo?.type);
      if (existingDocType && this.kycInfo?.type) {
        this.appCoreService.showMessage(`File already attached to ${this.kycInfo?.type}`, 'Error', 'error');
        return;
      }

      // this.kycForm.get('documentFileControl').setValue(this.kycInfo?.fileId);
      // this.kycForm.get('documentFileUrl').setValue(this.kycInfo?.url);

      // Add new KYC info to the list
      this.kycList = [{ ...this.kycInfo, isFromCustomer: false }, ...this.kycList];

      this.appCoreService.showMessage('Record saved successfully.', 'Success', 'success');

      // Reset form and KYC info object
      this.kycInfo = {
        type: null,
        no: null,
        filepath: null,
        fileid: null,
        entitytype: null
      };
      this.kycForm.reset();
      if (this.kycDocumentType instanceof NgSelectComponent) this.kycDocumentType.focus();
      Object.keys(this.kycForm.controls).forEach(key => {
        this.kycForm.get(key)?.clearValidators();
        this.kycForm.get(key)?.updateValueAndValidity();
      });
      this.iskycFormSubmitted = false;
      this.kycUploadedFileURL = '';
      this.kycUploadedFileName = '';
    } catch (err) {
      console.log(err);
    }
  }

  deleteKycItem(entityType: string, idx) {
    let message = `This action is irreversible. Are you sure you want to delete?`;
    this.openWarningDialogForKyc(message).then((response) => {
      if (response) {
        if (entityType === 'AWB') {
          this.kycList.splice(idx, 1);
        }
      }
    });
  }

  async bindCustomerKYC() {
    const customerId = this.awbForm.get('ddlCustomer')?.value;
    if (customerId) {
      const customerData: any = this.customerList.find(x => x.id === customerId);
      const customerKYCWithFile = customerData?.kyc?.filter(x => x.fileid);

      if (customerKYCWithFile?.length) {
        const manualKYC = this.kycList.filter(kyc => !kyc.isFromCustomer);

        // Find the first available KYC document based on priority order in documentOptions
        const selectedKYC = this.documentOptions
          .find(option => customerKYCWithFile.some(kyc => kyc.name === option.name));

        if (selectedKYC) {
          const preferredKYC = customerKYCWithFile.find(kyc => kyc.name === selectedKYC.name);

          if (preferredKYC) {
            this.kycList = [
              ...manualKYC,
              { ...preferredKYC, isFromCustomer: true }
            ];
          }
        }
      }

    } else {
      // Remove all customer-based KYC documents
      this.kycList = this.kycList.filter(kyc => !kyc.isFromCustomer);
    }
  }



  uploadPiecesFile() {
    try {
      if (this.selectedPiecesFile) {
        let interval: any;
        let timeout: any;
        clearInterval(interval);
        clearTimeout(timeout);
        let filetype = this.selectedPiecesFile.name.split('.').pop();
        if (filetype !== "xlsx" && filetype !== "xls") {
          this.appCoreService.showMessage('Only allowed Xlsx and Xls file Formate.', 'Info', 'info');
          return;
        }

        if (this.selectedPiecesFile?.size > FileSize) {
          this.appCoreService.showMessage('File size exceed.', 'Info', 'info');
          return;
        }
        this.ngxLoaderService.start();
        let requestObj = {
          name: this.selectedPiecesFile.name,
          fileType: this.selectedPiecesFile.type,
          category: 'pieces'
        };

        this.showProgressBar = true;
        interval = setInterval(() => {
          if (this.progress < 99) {
            this.progress += 1;
          } else {
            clearInterval(interval);
            if (!timeout) {
              timeout = setTimeout(() => {
                this.appCoreService.showMessage('Error in upload. Please try again later.', 'Error', 'error');
                clearTimeout(timeout);
              }, 2000);
            }
          }
        }, 100);

        this.fileHandlerService.GetSignedURLForUpload(requestObj).subscribe(res => {
          try {
            if (res && res.success) {
              const signedUrl = res.data.uploadURL;
              const fileId = res.data.fileId;
              if (signedUrl) {
                let headers: HttpHeaders = new HttpHeaders({
                  "Content-Type": requestObj.fileType
                });

                this.fileHandlerService.UploadFile(signedUrl, this.selectedPiecesFile, headers).subscribe((f) => {
                  if (f === null) {
                    this.fileHandlerService.UploadComplete({ id: fileId }).subscribe((res) => {
                      if (res && res.success) {
                        this.selectedPiecesFile = null;
                        this.progress = 100;
                        clearInterval(interval);
                        clearTimeout(timeout);
                        this.awbForm.get('txtTotalPiecesFileId').setValue(fileId);
                        this.ngxLoaderService.stop();
                        this.appCoreService.showMessage('File uploaded', '', 'success');
                        this.processFile(fileId);
                        // Clear upload input
                        setTimeout(() => {
                          this.awbForm.get('txtFile').setValue(null);
                        }, 100);
                      }
                    });
                  }
                });
              }
            }
          } catch (error) {
            this.ngxLoaderService.stop();
            clearInterval(interval);
            clearTimeout(timeout);
            this.showProgressBar = false;
            console.error(error);
          }
        });
      } else {
        this.ngxLoaderService.stop();
        this.appCoreService.showMessage('Select an excel file to upload', '', 'error');
      }
    } catch (e) {
      this.ngxLoaderService.stop();
      console.error(e);
    }
  }

  processFile(fileid) {
    if (fileid) {
      const requestObj = {
        fileid,
        piecesnumber: this.piecesForm.get('totalpieces')?.value
      }
      this.ngxLoaderService.start();
      this.awbService.UploadPieces(requestObj).subscribe(async (res) => {
        try {
          if (res && res.success) {
            this.ngxLoaderService.stop();
            this.showProgressBar = false;
            // console.log('piecesDetails', res.data);

            let totalactualweight = res.data?.piecesDetails.reduce((acc, curr) => acc + ((curr?.totalpieces * curr?.actualweight) || 0), 0);
            // console.log('totalactualweight', totalactualweight);

            const isNotWeightValid = this.validateActualWeight(totalactualweight)

            if (!isNotWeightValid) {
              const isConfirmedToAdd = await this.openOverrideOrAddDialog('Do you want to Add or Override records?', res.data)

              if (isConfirmedToAdd) {
                await this.processData(res.data, this.containers.controls)
              } else {
                await this.processData(res.data, this.containers.controls, true);
              }
            } else {
              return this.warningDialog(isNotWeightValid);
            }
          }
        } catch (error) {
          this.ngxLoaderService.stop();
          console.error(error);
        } finally {
          this.ngxLoaderService.stop();
          this.focusFirstActualWeight();
        }
      });
    }
  }

  async processData(piecesdata: any, container: any, isOverwrite: boolean = false) {
    if (isOverwrite) {
      for (const pieces of piecesdata?.piecesDetails) {
        let actualweight = pieces?.actualweight;
        if (actualweight) {
          const piecesdata = container.find(item => item.controls.piecescounter.value == pieces.piecesid);
          if (piecesdata) {
            piecesdata?.get('piecescount')?.setValue(pieces?.totalpieces);
            piecesdata?.get('piecesactualweight')?.setValue(actualweight);
            piecesdata?.get('pieceslength')?.setValue(pieces?.piecelength);
            piecesdata?.get('piecesbreadth')?.setValue(pieces?.piecebreadth);
            piecesdata?.get('piecesheight')?.setValue(pieces?.pieceheight);
            this.piecesForm.markAsDirty();
            this.calculateWeightNew();
          }
          else {
            //need to update logic in detail based on piecesid scenario
            this.addNewContainerCustom();
            const newpiecesdata = container.find(item => item.controls.piecescounter.value == pieces.piecesid);
            if (newpiecesdata) {
              newpiecesdata?.get('piecescount')?.setValue(pieces?.totalpieces);
              newpiecesdata?.get('piecesactualweight')?.setValue(actualweight);
              newpiecesdata?.get('pieceslength')?.setValue(pieces?.piecelength);
              newpiecesdata?.get('piecesbreadth')?.setValue(pieces?.piecebreadth);
              newpiecesdata?.get('piecesheight')?.setValue(pieces?.pieceheight);
              this.piecesForm.markAsDirty();
              this.calculateWeightNew();
              this.volumetricDetails('', true)
            }
          }

          this.subItem(pieces?.piecesid - 1)?.clear();
          for (const item of pieces?.proformaDetails) {
            if (item?.description && item?.rate && item?.quantity) {
              const { description, hsncode, weight, unit, quantity, rate, amount } = item;

              const parsedQuantity = parseFloat(quantity) ?? 0;
              const parsedRate = parseFloat(rate) ?? 0;
              const parsedWeight = parseFloat(weight) ?? 0;

              let tempdata = {
                description: { name: description },
                hsncode: hsncode ?? '',
                weight: parsedWeight,
                unit: unit ?? '',
                quantity: parsedQuantity,
                rate: parsedRate,
                amount: parsedQuantity * parsedRate || amount
              };

              // Inserting the new sub-item in the desired position
              this.subItem(pieces?.piecesid - 1)?.insert(0, this.newSubItem(tempdata));
              this.piecesForm.markAsDirty();
            }
            else {
              this.appCoreService.showMessage(`Description, rate, and quantity are required for pieces no ${pieces.piecesid}. Please provide all necessary information.`, 'Warning', 'warning');
            }
          }
        }
        else {
          this.appCoreService.showMessage(`Actual weight  of pieces no ${pieces.piecesid} not provided`, 'Error', 'error');
        }
      }

    } else {
      for (const pieces of piecesdata?.piecesDetails) {
        let actualweight = pieces?.actualweight;
        if (!actualweight) {
          this.appCoreService.showMessage(`Actual weight  of pieces no ${pieces.piecesid} not provided`, 'Error', 'error');
        }
        const piecesdata = container.find(item => item.controls.piecescounter.value == pieces.piecesid);
        if (piecesdata) {
          // const oldpiecescount = piecesdata?.get('piecescount')?.value || 0;
          const oldactualweight = piecesdata?.get('piecesactualweight')?.value || 0;
          const oldpiecelength = piecesdata?.get('pieceslength')?.value || 0;
          const oldpiecebreadth = piecesdata?.get('piecesbreadth')?.value || 0;
          const oldpieceheight = piecesdata?.get('piecesheight')?.value || 0;

          piecesdata?.get('piecescount')?.setValue(parseFloat(pieces?.totalpieces));
          piecesdata?.get('piecesactualweight')?.setValue(parseFloat(actualweight) + parseFloat(oldactualweight));
          piecesdata?.get('pieceslength')?.setValue(parseFloat(pieces?.piecelength) + parseFloat(oldpiecelength));
          piecesdata?.get('piecesbreadth')?.setValue(parseFloat(pieces?.piecebreadth) + parseFloat(oldpiecebreadth));
          piecesdata?.get('piecesheight')?.setValue(parseFloat(pieces?.pieceheight) + parseFloat(oldpieceheight));
          this.piecesForm.markAsDirty();
          this.calculateWeightNew();
        }
        else {
          //need to update logic in detail based on piecesid scenario
          this.addNewContainerCustom();
          const newpiecesdata = container.find(item => item.controls.piecescounter.value == pieces.piecesid);
          if (newpiecesdata) {
            newpiecesdata?.get('piecescount')?.setValue(pieces?.totalpieces);
            newpiecesdata?.get('piecesactualweight')?.setValue(actualweight);
            newpiecesdata?.get('pieceslength')?.setValue(pieces?.piecelength);
            newpiecesdata?.get('piecesbreadth')?.setValue(pieces?.piecebreadth);
            newpiecesdata?.get('piecesheight')?.setValue(pieces?.pieceheight);
            this.piecesForm.markAsDirty();
            this.calculateWeightNew();
            this.volumetricDetails('', true)
          }
        }

        for (const item of pieces?.proformaDetails) {
          if (item?.description && item?.rate && item?.quantity) {
            const { description, hsncode, weight, unit, quantity, rate, amount } = item;

            const parsedQuantity = parseFloat(quantity) ?? 0;
            const parsedRate = parseFloat(rate) ?? 0;
            const parsedWeight = parseFloat(weight) ?? 0;

            let tempdata = {
              description: { name: description },
              hsncode: hsncode ?? '',
              weight: parsedWeight,
              unit: unit ?? '',
              quantity: parsedQuantity,
              rate: parsedRate,
              amount: parsedQuantity * parsedRate || amount
            };
            this.subItem(pieces?.piecesid - 1)?.insert(0, this.newSubItem(tempdata));
            this.piecesForm.markAsDirty();
          }
          else {
            this.appCoreService.showMessage(`Description, rate, and quantity are required for pieces no ${pieces.piecesid}. Please provide all necessary information.`, 'Warning', 'warning');
          }
        }

      }
    }
  }

  //to campare rate
  searchRates() {
    if (!this.piecesForm.get('totalactualweight')?.value || !this.awbForm.get('consigneelocationdetails.ddlCountry').value?.length) {
      this.piecesForm.get('totalactualweight')?.markAsTouched();
      this.awbForm.get('consigneelocationdetails.ddlCountry')?.markAsTouched();
      this.appCoreService.showMessage('Please provide value for total weight and consignee country.', 'Warning', 'warning');
      return;
    }
    else {
      // this.searchtype = 'All';
      let selectedCustomerValue = this.awbForm.get('ddlCustomer')?.value;
      this.getRates(selectedCustomerValue ? 'Customer' : 'Tariff');

      // if (selectedCustomerValue != null) {
      //   this.searchtype = 'Customer';
      //   this.getRates('Customer');
      // }
      // else {
      //   this.searchtype = 'Tariff';
      //   this.getRates('Tariff');
      // }
      // this.getRates('All');
    }
  };

  async openCompareModal(rateList: any[]) {
    try {
      let ngbModalOptions: NgbModalOptions = {
        ariaLabelledBy: 'modal-basic-title',
        size: 'xl',
        backdrop: 'static',
        keyboard: false,
        centered: true,
      };

      const modalRef = this.modalService.open(compareRatesComponent, ngbModalOptions);

      // fill the rate list
      if (!modalRef.componentInstance.cellData) {
        modalRef.componentInstance.cellData = {};
      }
      modalRef.componentInstance.cellData.rates = rateList;
      modalRef.componentInstance.cellData.vendorOptions = this.vendorOptions;
      modalRef.componentInstance.cellData.productOptions = this.productOptions;


      // Listen to the emitted event from the modal
      if (modalRef.componentInstance.awbFormValues) {
        modalRef.componentInstance.awbFormValues.subscribe(async (awbData: any) => {
          try {
            const vend = this.vendorOptions.find((item) => item.code == awbData.vendor);
            const prod = this.productOptions.find((item) => item.code == awbData.product);

            this.awbForm.patchValue({
              ddlProduct: prod?.id || null,
              ddlVendor: vend?.id || null,
            });

            await this.getAllVendorServices();
            if (this.serviceOptions.length) {
              const service = this.serviceOptions.find((item) => item.servicename == awbData.service);
              this.awbForm.get('ddlService')?.setValue(service?.id || null);
              this.getAWBCharges(RateCategory.CUSTOMER);
            }

            /*we did not apply location from rates*/

            // this.shipperLocationInfo = {
            //   ...this.shipperLocationInfo,
            //   location: {
            //     locationapply: {
            //       country: awbData.origincountry,
            //       state: awbData.originstate,
            //       city: awbData.origincity,
            //     },
            //   },
            // };

            // this.consigneeLocationInfo = {
            //   ...this.consigneeLocationInfo,
            //   location: {
            //     locationapply: {
            //       country: awbData.destinationcountry,
            //       state: awbData.destinationstate,
            //       city: awbData.destinationcity,
            //     },
            //   },
            // };

            modalRef.close();
          } catch (error) {
            console.error("Error processing modal data:", error);
          }
        });
      } else {
        console.error("awbFormValues is not defined in compareRatesComponent");
      }
      modalRef.result.then(
        (result) => {
          if (result) {
            // console.log("Modal closed with result:", result);
          }
        },
        (error) => {
          // console.error("Modal dismissed:", error);
        }
      );
    } catch (err) {
      console.log("Error", err);
    }
  };

  getRates(paramSearchType: 'Tariff' | 'Customer') {
    //open compare modal
    this.showModal = !this.showModal;
    let selectedDestinationCountry = this.destinationCountryList.filter(x => x.isocode === this.awbForm.get('consigneelocationdetails.ddlCountry')?.value);
    let selectedDestinationState = this.destinationStateList.filter(x => x.isocode === this.awbForm.get('consigneelocationdetails.ddlState')?.value);
    let selectedDestinationCity = this.destinationCityList.filter(x => x.isocode === this.awbForm.get('consigneelocationdetails.ddlCity')?.value);
    let destinationPincode = this.awbForm.get('consigneelocationdetails.txtPincode')?.value;
    destinationPincode = typeof destinationPincode?.pincode === 'string' ? destinationPincode.pincode : destinationPincode;

    let selectedOriginCountry = this.originCountryList.filter(x => x.isocode === this.awbForm.get('shipperlocationdetails.ddlCountry')?.value);
    let selectedOriginState = this.originStateList.filter(x => x.isocode === this.awbForm.get('shipperlocationdetails.ddlState')?.value);
    let selectedOriginCity = this.originCityList.filter(x => x.isocode === this.awbForm.get('shipperlocationdetails.ddlCity')?.value);
    let originPincode = this.awbForm.get('shipperlocationdetails.txtPincode')?.value;
    destinationPincode = typeof originPincode?.pincode == 'string' ? originPincode.pincode : originPincode;

    let selectedVendor = this.vendorOptions.filter(x => x.id === this.awbForm.get('ddlVendor')?.value);
    let selectedProduct = this.productOptions.filter(x => x.id == this.awbForm.get('ddlProduct')?.value);
    let selectedService = this.serviceOptions.filter(x => x.id == this.awbForm.get('ddlService')?.value);
    const applicable_weight = Number(this.piecesForm.get('totalactualweight')?.value) > Number(this.piecesForm.get('totalvolumetricweight')?.value) ?
      this.piecesForm.get('totalactualweight')?.value :
      this.piecesForm.get('totalvolumetricweight')?.value;

    const reqObj = {
      searchtype: paramSearchType,
      // type: this.activeTabId === 1 ? 'Customer' : 'Vendor',
      customer: this.awbForm.controls.ddlCustomer.value,
      //vendor: this.awbForm.controls.ddlVendor.value || null,
      vendor: selectedVendor?.length ? selectedVendor : null,
      service: selectedService?.length ? selectedService[0]?.servicename : null,
      product: selectedProduct?.length ? selectedProduct[0]?.code : null,
      origincountry: selectedOriginCountry,
      originstate: selectedOriginState,
      origincity: selectedOriginCity,
      originpincode: originPincode || null,
      destinationcountry: selectedDestinationCountry,
      destinationstate: selectedDestinationState,
      destinationcity: selectedDestinationCity,
      destination_pincode: destinationPincode,
      weight: applicable_weight,
      //actual_weight: this.awbForm.controls.txtActualWeight.value,
      //volumetric_weight: this.awbForm.controls.txtVolumetricWeight.value,
    }
    // console.log('reqObj', reqObj);
    //const customerId = this.awbForm.controls.ddlCustomer.value;
    this.ngxLoaderService.start();
    try {
      this.rateUploadService.getRateCompare(reqObj).subscribe(async (res) => {
        if (res && res.success) {
          await this.openCompareModal(res?.data);
          // console.log('reqObj', this.compareRatesRowData);
          // if (!res.data.length) {
          //   this.appCoreService.showMessage(res.message, '', 'info');
          // }
        }
        this.ngxLoaderService.stop();
      });
    } catch (e) {
      this.ngxLoaderService.stop();
      console.log(e);
    }
  }

  async openWarningDialogForKyc(msg: any, id?: number) {
    const result = await Swal.fire({
      // title: 'Success!',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'OK',
      showCancelButton: true,
      allowEscapeKey: false,
      allowOutsideClick: false,
      allowEnterKey: true
    });
    return result.isConfirmed;
  }

  getCustomerApplicableTax() {
    try {
      let customer = this.awbForm.controls.ddlCustomer.value || null;
      let selectedProduct = this.productOptions.filter(x => x.id == this.awbForm.get('ddlProduct')?.value);

      let reqObj = {
        customer: customer || null,
        searchtype: !customer ? 'Tariff' : 'Customer',
        product: selectedProduct ? selectedProduct[0]?.code : null,
        bookingdate: this.formateDate(new Date()).dateString,
        company: this.awbForm.controls.ddlCompanies.value
      }

      this.rateUploadService.getCustomerTaxes(reqObj).subscribe((res) => {
        //if (res && res.success) {
        if (res) {
          //console.log('customerConfig',res);
          this.customerConfig.tax = {
            igst: Number(res.data?.[0]?.igst),
            cgst: Number(res.data?.[0]?.cgst),
            sgst: Number(res.data?.[0]?.sgst),
            igstapplicable: res.data?.[0]?.isIGSTApplicable || false
          }
        }
        // if (!res.data.length) {
        //   this.appCoreService.showMessage(res.message, '', 'info');
        // }
        //}
      });
    } catch (error) {
    }
  }

  getVendorApplicableTax() {
    try {
      // let vendor = this.awbForm.controls.ddlVendor.value || null;
      let selectedProduct = this.deliveryProductList.filter(x => x.id == this.awbForm.get('forwardinginfo.ddlDeliveryProduct')?.value);
      let selectedVendor = this.deliveryVendorList.filter(x => x.id == this.awbForm.get('forwardinginfo.ddlDeliveryVendor')?.value);

      let reqObj = {
        vendor: selectedVendor || null,
        searchtype: !selectedVendor ? 'Tariff' : 'Vendor',
        product: selectedProduct ? selectedProduct[0]?.code : null,
        bookingdate: this.formateDate(new Date()).dateString,
        company: this.awbForm.get('ddlCompanies')?.value
      }

      this.rateUploadService.getCustomerTaxes(reqObj).subscribe((res) => {
        //if (res && res.success) {
        if (res) {
          //console.log('customerConfig',res);
          this.vendorConfig.tax = {
            igst: Number(res.data?.[0]?.igst),
            cgst: Number(res.data?.[0]?.cgst),
            sgst: Number(res.data?.[0]?.sgst),
            igstapplicable: res.data?.[0]?.isIGSTApplicable || false
          }
        }
        // if (!res.data.length) {
        //   this.appCoreService.showMessage(res.message, '', 'info');
        // }
        //}
      });
    } catch (error) {
    }
  }

  onChangeCompany(value) {
    if (value) {
      // Filter customers whose companyids array contains at least one matching company ID
      this.customerList = this.resCustomerList.filter(cust => cust.companyids.some(id => id == value));

      // filter products based on company operation type
      this.awbForm.get('ddlProduct').reset();
      const companyOperationTypeArray = this.companyList.find(x => x.id === value)?.operationtype;
      this.productOptions = this.resProductOptions.filter(option => companyOperationTypeArray?.includes(option.producttype));
    }
  }

  onProductChange(productid: number) {
    this.selectedProduct = this.productOptions.find(x => x.id == productid);
    const selectedProduct = this.selectedProduct;

    //bind delivery product 
    this.awbForm.get('forwardinginfo').get('ddlDeliveryProduct').setValue(productid);
    this.awbForm.get('forwardinginfo').get('ddlDeliveryProduct').markAsDirty();

    // bind currencylist removing dublicates
    this.currencyList = Array.from(new Set(this.originCountryList?.filter((x) => x.currencycode !== '' && x.currencycode !== null)))
    // bind currecycode
    const defaultCountryCode = this.appCoreService.GetUserData()?.metaInfo?.defaultcountry
    this.currencyCode = this.currencyList.find(x => x.isocode === defaultCountryCode)?.currencycode;
    this.currencyCode && this.awbForm.get('ddlCurrency').setValue(this.currencyCode);

    // remove shipment value mandate
    selectedProduct?.shipmenttype === 'DOX' ? this.awbForm.get('txtShipmentValue').disable() : this.awbForm.get('txtShipmentValue').enable();
    // Filter destination
    if (selectedProduct?.producttype === 'Domestic') {
      // remove shipment value mandate
      // this.productFilteredCountryList = this.destinationCountryList.filter(item => item.isocode === defaultCountryCode);

      this.productFilteredCountryList = this.CountryList.filter(item => item.isocode === defaultCountryCode);
      this.awbForm.get('txtShipmentValue').clearValidators();
      this.awbForm.get('txtShipmentValue').setValidators([AmountValidation]);

      // remove mobileno. from shipper consginee mandate
      this.awbForm.get('shipperlocationdetails.txtMobileNo').clearValidators();
      this.awbForm.get('shipperlocationdetails.txtMobileNo').setValidators([MobileNumberValidation]);
      this.awbForm.get('consigneelocationdetails.txtMobileNo').clearValidators();
      this.awbForm.get('consigneelocationdetails.txtMobileNo').setValidators([MobileNumberValidation]);

    } else if (selectedProduct.producttype === 'International') {
      if (selectedProduct?.shipmenttype === 'NDOX') {
        this.awbForm.get('txtShipmentValue').setValidators([Validators.required, AmountValidation]);

        this.awbForm.get('shipperlocationdetails.txtMobileNo').clearValidators();
        this.awbForm.get('shipperlocationdetails.txtMobileNo').setValidators([Validators.required, MobileNumberValidation]);
        this.awbForm.get('consigneelocationdetails.txtMobileNo').clearValidators();
        this.awbForm.get('consigneelocationdetails.txtMobileNo').setValidators([Validators.required, MobileNumberValidation]);
      } else {
        this.awbForm.get('txtShipmentValue').clearValidators();
        this.awbForm.get('txtShipmentValue').setValidators([AmountValidation]);

        this.awbForm.get('shipperlocationdetails.txtMobileNo').clearValidators();
        this.awbForm.get('shipperlocationdetails.txtMobileNo').setValidators([MobileNumberValidation]);
        this.awbForm.get('consigneelocationdetails.txtMobileNo').clearValidators();
        this.awbForm.get('consigneelocationdetails.txtMobileNo').setValidators([MobileNumberValidation]);
      }
      // this.productFilteredCountryList = this.destinationCountryList.filter(item => item.isocode !== defaultCountryCode);
      this.productFilteredCountryList = this.CountryList.filter(item => item.isocode !== defaultCountryCode);
    } else {
      // this.productFilteredCountryList = this.destinationCountryList;
      this.productFilteredCountryList = this.CountryList;
      this.awbForm.get('txtShipmentValue').clearValidators();
      this.awbForm.get('txtShipmentValue').setValidators([AmountValidation]);

      this.awbForm.get('shipperlocationdetails.txtMobileNo').clearValidators();
      this.awbForm.get('shipperlocationdetails.txtMobileNo').setValidators([MobileNumberValidation]);
      this.awbForm.get('consigneelocationdetails.txtMobileNo').clearValidators();
      this.awbForm.get('consigneelocationdetails.txtMobileNo').setValidators([MobileNumberValidation]);
    }
    this.awbForm.get('txtShipmentValue').updateValueAndValidity();

    this.awbForm.get('shipperlocationdetails.txtMobileNo').updateValueAndValidity();
    this.awbForm.get('consigneelocationdetails.txtMobileNo').updateValueAndValidity();

    let ConsigneeCountry = this.awbForm.get('consigneelocationdetails.ddlCountry').value;
    if (!this.productFilteredCountryList?.filter(x => x.isocode === ConsigneeCountry)?.length) {
      this.awbForm.get('consigneelocationdetails.ddlCountry').setValue(null);
    }

    // //bind company on product change
    // this.companyList = this.respCompanyList;
    // if (selectedProduct?.producttype) {
    //   this.companyList = this.companyList.filter(item => item.operationtype.includes(selectedProduct.producttype));
    // }

    this.checkVolumetricDetail();
    this.getCustomerApplicableTax();

    /*on product change call rate api*/
    this.getAWBCharges(RateCategory.CUSTOMER);
    this.CustomerVolumetricRequired();
  }

  lablePrintOptionChange(printType: string, awbNumber: string) {
    try {
      switch (printType) {
        case 'AWBByPieces':
          this.printPDF(awbNumber, 'awb-pieces');
          break;
        case "AWB":
          this.printPDF(awbNumber, 'awb');
          break;
        case "BoxLabel":
          this.printPDF(awbNumber, 'box-label');
          break;
        case "VendorLabel":
          this.printPDF(awbNumber, 'vendor-label');
          break;
        case "Label":
          this.printPDF(awbNumber, 'label');
          break;
        case "CommercialInvoice":
          this.printPDF(awbNumber, 'commercial-invoice');
          break;
        case "AuthorityLetter":
          this.printPDF(awbNumber, 'authority-letter');
          break;
        case "PrintAll":
          this.printPDF(awbNumber, 'all');
          break;
        default:
          break;
      }
    } catch (e) {
      console.log(e);
    }
  }

  async printPDF(awbNumber: string, printType: string): Promise<void> {
    // Handle the label printing case
    if (printType === 'label') {
      const ngbModalOptions: NgbModalOptions = {
        ariaLabelledBy: 'modal-basic-title',
        size: 'md',
        backdrop: 'static',
        keyboard: false,
        centered: true
      };
      const awbdata = this.rowData.find((item) => item?.awbnumber === awbNumber);
      const modalRef = this.modalService.open(LabelPrintComponent, ngbModalOptions);
      modalRef.componentInstance.awbNumber = awbNumber;
      modalRef.componentInstance.totalPieceNo = awbdata?.totalpieces;
      return;
    }

    // Prepare parameters for PDF generation
    const inputParams = { awbNumber, printType };
    this.ngxLoaderService.start();

    try {
      this.awbService.GeneratePDF(inputParams).subscribe(async (res) => {
        if (res && res.success) {
          this.ngxLoaderService.stop();
          const pdfString = res.data;
          if (this.isMobileDevice()) {
            this.printPDFMobile(pdfString);
          } else {
            printJS({ printable: pdfString, type: 'pdf', base64: true, showModal: true });
          }
        } else if (!res?.success && res?.data?.err_msg) {
          // when error in parsing document to generate pdf - intermittent
          this.ngxLoaderService.stop();
          this.appCoreService.showMessage(res?.data?.err_msg, '', 'error');
        }
      });
    } catch (error) {
      this.ngxLoaderService.stop();
      console.error('PDF Generation Error:', error);
    }
  }

  isMobileDevice(): boolean {
    return /Mobi|Android/i.test(navigator.userAgent);
  }

  printPDFMobile(pdfString: string): void {
    // console.log("mobile pringing");

    const printWindow = window.open('', '', 'width=600,height=800');

    if (!printWindow) {
      console.error('Failed to open print window');
      return;
    }

    // Write the PDF data into the print window
    printWindow.document.write('<html><head><title>Print</title></head><body>');
    printWindow.document.write('<embed id="pdfEmbed" width="100%" height="100%" src="data:application/pdf;base64,' + pdfString + '" type="application/pdf">');
    printWindow.document.write('</body></html>');

    // Ensure the document is fully loaded before triggering the print dialog
    printWindow.document.close();

    // Get the embed element
    const embedElement = printWindow.document.getElementById('pdfEmbed') as HTMLEmbedElement;

    embedElement.onerror = () => {
      console.error('Failed to load PDF for printing');
      printWindow.close();
    };
  }

  piecesValidate(event: KeyboardEvent): void {
    const val = (event.target as HTMLInputElement).value;
    if (event.keyCode !== 8 && event.keyCode !== 46 && val?.length >= 10 && event.keyCode !== 9) {
      event.preventDefault();
    }
    if (event.keyCode == 69 || event.keyCode == 107) {
      event.preventDefault();
    }
  }

  totalPiecesValidate(event: KeyboardEvent): void {
    const val = (event.target as HTMLInputElement).value;
    if (event.keyCode !== 8 && event.keyCode !== 46 && val?.length >= 3 && event.keyCode !== 9) {
      event.preventDefault();
    }
    if (event.keyCode == 69 || event.keyCode == 107 || event.keyCode == 190) {
      event.preventDefault();
    }
  }

  documentTypeValidation(controlName: string, resetControl = false): void {
    const controls = {
      shipperdoc: {
        docType: this.awbForm.get('ddlShipperDocumentType')?.value,
        docNoControl: this.awbForm.get('txtShipperDocumentNo'),
        stateIsoCode: this.awbForm.get('shipperlocationdetails.ddlState')?.value,
        validationMsg: 'shipperDocValidationMsg',
      },
      consigneedoc: {
        docType: this.awbForm.get('ddlConsigneeDocumentType')?.value,
        docNoControl: this.awbForm.get('txtConsigneeDocumentNo'),
        stateIsoCode: this.awbForm.get('consigneelocationdetails.ddlState')?.value,
        validationMsg: 'consigneeDocValidationMsg',
      },
      kycdoc: {
        docType: this.kycForm.get('ddlDocumentType')?.value,
        docNoControl: this.kycForm.get('txtDocumentNo'),
        stateIsoCode: this.awbForm.get('shipperlocationdetails.ddlState')?.value,
        validationMsg: 'kycDocValidationMsg',
      },
    };

    const control = controls[controlName];

    if (!control) {
      console.error('Invalid controlName:', controlName);
      return;
    }

    const { docType, docNoControl, stateIsoCode, validationMsg } = control;
    if (!docNoControl) {
      console.error('Document control not found for:', controlName);
      return;
    }

    // Generate GST Pattern
    const stateList = controlName === 'shipperdoc' || controlName === 'kycdoc' ? this.originStateList : this.destinationStateList;

    let taxCode = stateIsoCode ? stateList?.find(row => row.isocode === stateIsoCode)?.taxcode : null;
    // console.log(stateIsoCode, stateList, taxCode);

    if (controlName === 'shipperdoc' && this.isShipperCustomerBinded && this.customerData?.[0]?.location?.state) {
      taxCode = this.originStateList.find(x => x.isocode === this.customerData[0].location.state)?.taxcode || taxCode;
    }

    const gstPattern = taxCode && !isNaN(Number(taxCode)) && Number(taxCode) !== 0
      ? new RegExp(`^(${taxCode})[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[0-9A-Z]{1}$`)
      : regexPattern.generalDocValidation;

    // Validation patterns
    const regexPatterns = {
      'Aadhaar Number': { regex: regexPattern.adhaarValidation, msg: 'Invalid Aadhaar No. Format.', charLength: '12' },
      'PAN Number': { regex: regexPattern.panValidation, msg: 'Invalid PAN No. Format.', charLength: '10' },
      'GSTIN (Normal)': { regex: gstPattern, msg: 'Invalid GST No. Format.', charLength: '15' },
      'Others': { regex: regexPattern.maxCharacterDocValidation, msg: 'Max 150 characters allowed.', charLength: '150' }
    };

    // Fallback to default validation if docType not found
    const validation = regexPatterns[docType] ?? {
      regex: regexPattern.generalDocValidation,
      msg: 'Max 30 characters allowed.',
      limitDigit: '30'
    };

    this.docCharacterLimit = validation.charLength;
    // Reset and apply validators
    if (['shipperdoc', 'consigneedoc', 'kycdoc'].includes(controlName)) {
      if (resetControl) {
        docNoControl.reset();
      }

      docNoControl.clearValidators();
      docNoControl.updateValueAndValidity();

      // Conditionally apply Validators.required only if controlName and its value exist
      const validatorsArray = controlName === 'kycdoc'
        ? [Validators.pattern(validation.regex)]
        : control?.docType
          ? [Validators.pattern(validation.regex), Validators.required]
          : [Validators.pattern(validation.regex)];

      docNoControl.setValidators(validatorsArray);

      docNoControl.updateValueAndValidity();
    }
    docNoControl.updateValueAndValidity();
    this[validationMsg] = validation.msg;

  }

  validateGSTINStateSelection(gstin: string, docType: string): void {
    const formMap = {
      shipper: {
        stateControl: this.awbForm.get('shipperlocationdetails.ddlState'),
        docTypeControl: this.awbForm.get('ddlShipperDocumentType'),
        docNoControl: this.awbForm.get('txtShipperDocumentNo'),
      },
      consignee: {
        stateControl: this.awbForm.get('consigneelocationdetails.ddlState'),
        docTypeControl: this.awbForm.get('ddlConsigneeDocumentType'),
        docNoControl: this.awbForm.get('txtConsigneeDocumentNo'),
      },
      kyc: {
        stateControl: this.awbForm.get('shipperlocationdetails.ddlState'),
        docTypeControl: this.kycForm.get('ddlDocumentType'),
        docNoControl: this.kycForm.get('txtDocumentNo'),
      },
    };

    const currentForm = formMap[docType];
    if (!currentForm || !gstin) return;

    const { stateControl, docTypeControl, docNoControl } = currentForm;

    if (!stateControl?.value && docTypeControl?.value === 'GSTIN (Normal)') {
      docNoControl?.reset();
      this.appCoreService.showMessage('Please Select State to Validate GSTIN', '', 'error');
    }
  }

  getChargesSummary(chargesdetails: any[], cb: any) {
    let chargeOtherTotal = 0, chargeTotalFuel = 0, chargeTotalAmount = 0, contract_amount = 0, chargeSubTotal = 0, igstTotal = 0, cgstTotal = 0, sgstTotal = 0;
    for (const charge of chargesdetails) {
      chargeOtherTotal += charge?.chargesdescription?.toLowerCase() !== "freight" ? parseFloat(charge.itemamount) : 0;;
      chargeTotalFuel += parseFloat(charge.fuelamount);
      chargeTotalAmount += parseFloat(charge.itemtotal);
      contract_amount += charge?.chargesdescription?.toLowerCase() === "freight" ? charge.itemamount : 0;

      igstTotal += charge?.tax ? parseFloat(charge.igst || 0) : 0;
      sgstTotal += charge?.tax ? parseFloat(charge.sgst || 0) : 0;
      cgstTotal += charge?.tax ? parseFloat(charge.cgst || 0) : 0;
    }
    chargeSubTotal = chargeOtherTotal + contract_amount;
    const obj = {
      subtotal: chargeSubTotal,
      othercharges: chargeOtherTotal,
      contractcharges: contract_amount,
      totalfuel: chargeTotalFuel,
      totalamount: chargeTotalAmount,
      igst: igstTotal.toFixed(3),
      cgst: cgstTotal.toFixed(3),
      sgst: sgstTotal.toFixed(3)
    }
    cb(obj);
  }

  calculateShipmentValue() {
    this.totalShipment = 0;
    const txtShipmentValue = this.awbForm.get('txtShipmentValue');
  
    if (this.containers?.controls?.length) {
      this.containers.controls.forEach((item: any) => {
        const subItems = item?.controls?.containeritemsgroup?.value?.subitems ?? [];
  
        const hasPositiveAmount = subItems.some(s => s?.itemamount > 0);
        const isDOX = this.selectedProduct?.shipmenttype === 'DOX';
        const isInternational = this.selectedProduct?.producttype === 'International';
  
        if (hasPositiveAmount) {
          txtShipmentValue?.disable();
          txtShipmentValue?.clearValidators();
        } else {
          isDOX ? txtShipmentValue?.disable() : txtShipmentValue?.enable();
          txtShipmentValue?.clearValidators();
          txtShipmentValue?.setValidators(isInternational ? [AmountValidation, Validators.required] : [AmountValidation]);
        }
  
        txtShipmentValue?.updateValueAndValidity();
  
        subItems.forEach(s => this.totalShipment += Number(s?.itemamount) || 0);
      });
    }
  
    txtShipmentValue?.setValue(this.totalShipment > 0 ? this.totalShipment : null);
  }


  proceedWithAwbInscan() {
    // console.log("Tesrting");
    if (this.inscanAWB) {
      this.ngxLoaderService.start();
      const reqObj = {
        awbnumber: this.inscanAWB,
        generatedfromid: this.selectedSCId
      };

      this.awbService.AwbInscan(reqObj).subscribe((res) => {
        this.ngxLoaderService.stop();
        if (res && res.success) {
          // console.log("res.data", res.data);
          // if (res.data.misroute) {
          this.appCoreService.showMessage('AWB Inscan successfully', 'Success', 'success');
          this.router.navigate(['/operation/awb']);
          // }             
        } else if (res && !res.success) {
          this.appCoreService.showMessage(res.message, 'Error', 'error');
        } else if (res && res?.error) {
          this.appCoreService.showMessage(res?.message || 'An error occurred', 'Warning', 'warning');
        }
      });
    } else {
      this.appCoreService.showMessage('AWB No Can not be empty To add Inscan', 'Warning', 'warning');
      this.router.navigate(['/operation/awb']);
    }
  }

  async configData() {
    try {
      const reqObj: any = this.awbConfigForm.getRawValue();

      if (!reqObj?.configDetails || reqObj.configDetails.length === 0) {
        this.appCoreService.showMessage('No configuration details found.', 'Warning', 'warning');
        return;
      }

      const repeatDataMap: { [key: string]: string } = {
        'Repeat Booking Date': 'bookingdate',
        'Repeat Product': 'productid',
        'Repeat Customer': 'customerid',
        'Repeat Vendor': 'vendorid',
        'Repeat Vendor Service': 'vendorserviceid',
        'Repeat Destination': 'destination',
      };

      reqObj.configDetails.forEach((item: any) => {
        const name = item?.name;
        const isChecked = item?.ischecked;

        const key = repeatDataMap[name];
        if (key) {
          const index = this.repeatData.findIndex((data) => data.key === key);
          if (index !== -1) {
            this.repeatData[index].value = isChecked ? this.awbForm.get(key)?.value || null : null;
            this.repeatData[index].isrepeat = !!isChecked;
          }
        }
      });

      this.setRepeatDataToLocal();

      // Success message
      this.appCoreService.showMessage('Record Saved Successfully.', 'Success', 'success');
      this.hide();
    } catch (err) {
      console.error("Error processing config data:", err);
      this.appCoreService.showMessage('An error occurred while saving the record.', 'Error', 'error');
    }
  }

  async updateRepeatData() {
    const data: any = this.appCoreService.GetUserData();
    if (data?.repeatedawbdata) {
      this.repeatData.forEach(async (item) => {
        const repeatedData = data.repeatedawbdata?.[item.key]; // Get corresponding data

        const isRepeatChecked = repeatedData.isrepeat;
        // console.log('repeatedData', repeatedData);
        // console.log('isRepeatChecked', isRepeatChecked);

        switch (item.key) {
          case 'bookingdate':
            this.setIsChecked('Repeat Booking Date', isRepeatChecked);
            if (isRepeatChecked) {
              const formattedDate = this.utilities.FormatDateWithTime(0, repeatedData.value).dateTimeString;
              this.awbForm.get('txtDateTime')?.setValue(formattedDate);
            }
            break;

          case 'productid':
            this.setIsChecked('Repeat Product', isRepeatChecked);
            if (isRepeatChecked) {
              this.awbForm.get('ddlProduct')?.setValue(repeatedData.value);
            }
            break;

          case 'customerid':
            this.setIsChecked('Repeat Customer', isRepeatChecked);
            if (isRepeatChecked) {
              this.awbForm.get('ddlCustomer')?.setValue(repeatedData.value);
            }
            break;

          case 'vendorid':
            this.setIsChecked('Repeat Vendor', isRepeatChecked);
            if (isRepeatChecked) {
              this.awbForm.get('ddlVendor')?.setValue(repeatedData.value);
              await this.getAllVendorServices();
            }
            break;

          case 'vendorserviceid':
            this.setIsChecked('Repeat Vendor Service', isRepeatChecked);
            if (isRepeatChecked) {
              this.awbForm.get('ddlService')?.setValue(repeatedData.value);
            }
            break;

          case 'destination':
            this.setIsChecked('Repeat Destination', isRepeatChecked);
            if (isRepeatChecked) {
              this.consigneeLocationInfo = {
                ...this.consigneeLocationInfo,
                location: repeatedData.value ?? {}
              }
            }
            break;

          default:
        }
      });

      // Update `repeatData` from form values
      this.repeatData = this.repeatData.map((item) => ({
        ...item,
        value: this.awbForm.get(item.key)?.value || null,
      }));
    }
  }

  setRepeatDataToLocal() {
    const userdata: any = this.appCoreService.GetUserData();

    // Map form values into repeatData
    const formData = {
      bookingdate: this.awbForm.get('txtDateTime')?.value || null,
      customerid: this.awbForm.get('ddlCustomer')?.value || null,
      vendorid: this.awbForm.get('ddlVendor')?.value || null,
      productid: this.awbForm.get('ddlProduct')?.value || null,
      vendorserviceid: this.awbForm.get('ddlService')?.value || null,
      destination: {
        country: this.awbForm.get('consigneelocationdetails.ddlCountry')?.value,
        state: this.awbForm.get('consigneelocationdetails.ddlState')?.value,
        city: this.awbForm.get('consigneelocationdetails.ddlCity')?.value,
      },
    };

    // Update repeatData with form values and existing isrepeat flags
    this.repeatData.forEach((item: any) => {
      item.value = formData[item.key] || null;
    });

    // Save updated repeatData to local storage
    userdata.repeatedawbdata = this.repeatData.reduce((acc: any, item: any) => {
      acc[item.key] = { value: item.value, isrepeat: item.isrepeat };
      return acc;
    }, {});

    // Store the updated userdata in localStorage
    localStorage.setItem('ud', JSON.stringify(userdata));
  }


  setIsChecked(name: string, isChecked: boolean) {
    const configDetailsArray = this.awbConfigForm.get('configDetails') as FormArray;
    const detailIndex = this.configDetail.findIndex(detail => detail.name === name);

    if (detailIndex !== -1) {
      const detailFormGroup = configDetailsArray.at(detailIndex) as FormGroup;
      detailFormGroup.patchValue({ ischecked: isChecked });
    } else {
      console.error('Detail with the given name not found');
    }
  }

  get configDetails(): FormArray {
    return this.awbConfigForm.get('configDetails') as FormArray;
  }

  showConfiguration() {
    this.isModalOpen = !this.isModalOpen;
    //document.body.classList.toggle('right-bar-enabled');
  }

  hide() {
    //document.body.classList.remove('right-bar-enabled');
    this.isModalOpen = false;
  }

  getAwbConfigs() {
    this.configService.getAllGlobalConfig().subscribe((res) => {
      if (res && res.success) {
        this.checkAwbConfig(res?.data.filter(x => x.categoryname == 'AWB'));
      }
    })
  }

  async getServiceConfig() {
    const serviceid = this.awbForm.get('ddlService')?.value;
    if (serviceid) {
      const res = await lastValueFrom(this.vendorService.GetVendorServiceConfigs(serviceid));
      if (res?.success) {
        this.checkServiceConfig(res?.data?.config)
      }
    }
  }

  checkAwbConfig(awbconfig: any[]) {
    awbconfig.forEach(config => {
      switch (config.configurationcode) {
        case 'DISABLE_PAYMENT_MODE':
          this.awbConfig.isPaymentModeDisable = config.active;
          break;
        case 'CUSTOMER_LOGIN_VOLUMETRIC_REQUIRED_ON_NDOX':
          this.awbConfig.isVolumetricRequired = config.active;
          break;
        case 'KYC_MANDATORY':
          this.awbConfig.isKYCMandatory = config.active;
          break;
        default:
          break;
      }
    });
  }
  

  checkServiceConfig(serviceconfig: any) {
    for (let config in serviceconfig?.proforma) {
      switch (config) {
        case 'documentrequired':
          this.serviceConfig.proforma.documentrequired = serviceconfig.proforma[config];
          break;
        case 'detailsmandatory':
          this.serviceConfig.proforma.detailsmandatory = serviceconfig.proforma[config];
        default:
          break;
      }
    }
  }

  async warningDialog(msg: any) {
    const isHtml = msg.includes('<') && msg.includes('>');
    // const confirmText = isHtml ? ''/operation/awb'<i class="bx bx-download"></li> Download' : null;
    const res = await Swal.fire({
      title: 'Warning!',
      [isHtml ? 'html' : 'text']: msg,
      icon: 'warning',
      showCloseButton: true,
      allowEscapeKey: false,
      allowOutsideClick: false,
      allowEnterKey: true
    });
  }

  awbBuyerDetails() {
    const isbuyerdetails = this.proformaForm.get('chkBuyerDetails')?.value;
    this.isAwbBuyerDetailsChk = isbuyerdetails;
  }

  updatePickedByWhome(id, awbnumber) {
    try {
      let obj = {
        fieldexecutiveid: id,
        awbnumber: awbnumber
      }
      this.awbService.updatePickedByWhom(obj).subscribe((res) => {
        if (res && res.success) {
          Swal.close();
          this.router.navigate(['/operation/awb']);
          this.toastr.success(`Field Executive Assinged Successfully To ${awbnumber}`);
        }
      })
    } catch (err) {
      console.error(err);
    }
  }


  getOptionsHtml(): string {
    this.fieldExeList = this.fieldExecutiveList.map(item => ({
      value: item.id,
      label: item.username
    }));
    const stringValue = this.fieldExeList.map(option => `<option value="${option.value}">${option.label}</option>`).join('');
    return stringValue;
  }

  // =============================================
  // Copy AWB Process

  bindAwb(awbid: number) {
    this.ngxLoaderService.start();
    const awbForm = this.awbForm
    this.awbService.GetById(awbid).subscribe(async (res) => {
      // console.log(" res.data : ",res.data)
      if (res && res.success) {
        // console.log('bindAwb-res', res);
        const resData = res?.data;
        const shipper = resData?.details.filter(x => x?.type === 'Shipper');
        const consignee = resData?.details.filter(x => x?.type === 'Consignee');
        // console.log("(BindAWb)shipper : ", shipper, "\n(BindAWb)chonsignee : ", consignee);
        const pieces = resData?.pieces;
        // const piecesDetails = resData?.pieces?.piecesDetails;
        // const piecesDetails = resData?.pieces?.containers;
        this.ReservedPiecesData = resData?.pieces;
        const performa = resData?.proforma;
        const csbDetails = resData?.proforma?.csbdetails;
        const buyerDetails = resData?.proforma?.awbbuyerdetails;
        const charges = resData?.charges;
        this.shipmentDetails.previousAmount = charges?.totalamount;
        const shipment = resData?.shipmentdetails;
        const forwardinginfo = resData?.forwardingdetails;
        const receipt = resData?.receipt;
        this.performaId = performa?.id;
        this.piecesId = pieces?.id;
        this.shipmentDetails.chargeId = charges?.id;
        this.shipmentDetails.shipmentId = shipment?.id;
        this.shipmentDetails.forwardingId = forwardinginfo?.id;
        this.shipmentDetails.receiptId = receipt?.id;

        if (shipper) {
          this.shipmentDetails.shipperAddressBookId = shipper[0]?.bookid;
          // console.log("shipperaddressbookid (bindawb): ", shipper[0])
        }

        if (consignee) {
          this.shipmentDetails.consigneeAddressBookId = consignee[0]?.bookid;
          // console.log("consigneeAddressBookId (bindawb): ", consignee[0])
        }

        if (!pieces) {
          this.addNewContainerCustom();
        }
        this.shipmentDetails.customerId = resData?.customerid;
        this.bindBookingDate(resData?.bookingdate);

        awbForm.patchValue({
          txtReferenceNo: resData?.referenceno,
          ddlCustomer: this.customerList.find(x => x.id == resData?.customerid)?.id,
          ddlCompanies: this.companyList.find(x => x.id == resData?.companyid)?.id,
          // txtDateTime: this.utilities.FormatDateWithTime(0, resData?.bookingdate)?.dateTimeString,
          ddlProduct: this.productOptions.find(x => x.id == resData?.productid)?.id,
          ddlVendor: this.vendorOptions.find(x => x.id == resData?.vendorid)?.id,
          ddlService: this.serviceOptions.find(x => x.id == resData?.serviceid)?.id,
          txtShipmentValue: resData?.shipmentvalue,
          ddlCurrency: resData?.currencycode,
          ddlChargeType: resData?.chargetypes,
          ddlPaymentType: resData?.paymenttype,

          // txtShipperName: shipper?.length ? shipper[0]?.info : '',
          // txtShipperContactPerson: shipper[0]?.info?.contactperson,
          // txtShipperEmail: shipper[0]?.info?.emailid,
          // txtConsigneeName: consignee?.length ? consignee[0]?.info : '',
          // txtConsigneeContactPerson: consignee[0]?.info?.contactperson,
          // txtConsigneeEmail: consignee[0]?.info?.emailid,
          txtShipperIecIoeNo: shipper[0]?.info?.iecno,
          txtConsigneeIecIoeNo: consignee[0]?.info?.iecno,
          ddlShipperDocumentType: shipper[0]?.kyc?.type,
          txtShipperDocumentNo: shipper[0]?.kyc?.no,
          ddlConsigneeDocumentType: consignee[0]?.kyc?.type,
          txtConsigneeDocumentNo: consignee[0]?.kyc?.no,

          txtTotalActualWeight: parseFloat(pieces?.totalactualweight),
          ddlActualWeightUnit: pieces?.actualweightunit,
        });
        //this.shipperLocationInfo = shipper?.length ? (shipper[0]?.location == null ? {} : shipper[0].location) : {};
        this.shipperLocationInfo = {
          ...this.shipperLocationInfo,
          location: shipper[0]?.location ?? {},
          info: shipper[0]?.info ?? {}
        }

        this.consigneeLocationInfo = {
          ...this.consigneeLocationInfo,
          location: consignee[0]?.location ?? {},
          info: consignee[0]?.info ?? {}
        }
        this.kycList = resData?.kyc;

        this.bindPiecesAndContainerList(pieces);

        const perfroma = {
          ddlCSBType: performa?.csbtype ?? 'csb4',
          ddlInvoiceTerm: performa?.termofinvoice,
          ddlGSTInvoice: performa?.isgstinvoice ? 'Yes' : 'No',
          txtCommercialInvoiceNo: performa?.commercialinvoiceno,
          ddlInvoiceDate: this.formateDate(performa?.invoicedate)?.dateString,
          ddlExportReason: performa?.exportreason,
          txtDepartmentNo: performa?.departmentno
        }

        this.proformaForm.patchValue(perfroma);

        if (csbDetails) {
          const details = {
            ddlLutIgst: csbDetails?.lut,
            txtTotalIgst: csbDetails?.totalisgt,
            txtBankAdCode: csbDetails?.bankadcode,
            txtBankAccount: csbDetails?.bankaccount,
            txtBankIfsc: csbDetails?.bankifsc,
            txtLutBondNo: csbDetails?.lutbondno,
            txtExchangeRate: csbDetails?.exchangerate,
            ddlFirm: csbDetails?.firm,
            nfeiCheck: csbDetails?.nfei,
            payOfIgstCheck: csbDetails?.payofigst,
            eCommerceCheck: csbDetails?.ecommerce,
            meisSchemaCheck: csbDetails?.meisschema
          }
          this.proformaForm.get('csbDetails').patchValue(details)
        }
        if (buyerDetails) {
          this.proformaForm.get('chkBuyerDetails').setValue(true);
          this.isAwbBuyerDetailsChk = true;
          this.proformaForm.get('buyerDetails').patchValue({
            txtName: buyerDetails?.name,
            txtPerson: buyerDetails?.contactperson,
            txtEmail: buyerDetails?.email,
            txtIECNo: buyerDetails?.iecno,
            txtAddress: buyerDetails?.address,
          })
        }

        performa?.csbtype && performa?.csbtype !== 'csb4' ? this.isCsbType = true : this.isCsbType = false;
        this.customerData = charges || [];
        // console.log('resData', resData);

        this.totalCustomerCharges = resData.charges?.totalamount || 0;
        this.totalForwardingCharges = resData.forwardingdetails.charges?.chargesdetails[0]?.itemamount;

        this.customerRowData = charges?.chargesdetails ? charges.chargesdetails : [];
        let receiptList = this.receiptList;
        let totalamountreceived = Number(receiptList.reduce((sum, receipt) => Number(sum) + Number(receipt.amountreceived), 0) ?? 0);

        let balanceamount = Number(this.totalCustomerCharges) - totalamountreceived;
        this.receiptForm.get('txtBalanceAmount').setValue(balanceamount);

        this.customerRowData = charges?.chargesdetails || [];
        this.reservedCustomerCharges = charges?.chargesdetails || [];

        awbForm.get('shipmentinfo').patchValue({
          ddlFieldExecutive: shipment?.fieldexecutive,
          ddlSalesExecutive: shipment?.salesexecutive,
          txtExpectedDeliveryDate: shipment?.expecteddeliverydate && this.formateDate(shipment?.expecteddeliverydate).dateTimeString,
          txtMasterAwbNo: shipment?.masterawbno,
          txtRunNo: shipment?.runno,
          txtSpecialInstruction: shipment?.specialinstructions
        });

        const specialdetails = shipment?.specialservicesdetail
        this.specialServicesForm.patchValue({
          dangerousGoodsCheck: specialdetails?.isdangerousgoods ? 'Yes' : 'No',
          ddldangerousGoods: specialdetails?.goodstype,
          dryIceCheck: specialdetails?.isdryice ? 'Yes' : 'No',
          txtDryIceWeight: specialdetails?.dryiceweight,
          insuranceCoverCheck: specialdetails?.isinsurancecovered ? 'Yes' : 'No',
          txtInsuranceCoverValue: specialdetails?.insurancecovervalue,
          txtBookingConfirmationNo: specialdetails?.bookingconfirmationno,
          ddlbillShipmentTo: specialdetails?.billshipmentto?.type,
          txtBillShipmentToAccNo: specialdetails?.billshipmentto?.accountno,
          ddlTaxAndDutiesPaidBy: specialdetails?.taxdutypaidby?.type,
          txtTaxAndDutiesAccNo: specialdetails?.taxdutypaidby?.accountno,
          ddlOutputFormat: specialdetails?.outputformat,
          bsoBrokerCheck: specialdetails?.brokerdetails.enabled,
        });

        this.bsoBrokerLocationInfo = specialdetails?.brokerdetails;

        this.SpecialServicesCheckChange();

        awbForm.get('forwardinginfo').patchValue({
          txtDeliveryAwb: forwardinginfo?.deliveryawbno,
          txtForwardingAwb: forwardinginfo?.forwardingawbno,
          ddlDeliveryProduct: forwardinginfo?.deliveryproduct,
          ddlDeliveryVendor: forwardinginfo?.deliveryvendor,
          txtVendorWeight: forwardinginfo?.deliveryweight,
          txtVendorInvoiceNo: forwardinginfo?.deliveryinvoice
        });

        this.receiptForm.patchValue({
          ddlPaymentMode: receipt?.paymentmode,
          txtAmountReceived: receipt?.amountreceived,
          txtBalanceAmount: receipt?.balanceamount,
          txtCashReceiptNo: receipt?.cashreceiptno,
          txtCashReceiptDate: this.formateDate(receipt?.cashreceiptdate)?.dateTimeString
        })

        await this.getAllVendorServices('forwardinginfo');
        //this.vendorData = forwardinginfo?.charges || [];
        this.vendorRowData = forwardinginfo?.charges?.chargesdetails ? forwardinginfo?.charges?.chargesdetails : [];
        this.reservedVendorCharges = forwardinginfo?.charges?.chargesdetails || [];
        await this.getAllVendorServices();
        awbForm.get('ddlService').setValue(resData?.serviceid);
        awbForm.get('forwardinginfo.ddlDeliveryService').setValue(this.deliveryServiceList.find(x => x.id == forwardinginfo?.deliveryservice)?.id);
        awbForm.get('forwardinginfo.ddlDeliveryService').markAsDirty();
        this.volumetricDetails();
        // this.calculateWeight();
        if (this.piecesDetailsList.length == 0) {
          this.addRow();
        }
        this.shipmentDetails.isAwbBind = true;

        this.getChargesSummary(charges?.chargesdetails, (data) => {
          this.customerData = data;
        });

        this.getChargesSummary(forwardinginfo?.charges?.chargesdetails, (data) => {
          this.vendorData = data;
        });

        if (awbForm.get('txtTotalPieces')?.value > 0) {
          awbForm.get('txtTotalVolumetricWeight').disable();
        }

        if (awbForm.get('txtTotalActualWeight')?.value > 0) {
          awbForm.get('txtTotalActualWeight').disable();
        }

        this.getCustomerApplicableTax();
        await this.getServiceConfig();
        this.ngxLoaderService.stop();
      } else if (res && !res.success) {
        this.ngxLoaderService.stop();
      }
    })
  }


  // getBookingDate(date?: any) {
  //   this.bookingDate = date ? new Date(date) : new Date();
  //   this.bookingDate.setDate(this.bookingDate.getDate() - 30);
  //   this.bookingDate = this.formateDate(this.bookingDate).dateTimeString;
  // }


  bindPiecesAndContainerList(pieces: IAWBPiecesDB) {
    if (pieces) {
      this.piecesForm.patchValue({
        totalpieces: pieces.totalpieces,
        totalactualweight: pieces.totalactualweight,
        totalvolumetricweight: pieces.totalvolumetricweight,
        totalchargeableweight: pieces.totalchargeableweight,
        actualweightunit: pieces.actualweightunit
      })
      pieces?.measurementunit ? this.awbForm.get('ddlMeasurementUnit').setValue(pieces?.measurementunit) : null;
      // this.piecesForm.get('totalpieces').setValue(pieces.totalpieces);
      pieces.containers.forEach((val, idx) => {
        this.childAwbList[idx] = val?.awblist?.[0]?.ischild ? val.awblist : false;
        this.addContainer(val.piecescount, val);
        if (val.containeritemsgroup) {
          for (const item of val.containeritemsgroup.subitems) {
            this.subItem(idx).push(this.newSubItem(item));
          }
        }
        // this.subItem(idx).insert(0, this.newSubItem(item));
      });
    }
  }

  addRow() {
    this.totalPiecesLength = this.piecesDetailsList.length + 1;
    if (this.totalPiecesLength > 50) {
      this.openWarningDialog("Please Enter Pieces Upto 50");
      return;
    }
    this.numberOfRowsToGenerate = this.totalPiecesLength - this.piecesDetailsList.length;
    for (let i = 0; i < (this.numberOfRowsToGenerate); i++) {
      const newRow = {
        piecesid: null,
        totalpieces: 1,
        totalpiecesdisable: false,
        piecelength: null,
        piecebreadth: null,
        pieceheight: null,
        actualweight: null,
        volumetricweight: null,
        chargeweight: null,
      };
      this.piecesDetailsList.push(newRow);
      this.shipmentDetails.totalPiecesDisable = false;
    }

    for (let i = 0; i < this.piecesDetailsList.length; i++) {
      this.piecesDetailsList = this.piecesDetailsList.map((item) => {
        if (item.piecesid) {
          return item
        }
        else {
          this.shipmentDetails.tempPiecesId = this.shipmentDetails.tempPiecesId + 1
          item.piecesid = this.shipmentDetails.tempPiecesId;
          return item;
        }
      })
    }
    this.calculateWeight();
  }

  calculateWeight(piecesfldDet?) {
    if (!piecesfldDet) {
      piecesfldDet = this.piecesDetailsList[0];
      if (!piecesfldDet) {
        return;
      }
    }

    let totalPieces: any = 0;
    let totalActualWeight: any = 0;
    let totalVolumetricWeight: any = 0;

    const totalpieces: any = parseFloat(piecesfldDet?.piecescount || 0);
    const actualweight: any = parseFloat(piecesfldDet?.piecesactualweight || 0);
    const volumetricweight: any = parseFloat(piecesfldDet?.piecesvolumetricweight || 0);

    piecesfldDet.chargeableweight = Math.max(parseFloat(volumetricweight), parseFloat(totalpieces ? (actualweight * totalpieces).toString() : actualweight));
    for (const item of this.piecesDetailsList) {
      totalPieces += parseFloat(item.piecescount);
      totalActualWeight += parseFloat(item.piecescount ? item.piecesactualweight * item.piecescount : item.piecesactualweight || 0);
      totalVolumetricWeight += parseFloat(item.pieceschargeableweight || 0);
    }

    totalActualWeight = totalActualWeight.toFixed(3);
    totalVolumetricWeight = totalVolumetricWeight.toFixed(3);
    // this.awbForm.get('txtTotalPieces').setValue(totalPieces);
    // this.awbForm.get('txtTotalActualWeight')?.setValue(totalActualWeight);
    // this.awbForm.get('txtTotalVolumetricWeight')?.setValue(totalVolumetricWeight);
    // this.awbForm.get('txtTotalChargeableWeight')?.setValue(Math.max(totalActualWeight, totalVolumetricWeight));
    this.insertIntoFinalList();
  }

  insertIntoFinalList() {
    const finalList: any[] = [];
    for (const item of this.piecesDetailsList) {
      if (item.actualweight !== null) {
        finalList.push(item);
      }
    }
    this.finalList = finalList;
    return;
  }

  newContainerWithData(pCount, containerObj): FormGroup {
    return this._fb.group({
      piecescounter: (this.containers.length + 1),
      piecescount: [pCount || containerObj?.piecescount, Validators.compose([Validators.required, Validators.min(1)])],
      piecesactualweight: [containerObj?.piecesactualweight, Validators.compose([Validators.required, Validators.pattern(/^\d{0,9}(\.\d{0,3})?$/)])],
      pieceslength: containerObj?.pieceslength,
      piecesbreadth: containerObj?.piecesbreadth,
      piecesheight: containerObj?.piecesheight,
      piecesvolumetricweight: containerObj?.piecesvolumetricweight,
      pieceschargeableweight: [{ value: containerObj?.pieceschargeableweight, disabled: true }],
      // subitems: this._fb.array([])
      containeritemsgroup: this._fb.group({
        containerid: containerObj.containeritemsgroup?.containerid,
        editmode: false,
        editsubitemid: 0,
        description: [null, Validators.compose([Validators.maxLength(40), Validators.required])],
        hsncode: [null, Validators.compose([Validators.maxLength(10)])],
        unit: ['KGS'],
        weight: [null, Validators.compose([Validators.pattern(/^[0-9]{0,9}(\.[0-9]{0,3})?$/)])],
        quantity: [null, Validators.compose([Validators.pattern(/^\d{1,3}$/), Validators.required, nonZeroValidator])],
        rate: [null, Validators.compose([Validators.required, Validators.pattern(/^[0-9]{0,10}(\.[0-9]{0,3})?$/)])],
        amount: [{ value: '', disabled: true }],
        subitems: this._fb.array([])
      })
    });
  }

  async openOverrideOrAddDialog(msg: string, data: any) {
    const result = await Swal.fire({
      text: msg,
      icon: 'warning',
      confirmButtonText: 'Add',
      showCancelButton: true,
      cancelButtonText: 'Override',
      allowEscapeKey: false,
      allowOutsideClick: false,
      allowEnterKey: true
    })

    if (result?.isConfirmed) {
      return true;
    } else return false;
  }

  upsertReceipt(add: boolean = false) {
    try {
      this.isReceiptFormSubmitted = true;
      if (this.receiptForm.valid) {
        let totalamountreceived = Number(this.receiptForm.get('txtAmountReceived')?.value);

        if (add)
          totalamountreceived += Number(this.receiptList.reduce((sum, receipt) => sum + receipt.amountreceived, 0) ?? 0);

        let balanceamount = Number(this.totalCustomerCharges) - totalamountreceived;

        if (balanceamount < 0) {
          this.appCoreService.showMessage("Received Amount can't be greater than Balance Amount.", 'Warning', 'warning');
          return;
        }

        this.receiptForm.get('txtBalanceAmount').setValue(balanceamount);

        const reqObj = {
          paymentmode: this.receiptForm.get('ddlPaymentMode')?.value,
          paymentmodetype: this.paymentOptions.find((item) => item.id == this.receiptForm.get('ddlPaymentMode')?.value)?.name,
          amountreceived: parseFloat(this.receiptForm.get('txtAmountReceived')?.value),
          // balanceamount: balanceamount,
          cashreceiptno: this.receiptForm.get('txtCashReceiptNo')?.value,
          cashreceiptdate: this.receiptForm.get('txtCashReceiptDate')?.value,
        }

        if (add) {
          this.receiptList.push(reqObj)
          this.resetReceiptForm();
        } else {
          this.receiptList[this.receiptIndex] = reqObj;
          this.resetReceiptForm();
        }
        // this.isReceiptFormSubmitted = false;
        this.submitBtn.nativeElement.focus();
      }
    } catch (err) {
      console.log('Error', err);
    }
  }

  editReceipt(index: number) {
    try {
      this.isReceiptEdit = true;
      this.receiptForm.patchValue({
        ddlPaymentMode: this.receiptList[index]?.paymentmode,
        txtAmountReceived: this.receiptList[index]?.amountreceived,
        txtBalanceAmount: Number(this.receiptForm.get('txtBalanceAmount').value) + Number(this.receiptList[index]?.amountreceived),
        txtCashReceiptNo: this.receiptList[index]?.cashreceiptno,
        txtCashReceiptDate: this.receiptList[index]?.cashreceiptdate
      });
      this.receiptIndex = index;
    } catch (err) {
      console.log('Error', err);
    }
  }

  async deleteReceipt(index: any) {
    try {
      const confirmed = await this.openConfirmationDialog('Are you sure you want to delete ?');
      if (confirmed) {
        // let totalamountreceived = Number(this.receiptList.reduce((sum, receipt) => sum + receipt.amountreceived, 0) ?? 0);
        let deletedEntry = this.receiptList[index];
        this.receiptList.splice(index, 1);

        let previousbalanceamount = Number(this.receiptForm.get('txtBalanceAmount').value);
        let balanceamount = previousbalanceamount + Number(deletedEntry?.amountreceived);
        this.receiptForm.get('txtBalanceAmount').setValue(balanceamount);
      }
    } catch (err) {
      console.log('Error', err);
    }
  }

  resetReceiptForm() {
    this.receiptIndex = null;
    this.isReceiptEdit = false;
    this.isReceiptFormSubmitted = false;

    // This will clear form values AND reset validation states
    this.receiptForm.reset();

    // Now patch your defaults
    this.receiptForm.patchValue({
      ddlPaymentMode: 1,
      txtCashReceiptDate: this.formateDate(new Date()).dateTimeString
    });

    const totalamountreceived = Number(this.receiptList.reduce((sum, receipt) => sum + receipt.amountreceived, 0) ?? 0);
    const balanceamount = Number(this.totalCustomerCharges) - totalamountreceived;

    this.receiptForm.get('txtBalanceAmount')?.setValue(balanceamount);
  }

  vendorServiceChange(serviceChangeEvent?: any) {
    const serviceid = serviceChangeEvent?.id;
    this.awbForm.get('forwardinginfo').get('ddlDeliveryService').setValue(serviceid);
    this.awbForm.get('forwardinginfo').get('ddlDeliveryService').markAsDirty();
    this.vendorWeightInfo = this.serviceOptions.find((item) => item.id === serviceid)?.weightinfo;
    this.piecesForm.get('actualweightunit').setValue(this.vendorWeightInfo?.unit ?? 'KGS');
  };

  async bindDeliveryVendor() {
    const vendor = this.awbForm.get('ddlVendor')?.value;
    this.awbForm.get('forwardinginfo.ddlDeliveryVendor').setValue(vendor);
    this.awbForm.get('forwardinginfo.ddlDeliveryVendor').markAsDirty();
    await this.getAllVendorServices('forwardinginfo');
    if (this.deliveryServiceList?.length) {
      this.awbForm.get('forwardinginfo.ddlDeliveryService')?.setValue(this.deliveryServiceList[0]?.id);
    }
    if (this.serviceOptions?.length) {
      this.awbForm.get('ddlService')?.setValue(this.serviceOptions[0]?.id);
    }
  };

  validateActualWeight(totalactualweight: any) {
    if (totalactualweight == null || !this.vendorWeightInfo) {
      return null;
    }
    // Get min & max: If vendorWeightInfo does not have min/max, find from serviceOptions
    const { min, max } =
      this.vendorWeightInfo?.min !== undefined && this.vendorWeightInfo?.max !== undefined
        ? this.vendorWeightInfo
        : this.serviceOptions.find(
          (item) => item.id === this.awbForm.get('ddlService')?.value
        )?.weightinfo || {};

    if ((max && totalactualweight > max) || (min && totalactualweight < min)) {
      return `<b>Total actual weight</b> must be between <b>${min}</b> and <b>${max}</b>`;
    }

    return null;
  }

  bindProformaCsbDetails(type: string, data?: any) {
    if (type === 'customer') {
      const customerId = this.awbForm.get('ddlCustomer')?.value;
      const customerData: any = this.customerList.filter(x => x.id === customerId)[0]?.additionaldetails;
      this.proformaForm.get('csbDetails')?.patchValue({
        txtBankAdCode: customerData?.bankadcode,
        txtBankAccount: customerData?.bankaccount,
        txtBankIfsc: customerData?.bankifsc,
        txtLutBondNo: customerData?.lutbondno,
        ddlFirm: customerData?.firm,
        nfeiCheck: customerData?.nfei,
      })

    } else if (type === 'shipper') {
      const shipperData: any = data?.item?.additionaldetails ?? {};
      this.proformaForm.get('csbDetails')?.patchValue({
        txtBankAdCode: shipperData?.bankadcode,
        txtBankAccount: shipperData?.bankaccount,
        txtBankIfsc: shipperData?.bankifsc,
        txtLutBondNo: shipperData?.lutbondno,
        ddlFirm: shipperData?.firm,
        nfeiCheck: shipperData?.nfei,
      })
    }
  }

  CustomerVolumetricRequired() {
    //&& this.awbConfig.isCustomerLoginVolumetricRequiredOnNdox
    if (this.isAccessTypeCustomer && this.awbConfig.isVolumetricRequired) {
      if (!this.isDOXSelected) {
        this.containers.controls.map(container => {
          container.get('pieceslength').setValidators([Validators.required]);
          container.get('piecesbreadth').setValidators([Validators.required]);
          container.get('piecesheight').setValidators([Validators.required]);
          container.get('pieceslength').updateValueAndValidity();
          container.get('piecesbreadth').updateValueAndValidity();
          container.get('piecesheight').updateValueAndValidity();
        });
      }
      else {
        this.containers.controls.forEach(container => {
          container.get('pieceslength').clearValidators();
          container.get('piecesbreadth').clearValidators();
          container.get('piecesheight').clearValidators();
        });
      }
    }
  };

  sanitizeId(name: string): string {
    return name ? 'chk_' + name.replace(/\s+/g, '_') : 'chk_unknown';
  };

  focusConsignee() {
    const shipperControl = this.awbForm.get('shipperlocationdetails.txtName');
    // Emit an event to the child component
    if (shipperControl?.valid && shipperControl.value !== 'string') {
      this.focusConsigneeName = true;
    }
  }

  focusSubmitBtn() {
    setTimeout(() => {
      this.submitBtn.nativeElement.focus();
    }, 200);
  }

  getCheckedStatus(fieldKey: string): boolean {
    return this.awbFocusCheckMap?.find(item => item.key === fieldKey)?.value ?? false;
  }

  toggleFieldCheck(fieldKey: string, isChecked: boolean) {
    const field = this.awbFocusCheckMap?.find(item => item.key === fieldKey);
    if (field) {
      field.value = isChecked;
    }
  }

  focusNextField(currentField?: string) {
    // If no currentField is provided, find the smallest `no` field with `value: true`
    let nextField;

    if (!currentField) {
      nextField = this.awbFocusCheckMap?.reduce((min, item) =>
        item.value && (!min || item.no < min.no) ? item : min, null);
    } else {
      // Find the current field based on `no`
      const currentItem = this.awbFocusCheckMap?.find(item => item.key === currentField);
      if (!currentItem) return; // If not found, exit

      const currentNo = currentItem.no;

      // Find the next field with the smallest `no` that has `value: true`
      nextField = this.awbFocusCheckMap?.find(item => item.no > currentNo && item.value);
    }

    if (nextField) {
      if (nextField.key === 'appShipperAddress') {
        this.appShipperAddress.focusFirstField();
        return;
      } else if (nextField.key === 'appConsigneeAddress') {
        this.appConsigneeAddress.focusFirstField();
        return;
      } else if (nextField.key === 'piecesActualWeightInputs') {
        this.focusFirstActualWeight();
        return;
      }

      setTimeout(() => {
        const field = this.fields.find(el =>
          (el instanceof NgSelectComponent && el.element.id === nextField.key) ||
          (el instanceof ElementRef && el.nativeElement.id === nextField.key)
        );

        if (field instanceof NgSelectComponent) {
          if (!field.disabled) {
            field.focus();
          } else {
            this.focusNextField(nextField.key); // Skip disabled field
          }
        } else if (field instanceof ElementRef) {
          if (!field.nativeElement.disabled) {
            field.nativeElement.focus();
          } else {
            this.focusNextField(nextField.key); // Skip disabled field
          }
        } else {
          this.focusNextField(nextField.key); // Continue to the next field if not found
        }
      });
    }
  }

  async toggleFocusMode(e: any) {
    if (e.target.checked) {
      this.focusCheckHide = false;
    } else {
      this.focusCheckHide = true;

      // Compare awbFocusCheckMap and awbAddressFocusCheckMap with their original versions
      const resAwbFocusCheckMap = this.appCoreService.GetUserData().metaInfo.userconfig.awbfocuscheckmap;
      const resAwbAddressFocusCheckMap = this.appCoreService.GetUserData().metaInfo.userconfig.awbaddressfocuscheckmap;

      const isAwbFocusChanged = this.awbFocusCheckMap?.length && this.awbFocusCheckMap.some(item => {
        const originalItem = resAwbFocusCheckMap?.find(resItem => resItem.key === item.key);
        return originalItem ? originalItem.value !== item.value : true;
      });

      const isAwbAddressFocusChanged = this.awbAddressFocusCheckMap?.length && this.awbAddressFocusCheckMap.some(item => {
        const originalItem = resAwbAddressFocusCheckMap.find(resItem => resItem.key === item.key);
        return originalItem ? originalItem.value !== item.value : true;
      });

      // If any changes are detected
      if (isAwbFocusChanged || isAwbAddressFocusChanged) {
        const confirmed = await this.openConfirmationDialog('Do you want to save this Focus config?');

        if (confirmed) {
          this.ngxLoaderService.start();

          try {
            const res = await lastValueFrom(
              this.configService.updateFocusConfig({ awbfocuscheckmap: this.awbFocusCheckMap, awbaddressfocuscheckmap: this.awbAddressFocusCheckMap })
            );

            this.ngxLoaderService.stop();

            if (res?.success) {
              this.appCoreService.showMessage('Config saved successfully');
              const userconfig = {
                awbfocuscheckmap: this.awbFocusCheckMap,
                awbaddressfocuscheckmap: this.awbAddressFocusCheckMap
              };
              this.appCoreService.setFocusConfig(userconfig);
              setTimeout(() => {
                this.focusNextField();
              }, 200);
            }
          } catch (error) {
            this.ngxLoaderService.stop();
            console.error('Error updating config:', error);
          }
        } else {
          // Reset both maps if changes are not confirmed
          this.awbFocusCheckMap = resAwbFocusCheckMap;
          this.awbAddressFocusCheckMap = resAwbAddressFocusCheckMap;
        }
      } else {
        // Reset both maps if changes are not confirmed
        this.awbFocusCheckMap = resAwbFocusCheckMap;
        this.awbAddressFocusCheckMap = resAwbAddressFocusCheckMap;
      }
    }
  };

  updateAddressCheck(e: any) {
    this.awbAddressFocusCheckMap = e;
  }

};